var $75d4fa33b7b16b97$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(c) {
                                return n(r, t, e, u, a, c);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(c) {
                                return function(i) {
                                    return n(r, t, e, u, a, c, i);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(c) {
                                return function(i) {
                                    return function(o) {
                                        return n(r, t, e, u, a, c, i, o);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(n) {
        return r(9, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(c) {
                                return function(i) {
                                    return function(o) {
                                        return function(f) {
                                            return n(r, t, e, u, a, c, i, o, f);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, c) {
        return 6 === n.a ? n.f(r, t, e, u, a, c) : n(r)(t)(e)(u)(a)(c);
    }
    function A7(n, r, t, e, u, a, c, i) {
        return 7 === n.a ? n.f(r, t, e, u, a, c, i) : n(r)(t)(e)(u)(a)(c)(i);
    }
    function A8(n, r, t, e, u, a, c, i, o) {
        return 8 === n.a ? n.f(r, t, e, u, a, c, i, o) : n(r)(t)(e)(u)(a)(c)(i)(o);
    }
    function A9(n, r, t, e, u, a, c, i, o, f) {
        return 9 === n.a ? n.f(r, t, e, u, a, c, i, o, f) : n(r)(t)(e)(u)(a)(c)(i)(o)(f);
    }
    function t(n, r) {
        for(var t, u = [], a = e(n, r, 0, u); a && (t = u.pop()); a = e(t.a, t.b, 0, u));
        return a;
    }
    function e(n, r, t, u) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && W(5), !1;
        if (t > 100) return u.push(o(n, r)), !0;
        for(var a in 0 > n.$ && (n = mt(n), r = mt(r)), n)if (!e(n[a], r[a], t + 1, u)) return !1;
        return !0;
    }
    var u = F2(t);
    function a(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = a(n.a, r.a)) || (t = a(n.b, r.b)) ? t : a(n.c, r.c);
        for(; n.b && r.b && !(t = a(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var c = F2(function(n, r) {
        var t = a(n, r);
        return 0 > t ? qt : t ? ht : pt;
    }), i = 0;
    function o(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function f(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function s(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    var b = F2(d);
    function d(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = v(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = v(n.a, r);
        return t;
    }
    var l = {
        $: 0
    };
    function v(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var p = F2(v);
    function h(n) {
        for(var r = l, t = n.length; t--;)r = v(n[t], r);
        return r;
    }
    function q(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var y = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return h(e);
    }), U = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), m = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, o(t, r);
    });
    function W(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var V = F2(function(n, r) {
        return n + r;
    }), T = F2(function(n, r) {
        return n - r;
    }), K = F2(function(n, r) {
        return n * r;
    }), k = F2(Math.pow), O = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? W(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), z = Math.PI, D = Math.cos, Z = Math.sin, H = Math.tan, Q = F2(Math.atan2), P = Math.ceil, M = Math.floor, S = Math.round, L = Math.sqrt, R = Math.log, x = isNaN, I = F2(function(n, r) {
        return n + r;
    }), F = F2(function(n, r) {
        return n + r;
    }), w = F3(function(n, r, t) {
        for(var e = t.length, u = 0; e > u;){
            var a = t[u], c = t.charCodeAt(u);
            u++, 55296 > c || c > 56319 || (a += t[u], u++), r = A2(n, a, r);
        }
        return r;
    }), N = F3(function(n, r, t) {
        for(var e = t.length; e--;){
            var u = t[e], a = t.charCodeAt(e);
            56320 > a || a > 57343 || (u = t[--e] + u), r = A2(n, u, r);
        }
        return r;
    }), X = F2(function(n, r) {
        return r.split(n);
    }), $ = F2(function(n, r) {
        return r.join(n);
    }), Y = F3(function(n, r, t) {
        return t.slice(n, r);
    }), g = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), j = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), J = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return l;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return h(u);
    });
    function E(n) {
        return n + "";
    }
    function A(n) {
        return {
            $: 2,
            b: n
        };
    }
    var G = A(function(n) {
        return "number" != typeof n ? pn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? kt(n) : !isFinite(n) || n % 1 ? pn("an INT", n) : kt(n);
    }), C = A(function(n) {
        return "boolean" == typeof n ? kt(n) : pn("a BOOL", n);
    }), B = A(function(n) {
        return "number" == typeof n ? kt(n) : pn("a FLOAT", n);
    }), _ = A(function(n) {
        return kt(n);
    }), nn = A(function(n) {
        return "string" == typeof n ? kt(n) : n instanceof String ? kt(n + "") : pn("a STRING", n);
    }), rn = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function tn(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var en = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), un = F2(function(n, r) {
        return tn(n, [
            r
        ]);
    }), an = F3(function(n, r, t) {
        return tn(n, [
            r,
            t
        ]);
    }), cn = F4(function(n, r, t, e) {
        return tn(n, [
            r,
            t,
            e
        ]);
    }), on = F5(function(n, r, t, e, u) {
        return tn(n, [
            r,
            t,
            e,
            u
        ]);
    }), fn = F2(function(n, r) {
        try {
            return bn(n, JSON.parse(r));
        } catch (n) {
            return Wt(A2(Vt, "This is not valid JSON! " + n.message, r));
        }
    }), sn = F2(function(n, r) {
        return bn(n, r);
    });
    function bn(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? kt(n.c) : pn("null", r);
            case 3:
                return ln(r) ? dn(n.b, r, h) : pn("a LIST", r);
            case 4:
                return ln(r) ? dn(n.b, r, vn) : pn("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return pn("an OBJECT with a field named `" + t + "`", r);
                var e = bn(n.b, r[t]);
                return be(e) ? e : Wt(A2(Tt, t, e.a));
            case 7:
                var u = n.e;
                return ln(r) ? r.length > u ? (e = bn(n.b, r[u]), be(e) ? e : Wt(A2(Kt, u, e.a))) : pn("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : pn("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || ln(r)) return pn("an OBJECT", r);
                var a = l;
                for(var c in r)if (r.hasOwnProperty(c)) {
                    if (e = bn(n.b, r[c]), !be(e)) return Wt(A2(Tt, c, e.a));
                    a = v(o(c, e.a), a);
                }
                return kt($t(a));
            case 9:
                for(var i = n.f, f = n.g, s = 0; f.length > s; s++){
                    if (e = bn(f[s], r), !be(e)) return e;
                    i = i(e.a);
                }
                return kt(i);
            case 10:
                return e = bn(n.b, r), be(e) ? bn(n.h(e.a), r) : e;
            case 11:
                for(var b = l, d = n.g; d.b; d = d.b){
                    if (e = bn(d.a, r), be(e)) return e;
                    b = v(e.a, b);
                }
                return Wt(Ot($t(b)));
            case 1:
                return Wt(A2(Vt, n.a, r));
            case 0:
                return kt(n.a);
        }
    }
    function dn(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var c = bn(n, r[a]);
            if (!be(c)) return Wt(A2(Kt, a, c.a));
            u[a] = c.a;
        }
        return kt(t(u));
    }
    function ln(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function vn(n) {
        return A2(se, n.length, function(r) {
            return n[r];
        });
    }
    function pn(n, r) {
        return Wt(A2(Vt, "Expecting " + n, r));
    }
    function hn(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return hn(n.b, r.b);
            case 6:
                return n.d === r.d && hn(n.b, r.b);
            case 7:
                return n.e === r.e && hn(n.b, r.b);
            case 9:
                return n.f === r.f && qn(n.g, r.g);
            case 10:
                return n.h === r.h && hn(n.b, r.b);
            case 11:
                return qn(n.g, r.g);
        }
    }
    function qn(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!hn(n[e], r[e])) return !1;
        return !0;
    }
    var yn = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function Un(n) {
        return n;
    }
    var mn = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function Wn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function Vn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var Tn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), Kn = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), kn = 0;
    function On(n) {
        var r = {
            $: 0,
            e: kn++,
            f: n,
            g: null,
            h: []
        };
        return Pn(r), r;
    }
    function zn(n) {
        return Vn(function(r) {
            r(Wn(On(n)));
        });
    }
    function Dn(n, r) {
        n.h.push(r), Pn(n);
    }
    var Zn = F2(function(n, r) {
        return Vn(function(t) {
            Dn(n, r), t(Wn(i));
        });
    }), Hn = !1, Qn = [];
    function Pn(n) {
        if (Qn.push(n), !Hn) {
            for(Hn = !0; n = Qn.shift();)Mn(n);
            Hn = !1;
        }
    }
    function Mn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, Pn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    function Sn(n) {
        return Vn(function(r) {
            var t = setTimeout(function() {
                r(Wn(i));
            }, n);
            return function() {
                clearTimeout(t);
            };
        });
    }
    var Ln = {};
    function Rn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function xn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, c = n.f;
        function i(n) {
            return A2(Tn, i, {
                $: 5,
                b: function(r) {
                    var i = r.a;
                    return 0 === r.$ ? A3(u, t, i, n) : a && c ? A4(e, t, i.i, i.j, n) : A3(e, t, a ? i.i : i.j, n);
                }
            });
        }
        return t.h = On(A2(Tn, i, n.b));
    }
    var In = F2(function(n, r) {
        return Vn(function(t) {
            n.g(r), t(Wn(i));
        });
    }), Fn = F2(function(n, r) {
        return A2(Zn, n.h, {
            $: 0,
            a: r
        });
    });
    function wn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function Nn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Xn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), $n = [], Yn = !1;
    function gn(n, r, t) {
        if ($n.push({
            p: n,
            q: r,
            r: t
        }), !Yn) {
            Yn = !0;
            for(var e; e = $n.shift();)jn(e.p, e.q, e.r);
            Yn = !1;
        }
    }
    function jn(n, r, t) {
        var e = {};
        for(var u in Jn(!0, r, e, null), Jn(!1, t, e, null), n)Dn(n[u], {
            $: "fx",
            a: e[u] || {
                i: l,
                j: l
            }
        });
    }
    function Jn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? Ln[r].e : Ln[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: l,
                        j: l
                    }, n ? t.i = v(r, t.i) : t.j = v(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var c = r.m; c.b; c = c.b)Jn(n, c.a, t, e);
                return;
            case 3:
                return void Jn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    function En(n) {
        Ln[n] && W(3);
    }
    function An(n, r) {
        return En(n), Ln[n] = {
            e: Gn,
            u: r,
            a: Cn
        }, wn(n);
    }
    var Gn = F2(function(n, r) {
        return r;
    });
    function Cn(n) {
        var r = [], t = Ln[n].u, e = Sn(0);
        return Ln[n].b = e, Ln[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = r, c = t(u.a), i = 0; a.length > i; i++)a[i](c);
            return e;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var t = (r = r.slice()).indexOf(n);
                0 > t || r.splice(t, 1);
            }
        };
    }
    function Bn(n, r) {
        return En(n), Ln[n] = {
            f: nr,
            u: r,
            a: rr
        }, wn(n);
    }
    var _n, nr = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    function rr(n, r) {
        var t = l, e = Ln[n].u, u = Wn(null);
        return Ln[n].b = u, Ln[n].c = F3(function(n, r) {
            return t = r, u;
        }), {
            send: function(n) {
                var u = A2(sn, e, n);
                be(u) || W(4);
                for(var a = u.a, c = t; c.b; c = c.b)r(c.a(a));
            }
        };
    }
    var tr = "undefined" != typeof document ? document : {};
    function er(n, r) {
        n.appendChild(r);
    }
    function ur(n) {
        return {
            $: 0,
            a: n
        };
    }
    var ar = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var c = e.a;
                a += c.b || 0, u.push(c);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: zr(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), cr = ar(void 0), ir = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var c = e.a;
                a += c.b.b || 0, u.push(c);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: zr(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), or = ir(void 0), fr = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    });
    function sr(n, r) {
        return {
            $: 5,
            l: n,
            m: r,
            k: void 0
        };
    }
    var br = F3(function(n, r, t) {
        return sr([
            n,
            r,
            t
        ], function() {
            return A2(n, r, t);
        });
    }), dr = F4(function(n, r, t, e) {
        return sr([
            n,
            r,
            t,
            e
        ], function() {
            return A3(n, r, t, e);
        });
    }), lr = F5(function(n, r, t, e, u) {
        return sr([
            n,
            r,
            t,
            e,
            u
        ], function() {
            return A4(n, r, t, e, u);
        });
    }), vr = F6(function(n, r, t, e, u, a) {
        return sr([
            n,
            r,
            t,
            e,
            u,
            a
        ], function() {
            return A5(n, r, t, e, u, a);
        });
    }), pr = F7(function(n, r, t, e, u, a, c) {
        return sr([
            n,
            r,
            t,
            e,
            u,
            a,
            c
        ], function() {
            return A6(n, r, t, e, u, a, c);
        });
    }), hr = F8(function(n, r, t, e, u, a, c, i) {
        return sr([
            n,
            r,
            t,
            e,
            u,
            a,
            c,
            i
        ], function() {
            return A7(n, r, t, e, u, a, c, i);
        });
    }), qr = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), yr = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), Ur = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), mr = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function Wr(n) {
        return "script" == n ? "p" : n;
    }
    function Vr(n) {
        return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
    }
    var Tr, Kr = F2(function(n, r) {
        return "a0" === r.$ ? A2(qr, r.n, function(n, r) {
            var t = pe(r);
            return {
                $: r.$,
                a: t ? A3(le, 3 > t ? kr : Or, ve(n), r.a) : A2(de, n, r.a)
            };
        }(n, r.o)) : r;
    }), kr = F2(function(n, r) {
        return o(n(r.a), r.b);
    }), Or = F2(function(n, r) {
        return {
            ag: n(r.ag),
            cn: r.cn,
            ck: r.ck
        };
    });
    function zr(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var c = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? Dr(c, u, a) : c[u] = a;
            } else "className" === u ? Dr(r, u, a) : r[u] = a;
        }
        return r;
    }
    function Dr(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Zr(n, r) {
        var t = n.$;
        if (5 === t) return Zr(n.k || (n.k = n.m()), r);
        if (0 === t) return tr.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (c = Zr(e, a)).elm_event_node_ref = a, c;
        }
        if (3 === t) return Hr(c = n.h(n.g), r, n.d), c;
        var c = n.f ? tr.createElementNS(n.f, n.c) : tr.createElement(n.c);
        _n && "a" == n.c && c.addEventListener("click", _n(c)), Hr(c, r, n.d);
        for(var i = n.e, o = 0; i.length > o; o++)er(c, Zr(1 === t ? i[o] : i[o].b, r));
        return c;
    }
    function Hr(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Qr(n, u) : "a0" === e ? Sr(n, r, u) : "a3" === e ? Pr(n, u) : "a4" === e ? Mr(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function Qr(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Pr(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Mr(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function Sr(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], c = e[u];
            if (a) {
                if (c) {
                    if (c.q.$ === a.$) {
                        c.q = a;
                        continue;
                    }
                    n.removeEventListener(u, c);
                }
                c = Lr(r, a), n.addEventListener(u, c, Tr && {
                    passive: 2 > pe(a)
                }), e[u] = c;
            } else n.removeEventListener(u, c), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Tr = !0;
            }
        }));
    } catch (n) {}
    function Lr(n, r) {
        function t(r) {
            var e = t.q, u = bn(e.a, r);
            if (be(u)) {
                for(var a, c = pe(e), i = u.a, o = c ? 3 > c ? i.a : i.ag : i, f = 1 == c ? i.b : 3 == c && i.cn, s = (f && r.stopPropagation(), (2 == c ? i.b : 3 == c && i.ck) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) o = a(o);
                    else for(var b = a.length; b--;)o = a[b](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return t.q = r, t;
    }
    function Rr(n, r) {
        return n.$ == r.$ && hn(n.a, r.a);
    }
    function xr(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Ir(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void xr(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var c = n.l, i = r.l, o = c.length, f = o === i.length; f && o--;)f = c[o] === i[o];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Ir(n.k, r.k, s, 0), void (s.length > 0 && xr(t, 1, e, s));
                case 4:
                    for(var b = n.j, d = r.j, l = !1, v = n.k; 4 === v.$;)l = !0, "object" != typeof b ? b = [
                        b,
                        v.j
                    ] : b.push(v.j), v = v.k;
                    for(var p = r.k; 4 === p.$;)l = !0, "object" != typeof d ? d = [
                        d,
                        p.j
                    ] : d.push(p.j), p = p.k;
                    return l && b.length !== d.length ? void xr(t, 0, e, r) : ((l ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(b, d) : b === d) || xr(t, 2, e, d), void Ir(v, p, t, e + 1));
                case 0:
                    return void (n.a !== r.a && xr(t, 3, e, r.a));
                case 1:
                    return void Fr(n, r, t, e, Nr);
                case 2:
                    return void Fr(n, r, t, e, Xr);
                case 3:
                    if (n.h !== r.h) return void xr(t, 0, e, r);
                    var h = wr(n.d, r.d);
                    h && xr(t, 4, e, h);
                    var q = r.i(n.g, r.g);
                    return void (q && xr(t, 5, e, q));
            }
        }
    }
    function Fr(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = wr(n.d, r.d);
            a && xr(t, 4, e, a), u(n, r, t, e);
        } else xr(t, 0, e, r);
    }
    function wr(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], c = r[u];
                a === c && "value" !== u && "checked" !== u || "a0" === t && Rr(a, c) || ((e = e || {})[u] = c);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var i = wr(n[u], r[u] || {}, u);
            i && ((e = e || {})[u] = i);
        }
        for(var o in r)o in n || ((e = e || {})[o] = r[o]);
        return e;
    }
    function Nr(n, r, t, e) {
        var u = n.e, a = r.e, c = u.length, i = a.length;
        c > i ? xr(t, 6, e, {
            v: i,
            i: c - i
        }) : i > c && xr(t, 7, e, {
            v: c,
            e: a
        });
        for(var o = i > c ? c : i, f = 0; o > f; f++){
            var s = u[f];
            Ir(s, a[f], t, ++e), e += s.b || 0;
        }
    }
    function Xr(n, r, t, e) {
        for(var u = [], a = {}, c = [], i = n.e, o = r.e, f = i.length, s = o.length, b = 0, d = 0, l = e; f > b && s > d;){
            var v = (O = i[b]).a, p = (z = o[d]).a, h = O.b, q = z.b, y = void 0, U = void 0;
            if (v !== p) {
                var m = i[b + 1], W = o[d + 1];
                if (m) {
                    var V = m.a, T = m.b;
                    U = p === V;
                }
                if (W) {
                    var K = W.a, k = W.b;
                    y = v === K;
                }
                if (y && U) Ir(h, k, u, ++l), Yr(a, u, v, q, d, c), l += h.b || 0, gr(a, u, v, T, ++l), l += T.b || 0, b += 2, d += 2;
                else if (y) l++, Yr(a, u, p, q, d, c), Ir(h, k, u, l), l += h.b || 0, b += 1, d += 2;
                else if (U) gr(a, u, v, h, ++l), l += h.b || 0, Ir(T, q, u, ++l), l += T.b || 0, b += 2, d += 1;
                else {
                    if (!m || V !== K) break;
                    gr(a, u, v, h, ++l), Yr(a, u, p, q, d, c), l += h.b || 0, Ir(T, k, u, ++l), l += T.b || 0, b += 2, d += 2;
                }
            } else Ir(h, q, u, ++l), l += h.b || 0, b++, d++;
        }
        for(; f > b;){
            var O;
            l++, gr(a, u, (O = i[b]).a, h = O.b, l), l += h.b || 0, b++;
        }
        for(; s > d;){
            var z, D = D || [];
            Yr(a, u, (z = o[d]).a, z.b, void 0, D), d++;
        }
        (u.length > 0 || c.length > 0 || D) && xr(t, 8, e, {
            w: u,
            x: c,
            y: D
        });
    }
    var $r = "_elmW6BL";
    function Yr(n, r, t, e, u, a) {
        var c = n[t];
        if (!c) return a.push({
            r: u,
            A: c = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = c);
        if (1 === c.c) {
            a.push({
                r: u,
                A: c
            }), c.c = 2;
            var i = [];
            return Ir(c.z, e, i, c.r), c.r = u, void (c.s.s = {
                w: i,
                A: c
            });
        }
        Yr(n, r, t + $r, e, u, a);
    }
    function gr(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var c = [];
                return Ir(e, a.z, c, u), void xr(r, 9, u, {
                    w: c,
                    A: a
                });
            }
            gr(n, r, t + $r, e, u);
        } else {
            var i = xr(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: i
            };
        }
    }
    function jr(n, r, t, e) {
        Jr(n, r, t, 0, 0, r.b, e);
    }
    function Jr(n, r, t, e, u, a, c) {
        for(var i = t[e], o = i.r; o === u;){
            var f = i.$;
            if (1 === f) jr(n, r.k, i.s, c);
            else if (8 === f) i.t = n, i.u = c, (s = i.s.w).length > 0 && Jr(n, r, s, 0, u, a, c);
            else if (9 === f) {
                i.t = n, i.u = c;
                var s, b = i.s;
                b && (b.A.s = n, (s = b.w).length > 0 && Jr(n, r, s, 0, u, a, c));
            } else i.t = n, i.u = c;
            if (!(i = t[++e]) || (o = i.r) > a) return e;
        }
        var d = r.$;
        if (4 === d) {
            for(var l = r.k; 4 === l.$;)l = l.k;
            return Jr(n, l, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var v = r.e, p = n.childNodes, h = 0; v.length > h; h++){
            u++;
            var q = 1 === d ? v[h] : v[h].b, y = u + (q.b || 0);
            if (!(u > o || o > y || (i = t[e = Jr(p[h], q, t, e, u, y, c)]) && (o = i.r) <= a)) return e;
            u = y;
        }
        return e;
    }
    function Er(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = Ar(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function Ar(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Zr(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Hr(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Er(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, a = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(Zr(u[e], r.u), a);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var c = t.A;
                return void 0 !== c.r && n.parentNode.removeChild(n), c.s = Er(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = tr.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                er(t, 2 === u.c ? u.s : Zr(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Er(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var c = u[a], i = c.A, o = 2 === i.c ? i.s : Zr(i.z, r.u);
                        n.insertBefore(o, n.childNodes[c.r]);
                    }
                    return e && er(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                W(10);
        }
    }
    function Gr(n) {
        if (3 === n.nodeType) return ur(n.textContent);
        if (1 !== n.nodeType) return ur("");
        for(var r = l, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = v(A2(mr, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), c = l, i = n.childNodes;
        for(e = i.length; e--;)c = v(Gr(i[e]), c);
        return A3(cr, a, r, c);
    }
    var Cr = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, a) {
            var c = A2(sn, n, r ? r.flags : void 0);
            be(c) || W(2);
            var i = {}, o = t(c.a), f = o.a, s = a(d, f), b = function(n, r) {
                var t;
                for(var e in Ln){
                    var u = Ln[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = xn(u, r);
                }
                return t;
            }(i, d);
            function d(n, r) {
                var t = A2(e, n, f);
                s(f = t.a, r), gn(i, t.b, u(f));
            }
            return gn(i, o.b, u(f)), b ? {
                ports: b
            } : {};
        }(r, e, n.et, n.e8, n.e3, function(r, t) {
            var e = n.cm && n.cm(r), u = n.fc, a = tr.title, c = tr.body, i = Gr(c);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (_r(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && _r(e), t = 2);
                };
            }(t, function(n) {
                _n = e;
                var t = u(n), o = cr("body")(l)(t.cE), f = function(n, r) {
                    var t = [];
                    return Ir(n, r, t, 0), t;
                }(i, o);
                c = function(n, r, t, e) {
                    return 0 === t.length ? n : (jr(n, r, t, e), Er(n, t));
                }(c, i, f, r), i = o, _n = 0, a !== t.dF && (tr.title = a = t.dF);
            });
        });
    }), Br = "undefined" != typeof cancelAnimationFrame ? cancelAnimationFrame : function(n) {
        clearTimeout(n);
    }, _r = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    };
    function nt() {
        return Qe(tr.location.href).a || W(1);
    }
    var rt = F2(function(n, r) {
        return A2(ru, Pe, Vn(function() {
            history.pushState({}, "", r), n();
        }));
    }), tt = F2(function(n, r) {
        return A2(ru, Pe, Vn(function() {
            history.replaceState({}, "", r), n();
        }));
    }), et = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, ut = "undefined" != typeof document ? document : et, at = "undefined" != typeof window ? window : et, ct = F3(function(n, r, t) {
        return zn(Vn(function() {
            function e(n) {
                On(t(n));
            }
            return n.addEventListener(r, e, Tr && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), it = F2(function(n, r) {
        var t = bn(n, r);
        return be(t) ? Dt(t.a) : Zt;
    });
    function ot(n, r) {
        return Vn(function(t) {
            _r(function() {
                var e = document.getElementById(n);
                t(e ? Wn(r(e)) : {
                    $: 1,
                    a: qe(n)
                });
            });
        });
    }
    var ft = F2(function(n, r) {
        return ot(r, function(r) {
            return r[n](), i;
        });
    });
    var st, bt = F2(function(n, r) {
        return Vn(function() {
            var t = setInterval(function() {
                On(r);
            }, n);
            return function() {
                clearInterval(t);
            };
        });
    });
    A(function(n) {
        return "undefined" != typeof File && n instanceof File ? kt(n) : pn("a FILE", n);
    });
    var dt, lt = F3(function(n, r, t) {
        return Vn(function() {
            var e = new Blob([
                t
            ], {
                type: r
            });
            if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(e, n);
            else {
                var u = st || (st = document.createElement("a")), a = URL.createObjectURL(e);
                u.href = a, u.download = n, vt(u), URL.revokeObjectURL(a);
            }
        });
    });
    function vt(n) {
        if ("function" == typeof MouseEvent) n.dispatchEvent(new MouseEvent("click"));
        else {
            var r = document.createEvent("MouseEvents");
            r.initMouseEvent("click", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), document.body.appendChild(n), n.dispatchEvent(r), document.body.removeChild(n);
        }
    }
    var pt = 1, ht = 2, qt = 0, yt = p, Ut = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(Ut, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), mt = function(n) {
        return A3(Ut, F3(function(n, r, t) {
            return A2(yt, o(n, r), t);
        }), l, n);
    }, Wt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vt = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Tt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Kt = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), kt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ot = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zt = V, Dt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Zt = {
        $: 1
    }, Ht = b, Qt = yn, Pt = E, Mt = F2(function(n, r) {
        return A2($, n, q(r));
    }), St = F2(function(n, r) {
        return h(A2(X, n, r));
    }), Lt = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), Rt = function(n) {
        return A3(Lt, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, xt = y, It = T, Ft = F3(function(n, r, t) {
        for(;;){
            if (a(n, r) >= 1) return t;
            var e = n, u = r - 1, c = A2(yt, r, t);
            n = e, r = u, t = c;
        }
    }), wt = F2(function(n, r) {
        return A3(Ft, n, r, l);
    }), Nt = F2(function(n, r) {
        return A3(xt, n, A2(wt, 0, Rt(r) - 1), r);
    }), Xt = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, $t = function(n) {
        return A3(Lt, yt, l, n);
    }, Yt = 32, gt = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), jt = [], Jt = P, Et = F2(function(n, r) {
        return R(r) / R(n);
    }), At = Jt(A2(Et, 2, Yt)), Gt = A4(gt, 0, At, jt, jt), Ct = U, Bt = F2(function(n, r) {
        return r(n);
    }), _t = u, ne = M, re = function(n) {
        return n.length;
    }, te = F2(function(n, r) {
        return a(n, r) > 0 ? n : r;
    }), ee = K, ue = m, ae = F2(function(n, r) {
        for(;;){
            var t = A2(ue, Yt, n), e = t.b, u = A2(yt, {
                $: 0,
                a: t.a
            }, r);
            if (!e.b) return $t(u);
            n = e, r = u;
        }
    }), ce = function(n) {
        return n.a;
    }, ie = F2(function(n, r) {
        for(;;){
            var t = Jt(r / Yt);
            if (1 === t) return A2(ue, Yt, n).a;
            n = A2(ae, n, l), r = t;
        }
    }), oe = F2(function(n, r) {
        if (r.m) {
            var t = r.m * Yt, e = ne(A2(Et, Yt, t - 1)), u = n ? $t(r.r) : r.r, a = A2(ie, u, r.m);
            return A4(gt, re(r.p) + t, A2(te, 5, e * At), a, r.p);
        }
        return A4(gt, re(r.p), At, jt, r.p);
    }), fe = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(oe, !1, {
                r: e,
                m: t / Yt | 0,
                p: u
            });
            var a = {
                $: 1,
                a: A3(Ct, Yt, r, n)
            };
            r -= Yt, e = A2(yt, a, e);
        }
    }), se = F2(function(n, r) {
        if (n > 0) {
            var t = n % Yt;
            return A5(fe, r, n - t - Yt, n, l, A3(Ct, t, n - t, r));
        }
        return Gt;
    }), be = function(n) {
        return !n.$;
    }, de = un, le = an, ve = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pe = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, he = function(n) {
        return n;
    }, qe = he, ye = F6(function(n, r, t, e, u, a) {
        return {
            cU: a,
            eo: r,
            ai: e,
            eV: t,
            eW: n,
            dh: u
        };
    }), Ue = g, me = function(n) {
        return n.length;
    }, We = Y, Ve = F2(function(n, r) {
        return 1 > n ? r : A3(We, n, me(r), r);
    }), Te = J, Ke = function(n) {
        return "" === n;
    }, ke = F2(function(n, r) {
        return 1 > n ? "" : A3(We, 0, n, r);
    }), Oe = F5(function(n, r, t, e, u) {
        if (Ke(u) || A2(Ue, "@", u)) return Zt;
        var a = A2(Te, ":", u);
        if (a.b) {
            if (a.b.b) return Zt;
            var c = a.a, i = function(n) {
                for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
                    var a = n.charCodeAt(u);
                    if (48 > a || a > 57) return Zt;
                    r = 10 * r + a - 48;
                }
                return u == e ? Zt : Dt(45 == t ? -r : r);
            }(A2(Ve, c + 1, u));
            if (1 === i.$) return Zt;
            var o = i;
            return Dt(A6(ye, n, A2(ke, c, u), o, r, t, e));
        }
        return Dt(A6(ye, n, u, Zt, r, t, e));
    }), ze = F4(function(n, r, t, e) {
        if (Ke(e)) return Zt;
        var u = A2(Te, "/", e);
        if (u.b) {
            var a = u.a;
            return A5(Oe, n, A2(Ve, a, e), r, t, A2(ke, a, e));
        }
        return A5(Oe, n, "/", r, t, e);
    }), De = F3(function(n, r, t) {
        if (Ke(t)) return Zt;
        var e = A2(Te, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(ze, n, Dt(A2(Ve, u + 1, t)), r, A2(ke, u, t));
        }
        return A4(ze, n, Zt, r, t);
    }), Ze = F2(function(n, r) {
        if (Ke(r)) return Zt;
        var t = A2(Te, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(De, n, Dt(A2(Ve, e + 1, r)), A2(ke, e, r));
        }
        return A3(De, n, Zt, r);
    }), He = j, Qe = function(n) {
        return A2(He, "http://", n) ? A2(Ze, 0, A2(Ve, 7, n)) : A2(He, "https://", n) ? A2(Ze, 1, A2(Ve, 8, n)) : Zt;
    }, Pe = function() {
        for(;;);
    }, Me = Wn, Se = Me(0), Le = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var c = a.a, i = a.b;
                if (i.b) {
                    var o = i.a, f = i.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, c, A2(n, o, A2(n, f.a, t > 500 ? A3(Lt, n, r, $t(s)) : A4(Le, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, c, A2(n, o, r)));
                }
                return A2(n, u, A2(n, c, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Re = F3(function(n, r, t) {
        return A4(Le, n, r, 0, t);
    }), xe = F2(function(n, r) {
        return A3(Re, F2(function(r, t) {
            return A2(yt, n(r), t);
        }), l, r);
    }), Ie = Tn, Fe = F2(function(n, r) {
        return A2(Ie, function(r) {
            return Me(n(r));
        }, r);
    }), we = F3(function(n, r, t) {
        return A2(Ie, function(r) {
            return A2(Ie, function(t) {
                return Me(A2(n, r, t));
            }, t);
        }, r);
    }), Ne = function(n) {
        return A3(Re, we(yt), Me(l), n);
    }, Xe = In, $e = F2(function(n, r) {
        var t = r;
        return zn(A2(Ie, Xe(n), t));
    });
    Ln.Task = Rn(Se, F3(function(n, r) {
        return A2(Fe, function() {
            return 0;
        }, Ne(A2(xe, $e(n), r)));
    }), F3(function() {
        return Me(0);
    }), F2(function(n, r) {
        return A2(Fe, n, r);
    }));
    var Ye, ge, je, Je, Ee, Ae, Ge, Ce, Be, _e, nu = wn("Task"), ru = F2(function(n, r) {
        return nu(A2(Fe, n, r));
    }), tu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, eu = function(n) {
        return {
            $: 4,
            a: n
        };
    }, uu = Nn, au = sn, cu = le(Bt), iu = F9(function(n, r, t, e, u, a, c, i, o) {
        return {
            cz: e,
            d1: n,
            d4: o,
            dq: i,
            dy: u,
            dz: a,
            dC: t,
            dK: c,
            e7: r
        };
    }), ou = nn, fu = function(n) {
        return {
            $: 4,
            a: n
        };
    }, su = {
        $: 0
    }, bu = {
        $: 2
    }, du = {
        $: 1
    }, lu = {
        $: 3
    }, vu = function(n) {
        switch(n){
            case "D":
                return su;
            case "R":
                return du;
            case "L":
                return bu;
            case "S":
                return lu;
            default:
                return function(n) {
                    switch(n){
                        case "c":
                            return su;
                        case "t":
                            return du;
                        case "g":
                            return bu;
                        case "a":
                            return lu;
                        default:
                            return fu(n);
                    }
                }(n);
        }
    }, pu = F3(function(n, r, t) {
        return r(n(t));
    }), hu = w, qu = A2(pu, A2(hu, F2(function(n, r) {
        var t = r.a;
        return r.b ? o(d(t, h([
            fu(n)
        ])), !1) : "_" === n ? o(t, !0) : o(d(t, h([
            vu(n)
        ])), !1);
    }), o(l, !1)), ce), yu = A2(de, qu, ou), Uu = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), mu = function(n) {
        return n.b ? A2(Uu, n.a, n.b) : A2(Uu, h([
            su
        ]), l);
    }, Wu = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Vu = A2(de, mu, Wu(yu)), Tu = A2(de, function(n) {
        return "curve" === n ? 1 : 0;
    }, ou), Ku = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), ku = F4(function(n, r, t, e) {
        return A4(Ku, n, r, t, e);
    }), Ou = function() {
        return A4(ku, 0, 0, 0, 1);
    }, zu = N, Du = function(n) {
        return A3(zu, yt, l, n);
    }, Zu = function(n) {
        return q(n).join("");
    }, Hu = I, Qu = function(n) {
        return A2(Hu, n, "");
    }, Pu = k, Mu = F3(function(n, r, t) {
        n: for(;;){
            if (!r.b) return kt(t);
            var e = r.a, u = r.b;
            switch(e){
                case "0":
                    n = a = n - 1, r = c = u, t = i = t;
                    continue n;
                case "1":
                    var a = n - 1, c = u, i = t + A2(Pu, 16, n);
                    n = a, r = c, t = i;
                    continue n;
                case "2":
                    a = n - 1, c = u, i = t + 2 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                case "3":
                    a = n - 1, c = u, i = t + 3 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                case "4":
                    a = n - 1, c = u, i = t + 4 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                case "5":
                    a = n - 1, c = u, i = t + 5 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                case "6":
                    a = n - 1, c = u, i = t + 6 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                case "7":
                    a = n - 1, c = u, i = t + 7 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                case "8":
                    a = n - 1, c = u, i = t + 8 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                case "9":
                    a = n - 1, c = u, i = t + 9 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                case "a":
                    a = n - 1, c = u, i = t + 10 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                case "b":
                    a = n - 1, c = u, i = t + 11 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                case "c":
                    a = n - 1, c = u, i = t + 12 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                case "d":
                    a = n - 1, c = u, i = t + 13 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                case "e":
                    a = n - 1, c = u, i = t + 14 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                case "f":
                    a = n - 1, c = u, i = t + 15 * A2(Pu, 16, n), n = a, r = c, t = i;
                    continue n;
                default:
                    return Wt(Qu(e) + " is not a valid hexadecimal character.");
            }
        }
    }), Su = F2(function(n, r) {
        return r.$ ? Wt(r.a) : kt(n(r.a));
    }), Lu = F2(function(n, r) {
        return r.$ ? Wt(n(r.a)) : kt(r.a);
    }), Ru = function(n) {
        return -n;
    }, xu = function(n) {
        return n.b ? Dt(n.b) : Zt;
    }, Iu = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Fu = function(n) {
        if (Ke(n)) return Wt("Empty strings are not valid hexadecimal strings.");
        var r = function() {
            if (A2(He, "-", n)) {
                var r = A2(Iu, l, xu(Du(n)));
                return A2(Su, Ru, A3(Mu, Rt(r) - 1, r, 0));
            }
            return A3(Mu, me(n) - 1, Du(n), 0);
        }();
        return A2(Lu, function(r) {
            return A2(Mt, " ", h([
                '"' + n + '"',
                "is not a valid hexadecimal string because",
                r
            ]));
        }, r);
    }, wu = function(n) {
        return n / 255;
    }, Nu = F3(function(n, r, t) {
        return A4(Ku, wu(n), wu(r), wu(t), 1);
    }), Xu = function(n) {
        return {
            X: n.d,
            ao: n.c,
            au: n.b,
            aB: n.a
        };
    }, $u = F4(function(n, r, t, e) {
        var u = Xu(A3(Nu, n, r, t));
        return A4(ku, u.aB, u.au, u.ao, e);
    }), Yu = function(n) {
        return n.toLowerCase();
    }, gu = F5(function(n, r, t, e, u) {
        var a = r.a, c = r.b, i = t.a, f = t.b, s = e.a, b = e.b, d = u.a, l = u.b, v = A2(pu, Zu, A2(pu, Yu, Fu)), p = o(o(v(h([
            a,
            c
        ])), v(h([
            i,
            f
        ]))), o(v(h([
            s,
            b
        ])), v(h([
            d,
            l
        ]))));
        if (p.a.a.$ || p.a.b.$ || p.b.a.$ || p.b.b.$) return Ou();
        var q = p.a, y = p.b;
        return A4($u, q.a.a, q.b.a, y.a.a, y.b.a / 255);
    }), ju = function(n) {
        var r = Du(A2(He, "#", n) ? A2(Ve, 1, n) : n);
        n: for(;;){
            if (r.b && r.b.b && r.b.b.b) {
                if (r.b.b.b.b) {
                    if (r.b.b.b.b.b) {
                        if (r.b.b.b.b.b.b) {
                            if (r.b.b.b.b.b.b.b) {
                                if (r.b.b.b.b.b.b.b.b && !r.b.b.b.b.b.b.b.b.b) {
                                    var t = r.b, e = t.b, u = (l = e.a, e.b), a = (p = u.a, u.b), c = (q = a.a, a.b), i = (y = c.a, c.b), f = i.a, s = i.b.a;
                                    return A5(gu, n, o(r.a, t.a), o(l, p), o(q, y), o(f, s));
                                }
                                break n;
                            }
                            var b = r.b, d = b.b, l = d.a, v = d.b, p = v.a, h = v.b, q = h.a, y = h.b.a;
                            return A5(gu, n, o(r.a, b.a), o(l, p), o(q, y), o("f", "f"));
                        }
                        break n;
                    }
                    var U = r.b, m = (K = U.a, U.b), W = (k = m.a, m.b.a);
                    return A5(gu, n, o(V = r.a, V), o(K, K), o(k, k), o(W, W));
                }
                var V, T = r.b, K = T.a, k = T.b.a;
                return A5(gu, n, o(V = r.a, V), o(K, K), o(k, k), o("f", "f"));
            }
            break n;
        }
        return Ou();
    }, Ju = A2(de, ju, ou), Eu = rn, Au = B, Gu = {
        cz: "backgroundColor",
        d1: "composition",
        d4: "curve",
        dq: "scale",
        dy: "strokeColor",
        dz: "strokeWidth",
        bv: "translateX",
        bw: "translateY",
        e7: "turnAngle"
    }, Cu = function(n) {
        return {
            $: 11,
            g: n
        };
    }, Bu = F2(function(n, r) {
        return o(n, r);
    }), _u = (Ye = A2(Eu, Gu.e7, Au), ge = A3(le, Bu, A2(Eu, Gu.bv, Au), A2(Eu, Gu.bw, Au)), je = ve, Je = A2(Eu, Gu.dz, Au), Ee = A2(Eu, Gu.dy, Ju), Ae = A2(Eu, Gu.dq, Au), Ge = A2(Eu, Gu.d4, Tu), Ce = A2(Eu, Gu.d1, Vu), Cu(h([
        A2(cu, Ge, A2(cu, Ae, A2(cu, ge, A2(cu, Je, A2(cu, Ee, A2(cu, Be = A2(Eu, Gu.cz, Ju), A2(cu, je(Zt), A2(cu, Ye, A2(cu, Ce, ve(iu)))))))))),
        A2(cu, je(0), A2(cu, Ae, A2(cu, ge, A2(cu, Je, A2(cu, Ee, A2(cu, Be, A2(cu, je(Zt), A2(cu, Ye, A2(cu, Ce, ve(iu)))))))))),
        A2(cu, je(0), A2(cu, Ae, A2(cu, ge, A2(cu, je(1), A2(cu, Ee, A2(cu, Be, A2(cu, je(Zt), A2(cu, Ye, A2(cu, Ce, ve(iu))))))))))
    ]))), na = {
        $: 0
    }, ra = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ta = ju("#2c2c2c"), ea = ju("#00b46e"), ua = function(n) {
        switch(n){
            case 0:
                return 120;
            case 1:
                return 90;
            case 2:
                return 72;
            default:
                return 60;
        }
    }, aa = function(n) {
        switch(n){
            case 0:
                return h([
                    su,
                    bu,
                    su,
                    bu,
                    su
                ]);
            case 1:
                return h([
                    su,
                    bu,
                    su,
                    bu,
                    su,
                    bu,
                    su
                ]);
            case 2:
                return h([
                    su,
                    bu,
                    su,
                    bu,
                    su,
                    bu,
                    su,
                    bu,
                    su
                ]);
            default:
                return h([
                    su,
                    bu,
                    su,
                    bu,
                    su,
                    bu,
                    su,
                    bu,
                    su,
                    bu,
                    su
                ]);
        }
    }, ca = {
        cz: ta,
        d1: mu(h([
            aa(1),
            h([
                su
            ])
        ])),
        d4: 0,
        dq: 1,
        dy: ea,
        dz: 1,
        dC: Zt,
        dK: o(0, 0),
        e7: ua(1)
    }, ia = function(n) {
        return {
            $: 44,
            a: n
        };
    }, oa = function(n) {
        return {
            $: 6,
            a: n
        };
    }, fa = F3(function(n, r, t) {
        return n(r(t));
    }), sa = Kn, ba = F2(function(n, r) {
        return nu(A2(sa, A2(fa, A2(fa, Me, n), Wt), A2(Ie, A2(fa, A2(fa, Me, n), kt), r)));
    }), da = function(n) {
        return ot(n, function(n) {
            var r, t, e = n.getBoundingClientRect(), u = at.pageXOffset, a = at.pageYOffset;
            return {
                dr: (r = ut.body, t = ut.documentElement, {
                    a5: Math.max(r.scrollWidth, r.offsetWidth, t.scrollWidth, t.offsetWidth, t.clientWidth),
                    aT: Math.max(r.scrollHeight, r.offsetHeight, t.scrollHeight, t.offsetHeight, t.clientHeight)
                }),
                fd: {
                    ff: u,
                    fg: a,
                    a5: ut.documentElement.clientWidth,
                    aT: ut.documentElement.clientHeight
                },
                ec: {
                    ff: u + e.left,
                    fg: a + e.top,
                    a5: e.width,
                    aT: e.height
                }
            };
        });
    }, la = uu(l), va = F2(function(n, r) {
        return 1 === r._.$ ? A2(ba, A2(fa, n, oa), da(r.aM)) : la;
    }), pa = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ha = F2(function(n, r) {
        return r.D ? la : A2(ba, A2(fa, n, pa), da(r.ar));
    }), qa = F2(function(n, r) {
        if (1 === r.$) return la;
        var t = r.a;
        return uu(h([
            A2(va, n, t),
            A2(ha, n, t)
        ]));
    }), ya = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Ua = A3(le, F2(function(n, r) {
        return {
            ff: n,
            fg: r
        };
    }), A2(Eu, "clientX", Au), A2(Eu, "clientY", Au)), ma = G, Wa = (_e = Ua, A2(en, function(n) {
        return n ? {
            $: 1,
            a: "Event is only relevant when the main mouse button was pressed."
        } : _e;
    }, A2(Eu, "button", ma))), Va = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ta = qr, Ka = F2(function(n, r) {
        return A2(Ta, n, Va(r));
    }), ka = F3(function(n, r, t) {
        return h([
            A2(Ka, "mousedown", A2(de, function(n) {
                return o(n, !0);
            }, A2(de, A2(fa, n, A2(ya, r, t)), Wa)))
        ]);
    }), Oa = {
        $: 4
    }, za = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Da = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Za = F2(function(n, r) {
        return A2(Ta, n, Da(r));
    }), Ha = function(n) {
        return A2(Za, "mouseenter", ve(n));
    }, Qa = function(n) {
        return A2(Za, "mouseleave", ve(n));
    }, Pa = F3(function(n, r, t) {
        var e, u;
        return h([
            (u = n(A2(za, r, t)), A2(Za, "mouseover", ve(u))),
            Ha(n((e = r, {
                $: 3,
                a: e
            }))),
            Qa(n(Oa))
        ]);
    }), Ma = function(n) {
        return Pt(n) + "px";
    }, Sa = S, La = yr, Ra = La, xa = F2(function(n, r) {
        return "translate3d(" + Ma(n) + ", " + Ma(r) + ", 0)";
    }), Ia = F2(function(n, r) {
        if (1 === r.$) return l;
        var t = r.a, e = t._;
        if (e.$) return l;
        var u = e.a.ec, a = e.a.fd, c = function() {
            switch(n){
                case 1:
                    return A2(Ra, "transform", A2(xa, Sa(t.O.ff - t.V.ff + u.ff - a.ff), Sa(u.fg - a.fg)));
                case 2:
                    return A2(Ra, "transform", A2(xa, Sa(u.ff - a.ff), Sa(t.O.fg - t.V.fg + u.fg - a.fg)));
                default:
                    return A2(Ra, "transform", A2(xa, Sa(t.O.ff - t.V.ff + u.ff - a.ff), Sa(t.O.fg - t.V.fg + u.fg - a.fg)));
            }
        }(), i = h([
            A2(Ra, "position", "fixed"),
            A2(Ra, "top", "0"),
            A2(Ra, "left", "0"),
            A2(Ra, "height", Ma(Sa(u.aT))),
            A2(Ra, "width", Ma(Sa(u.a5))),
            A2(Ra, "pointer-events", "none")
        ]);
        return A2(yt, c, i);
    }), Fa = F2(function(n, r) {
        return r.$ ? Zt : n(r.a);
    }), wa = F3(function(n, r, t) {
        return 1 === r.$ || 1 === t.$ ? Zt : Dt(A2(n, r.a, t.a));
    }), Na = function(n) {
        return A2(Fa, function(n) {
            return A3(wa, F2(function(r, t) {
                return {
                    O: n.O,
                    _: r,
                    aM: n.aM,
                    cO: n.cO,
                    aq: t,
                    ar: n.ar,
                    eb: n.eb,
                    V: n.V
                };
            }), n._, n.aq);
        }, n);
    }, Xa = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $a = {
        $: 5
    }, Ya = Nn, ga = Ya(l), ja = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Ja = F2(function(n, r) {
        return {
            dd: r,
            dB: n
        };
    }), Ea = {
        $: -2
    }, Aa = Ea, Ga = Me(A2(Ja, l, Aa)), Ca = function(n) {
        return o(d(n.a ? "w_" : "d_", n.b), n);
    }, Ba = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), _a = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(Ba, n, r, t, e, u);
            var a = e.d;
            return c = e.e, A5(Ba, 0, e.b, e.c, A5(Ba, 1, a.b, a.c, a.d, a.e), A5(Ba, 1, r, t, c, u));
        }
        var c, i = u.b, o = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(Ba, n, i, o, A5(Ba, 0, r, t, e, f), s) : A5(Ba, 0, r, t, A5(Ba, 1, e.b, e.c, e.d, c = e.e), A5(Ba, 1, i, o, f, s));
    }), nc = c, rc = F3(function(n, r, t) {
        if (-2 === t.$) return A5(Ba, 0, n, r, Ea, Ea);
        var e = t.a, u = t.b, a = t.c, c = t.d, i = t.e;
        switch(A2(nc, n, u)){
            case 0:
                return A5(_a, e, u, a, A3(rc, n, r, c), i);
            case 1:
                return A5(Ba, e, u, r, c, i);
            default:
                return A5(_a, e, u, a, c, A3(rc, n, r, i));
        }
    }), tc = F3(function(n, r, t) {
        var e = A3(rc, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(Ba, 1, e.b, e.c, e.d, e.e);
    }), ec = function(n) {
        return A3(Lt, F2(function(n, r) {
            return A3(tc, n.a, n.b, r);
        }), Aa, n);
    }, uc = function(n) {
        return Vn(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(Wn(i));
        });
    }, ac = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(ac, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), cc = F6(function(n, r, t, e, u, c) {
        var i = A3(ac, F3(function(e, u, c) {
            n: for(;;){
                var i = c.a, f = c.b;
                if (i.b) {
                    var s = i.a, b = s.a, d = s.b, l = i.b;
                    if (0 > a(b, e)) {
                        c = o(l, A3(n, b, d, f));
                        continue n;
                    }
                    return a(b, e) > 0 ? o(i, A3(t, e, u, f)) : o(l, A4(r, b, d, u, f));
                }
                return o(i, A3(t, e, u, f));
            }
        }), o(mt(e), c), u), f = i.a, s = i.b;
        return A3(Lt, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), s, f);
    }), ic = F2(function(n, r) {
        return {
            cQ: r,
            c4: n
        };
    }), oc = Fn, fc = F3(function(n, r, t) {
        return A2(Fe, function(n) {
            return o(r, n);
        }, A3(ct, t.a ? at : ut, t.b, function(t) {
            return A2(oc, n, A2(ic, r, t));
        }));
    }), sc = F2(function(n, r) {
        return A3(ac, tc, r, n);
    }), bc = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var u = e.c;
            return f(e.a, e.b, A2(yt, A3(fc, n, r, t), u));
        }), u = F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return f(A2(yt, r, t.a), e, u);
        }), a = F4(function(n, r, t, e) {
            var u = e.c;
            return f(e.a, A3(tc, n, r, e.b), u);
        }), c = A2(xe, Ca, r), i = A6(cc, u, a, e, t.dd, ec(c), f(l, Aa, l)), o = i.b, s = i.c;
        return A2(Ie, function(n) {
            return Me(A2(Ja, c, A2(sc, o, ec(n))));
        }, A2(Ie, function() {
            return Ne(s);
        }, Ne(A2(xe, uc, i.a))));
    }), dc = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(yt, e.a, t);
    }), lc = F2(function(n, r) {
        return A3(Re, dc(n), l, r);
    }), vc = F3(function(n, r, e) {
        var u = r.c4, a = r.cQ, c = function(n) {
            var r = n.b.c;
            return t(n.a, u) ? A2(it, r, a) : Zt;
        }, i = A2(lc, c, e.dB);
        return A2(Ie, function() {
            return Me(e);
        }, Ne(A2(xe, Xe(n), i)));
    });
    Ln["Browser.Events"] = Rn(Ga, bc, vc, 0, F2(function(n, r) {
        return A3(ja, r.a, r.b, A2(de, n, r.c));
    }));
    var pc, hc, qc = wn("Browser.Events"), yc = F3(function(n, r, t) {
        return qc(A3(ja, n, r, t));
    }), Uc = A2(yc, 0, "mousemove"), mc = A2(yc, 0, "mouseup"), Wc = F2(function(n, r) {
        return 1 === r.$ ? ga : Ya(h([
            Uc(A2(de, A2(fa, n, Xa), Ua)),
            mc(ve(n($a)))
        ]));
    }), Vc = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Tc = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(yt, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), Kc = F2(function(n, r) {
        return $t(A3(Tc, n, r, l));
    }), kc = F3(function(n, r, t) {
        if (r > 0) {
            var e = o(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return h([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var a = e.b, c = a.b;
                                return h([
                                    a.a,
                                    c.a,
                                    c.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var i = e.b, f = i.b, s = f.b, b = s.b, d = b.b;
                                return A2(yt, i.a, A2(yt, f.a, A2(yt, s.a, A2(yt, b.a, n > 1e3 ? A2(Kc, r - 4, d) : A3(kc, n + 1, r - 4, d)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return h([
                e.b.a
            ]);
        }
        return l;
    }), Oc = F2(function(n, r) {
        return A3(kc, 0, n, r);
    }), zc = F2(function(n, r) {
        return o(A2(Oc, n, r), A2(Vc, n, r));
    }), Dc = F3(function(n, r, t) {
        var e = A2(zc, r + 1, t), u = e.a, a = A2(zc, n - r - 1, e.b), c = a.a, i = A2(zc, 1, a.b);
        return d(u, d(i.a, d(c, i.b)));
    }), Zc = F3(function(n, r, t) {
        var e = A2(zc, n, t), u = e.a, a = A2(zc, r - n + 1, e.b), c = a.b, i = A2(zc, 1, a.a);
        return d(u, d(i.b, d(i.a, c)));
    }), Hc = F3(function(n, r, t) {
        return 0 > a(n, r) ? A3(Zc, n, r, t) : 0 > a(r, n) ? A3(Dc, n, r, t) : t;
    }), Qc = F3(function(n, r, t) {
        var e = A2(zc, r, t), u = e.a, a = A2(zc, n - r, e.b), c = a.a, i = A2(zc, 1, a.b);
        return d(u, d(i.a, d(c, i.b)));
    }), Pc = F3(function(n, r, t) {
        var e = A2(zc, n, t), u = e.a, a = A2(zc, r - n, e.b), c = a.b, i = A2(zc, 1, a.a);
        return d(u, d(i.b, d(i.a, c)));
    }), Mc = F3(function(n, r, t) {
        return 0 > a(n, r) ? A3(Pc, n, r, t) : 0 > a(r, n) ? A3(Qc, n, r, t) : t;
    }), Sc = F3(function(n, r, t) {
        return 0 > a(n, r) ? A3(Zc, n, r, t) : 0 > a(r, n) ? A3(Qc, n, r, t) : t;
    }), Lc = F2(function(n, r) {
        return r.b ? A3(Re, yt, r, n) : n;
    }), Rc = function(n) {
        return A3(Re, Lc, l, n);
    }, xc = F3(function(n, r, e) {
        var u = A2(Oc, 1, A2(Vc, r, e)), a = A2(Oc, 1, A2(Vc, n, e));
        return Rc(A2(Nt, F2(function(e, c) {
            return t(e, n) ? u : t(e, r) ? a : h([
                c
            ]);
        }), e));
    }), Ic = F3(function(n, r, e) {
        return t(n, r) ? e : A3(xc, n, r, e);
    }), Fc = F4(function(n, r, t, e) {
        switch(n){
            case 0:
                return A3(Hc, r, t, e);
            case 1:
                return A3(Mc, r, t, e);
            case 2:
                return A3(Sc, r, t, e);
            case 3:
                return A3(Ic, r, t, e);
            default:
                return e;
        }
    }), wc = F2(function(n, r) {
        return r.$ ? Zt : Dt(n(r.a));
    }), Nc = F3(function(n, r, t) {
        switch(n){
            case 0:
                return s(t, {
                    D: 0,
                    cO: 0 > a(r, t.cO) ? r + 1 : r
                });
            case 1:
                return s(t, {
                    D: 0,
                    cO: 0 > a(t.cO, r) ? r - 1 : r
                });
            case 2:
            case 3:
                return s(t, {
                    D: 0,
                    cO: r
                });
            default:
                return s(t, {
                    D: 0
                });
        }
    }), Xc = F4(function(n, r, e, u) {
        var a = n.dT, c = n.ew, i = n.eS, f = e;
        switch(r.$){
            case 0:
                var b = r.a, d = r.b;
                return o(Dt({
                    O: l = r.c,
                    D: 0,
                    _: Zt,
                    aM: d,
                    cO: b,
                    aq: Zt,
                    ar: d,
                    eb: b,
                    V: l
                }), u);
            case 1:
                var l = r.a;
                return o(A2(wc, function(n) {
                    return s(n, {
                        O: l,
                        D: n.D + 1
                    });
                }, f), u);
            case 2:
                var v = r.a, p = r.b;
                return o(A2(wc, function(n) {
                    return s(n, {
                        ar: p,
                        eb: v
                    });
                }, f), u);
            case 3:
                v = r.a;
                var h = o(f, c);
                return h.a.$ || h.b ? o(A2(wc, function(n) {
                    return s(n, {
                        D: 0
                    });
                }, f), u) : (q = h.a.a).D > 1 && !t(q.cO, v) ? o(Dt(A3(Nc, i, v, q)), A4(Fc, i, q.cO, v, A3(a, q.cO, v, u))) : o(f, u);
            case 4:
                return o(A2(wc, function(n) {
                    return s(n, {
                        eb: n.cO
                    });
                }, f), u);
            case 5:
                var q, y = o(f, c);
                return y.a.$ || 1 !== y.b || t((q = y.a.a).cO, q.eb) ? o(Zt, u) : o(Zt, A4(Fc, i, q.cO, q.eb, A3(a, q.cO, q.eb, u)));
            case 6:
                if (1 === r.a.$) return o(f, u);
                var U = r.a.a;
                return o(A2(wc, function(n) {
                    return s(n, {
                        _: Dt(U),
                        aq: Dt(U)
                    });
                }, f), u);
            default:
                if (1 === r.a.$) return o(f, u);
                var m = r.a.a;
                return o(A2(wc, function(n) {
                    return s(n, {
                        aq: Dt(m)
                    });
                }, f), u);
        }
    }), $c = F2(function(n, r) {
        return {
            d0: qa(r),
            d9: ka(r),
            ea: Pa(r),
            ek: Ia(n.eD),
            bg: Na,
            eC: Zt,
            e3: Wc(r),
            e8: Xc(n)
        };
    }), Yc = A2($c, {
        dT: F3(function(n, r, t) {
            return t;
        }),
        ew: 0,
        eD: 2,
        eS: 2
    }, ia), gc = E, jc = F3(function(n, r, t) {
        for(;;){
            if (0 >= r) return n;
            n = A2(yt, t, n), r -= 1;
        }
    }), Jc = F2(function(n, r) {
        return A3(jc, l, n, r);
    }), Ec = function(n) {
        return {
            aN: A2(Jc, 12, {
                ad: false,
                bk: !1
            }),
            bS: Zt,
            dG: n
        };
    }, Ac = function(n) {
        return 0 > n ? -n : n;
    }, Gc = F3(function(n, r, t) {
        return 0 > a(t, n) ? n : a(t, r) > 0 ? r : t;
    }), Cc = F2(function(n, r) {
        return r - n * ne(r / n);
    }), Bc = z, _c = function(n) {
        return n * Bc / 180;
    }, ni = F4(function(n, r, t, e) {
        var u = A3(Gc, 1e-6, 1, t), a = A2(Cc, 6.283185307179586, n) / _c(1) / 60, c = u * r, i = u - c, o = c * (1 - Ac(A2(Cc, 2, a) - 1)), s = 0 > a || a > 1 ? a > 1 && 2 >= a ? f(o, c, 0) : a > 2 && 3 >= a ? f(0, c, o) : a > 3 && 4 >= a ? f(0, o, c) : a > 4 && 5 >= a ? f(o, 0, c) : a > 5 && 6 >= a ? f(c, 0, o) : f(0, 0, 0) : f(c, o, 0), b = f(s.a + i, s.b + i, s.c + i);
        return A4(ku, b.a, b.b, b.c, e);
    }), ri = F3(function(n, r, t) {
        return A4(ni, n, r, t, 1);
    }), ti = function(n) {
        return A3(ri, n.b, n.a, 1);
    }, ei = F2(function(n, r) {
        return {
            bF: 2,
            d_: A2(Iu, ti(o(0, 0)), r),
            a9: !1,
            ba: Zt,
            bd: n,
            cd: o(0, 0),
            ax: !1,
            bQ: 100,
            cl: !0,
            bt: !0
        };
    }), ui = function(n) {
        return {
            $: 15,
            a: n
        };
    }, ai = F4(function(n, r, t, e) {
        return {
            $: 18,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), ci = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ii = F2(function(n, r) {
        return ci(n + ":" + r);
    }), oi = function(n) {
        return A2(ii, "background-color", n.W);
    }, fi = function(n) {
        return n ? "-" : "+";
    }, si = F2(function(n, r) {
        return n + "(" + A2(Mt, ", ", r) + ")";
    }), bi = F3(function(n, r, t) {
        var e = function(n) {
            return A2(He, "calc(", n.W) ? A2(Ve, 4, n.W) : n.W;
        }, u = A2(Mt, " ", h([
            e(n),
            fi(r),
            e(t)
        ]));
        return {
            cH: 0,
            aP: 0,
            w: 0,
            bi: 0,
            aU: 0,
            af: 0,
            aV: 0,
            aW: 0,
            av: 0,
            aw: 0,
            U: 0,
            a$: 0,
            W: A2(si, "calc", h([
                u
            ]))
        };
    }), di = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), li = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vi = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), pi = function(n) {
        return !n;
    }, hi = F2(function(n, r) {
        return !A2(vi, A2(fa, pi, n), r);
    }), qi = function(n) {
        return !n.b;
    }, yi = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 0:
                return qi(n.a.c) ? o(t, e) : o(t, A2(yt, n, e));
            case 1:
                return o(t, A2(hi, function(n) {
                    return qi(n.c);
                }, n.b) ? e : A2(yt, n, e));
            case 2:
            case 4:
                return qi(n.b) ? o(t, e) : o(t, A2(yt, n, e));
            case 3:
                return o(t, A2(yt, n, e));
            case 5:
            case 7:
            case 8:
                return qi(n.a) ? o(t, e) : o(t, A2(yt, n, e));
            case 6:
                var u = n.a;
                return Ke(u.d5) ? o(t, e) : o(A3(tc, u.eE, u.d5, t), e);
            default:
                return o(t, A2(hi, function(n) {
                    return qi(n.b);
                }, n.a) ? e : A2(yt, n, e));
        }
    }), Ui = function(n) {
        return {
            $: 6,
            a: n
        };
    }, mi = F2(function(n, r) {
        return A2(Lc, A2(xe, function(n) {
            return Ui({
                d5: n.b,
                eE: n.a
            });
        }, mt(n)), r);
    }), Wi = function(n) {
        return A2(Iu, "", A2(wc, function(n) {
            return '@charset "' + n + '"';
        }, n));
    }, Vi = F2(function(n, r) {
        return A3(Re, F2(function(r, t) {
            return n(r) ? A2(yt, r, t) : t;
        }), l, r);
    }), Ti = function(n) {
        return "(" + n.cS + A2(Iu, "", A2(wc, Ht(": "), n.W)) + ")";
    }, Ki = function(n) {
        var r = F3(function(n, r, t) {
            return n + " " + A2(Mt, " and ", A2(yt, function(n) {
                switch(n){
                    case 0:
                        return "print";
                    case 1:
                        return "screen";
                    default:
                        return "speech";
                }
            }(r), A2(xe, Ti, t)));
        });
        switch(n.$){
            case 0:
                return A2(Mt, " and ", A2(xe, Ti, n.a));
            case 1:
                return A3(r, "only", n.a, n.b);
            case 2:
                return A3(r, "not", n.a, n.b);
            default:
                return n.a;
        }
    }, ki = F2(function(n, r) {
        return '@import "' + n + Ki(r) + '"';
    }), Oi = function(n) {
        var r = n.b;
        return A2(Mt, "\n", A2(xe, ki(n.a), r));
    }, zi = function(n) {
        return "@namespace " + n.a + '"' + n.b + '"';
    }, Di = "    ", Zi = function(n) {
        return d(Di, n);
    }, Hi = function(n) {
        return n + ";";
    }, Qi = function(n) {
        return A2(Mt, "\n", A2(xe, A2(fa, Zi, Hi), n));
    }, Pi = F, Mi = function(n) {
        return "::" + n;
    }, Si = function(n) {
        switch(n){
            case 0:
                return "+";
            case 1:
                return "~";
            case 2:
                return ">";
            default:
                return "";
        }
    }, Li = function(n) {
        switch(n.$){
            case 0:
                return "." + n.a;
            case 1:
                return "#" + n.a;
            case 2:
                return ":" + n.a;
            default:
                return "[" + n.a + "]";
        }
    }, Ri = function(n) {
        switch(n.$){
            case 0:
            default:
                return A2(Mt, "", A2(yt, n.a, A2(xe, Li, r = n.b)));
            case 1:
                var r;
                return qi(r = n.a) ? "*" : A2(Mt, "", A2(xe, Li, r));
        }
    }, xi = function(n) {
        var r = n.b;
        return A2(Mt, " ", h([
            Si(n.a),
            Ri(r)
        ]));
    }, Ii = function(n) {
        var r = n.b, t = n.c, e = A2(yt, Ri(n.a), A2(xe, xi, r)), u = A2(Mt, "", h([
            A2(Iu, "", A2(wc, Mi, t))
        ]));
        return A2(Pi, A2(Mt, " ", A2(Vi, A2(fa, pi, Ke), e)), u);
    }, Fi = F2(function(n, r) {
        var t = r.c;
        return A2(Mt, "", h([
            A2(Mt, ", ", A2(xe, Ii, A2(yt, r.a, r.b))),
            " {\n",
            n,
            Qi(t),
            "\n",
            n,
            "}"
        ]));
    }), wi = function(n) {
        switch(n.$){
            case 0:
                return A2(Fi, "", n.a);
            case 1:
                var r = n.b;
                return "@media " + A2(Mt, ",\n", A2(xe, Ki, n.a)) + " {\n" + A2(Mt, "\n\n", A2(xe, A2(fa, Zi, Fi(Di)), r)) + "\n}";
            case 2:
            case 3:
            case 4:
            case 5:
            case 7:
            case 8:
            default:
                return "TODO";
            case 6:
                return "@keyframes " + n.a.eE + " {\n" + n.a.d5 + "\n}";
        }
    }, Ni = F2(function(n, r) {
        return Rc(A2(xe, n, r));
    }), Xi = function(n) {
        return {
            $: 8,
            a: n
        };
    }, $i = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Yi = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), gi = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), ji = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Ji = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ei = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Ai = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Gi = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ci = F2(function(n, r) {
        return r.b ? r.b.b ? A2(yt, r.a, A2(Ci, n, r.b)) : h([
            n(r.a)
        ]) : r;
    }), Bi = F2(function(n, r) {
        return A3(ji, r.a, r.b, d(r.c, h([
            n
        ])));
    }), _i = F2(function(n, r) {
        if (!r.b) return r;
        if (r.b.b) return A2(yt, r.a, A2(_i, n, r.b));
        switch(r.a.$){
            case 0:
                return h([
                    Ji(A2(Bi, n, r.a.a))
                ]);
            case 1:
                var t = r.a, e = t.b;
                return h([
                    A2(Gi, t.a, A2(Ci, Bi(n), e))
                ]);
            default:
                return r;
        }
    }), no = F2(function(n, r) {
        if (r.b.b) {
            var t = r.a, e = r.b, u = (c = r.c, A2(xe, n, e)), a = n(t);
            return h([
                A3(ji, t, e, c),
                A3(ji, a, u, l)
            ]);
        }
        var c, i = r.a;
        return h([
            A3(ji, i, l, c = r.c),
            A3(ji, n(i), l, l)
        ]);
    }), ro = F2(function(n, r) {
        return A3(gi, r.a, r.b, Dt(n));
    }), to = F2(function(n, r) {
        return A2(no, ro(n), r);
    }), eo = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), uo = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ao = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(uo, r.a, d(r.b, h([
                    n
                ])));
            case 1:
                return li(d(r.a, h([
                    n
                ])));
            default:
                return A2(eo, r.a, d(r.b, h([
                    n
                ])));
        }
    }), co = F2(function(n, r) {
        if (r.b) {
            if (r.b.b) return A2(yt, r.a, A2(co, n, r.b));
            var t = r.a;
            return h([
                o(t.a, A2(ao, n, t.b))
            ]);
        }
        return l;
    }), io = F2(function(n, r) {
        if (r.b.b) return t = r.c, A3(gi, r.a, A2(co, n, r.b), t);
        var t = r.c;
        return A3(gi, A2(ao, n, r.a), l, t);
    }), oo = F2(function(n, r) {
        return A2(no, io(n), r);
    }), fo = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.a.$) {
                    n = t = n.b;
                    continue n;
                }
                var r = n.a.a, t = n.b;
                return d(A2(yt, r.a, r.b), fo(t));
            }
            return l;
        }
    }, so = F5(function(n, r, t, e, u) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), bo = F2(function(n, r) {
        n: for(;;){
            if (!r.b) return r;
            if (r.b.b) break n;
            switch(r.a.$){
                case 0:
                    return A2(xe, Ji, n(s = r.a.a));
                case 1:
                    if (r.a.b.b) {
                        if (r.a.b.b.b) {
                            var t = r.a, e = t.b, u = e.a, a = A2(bo, n, h([
                                A2(Gi, t.a, e.b)
                            ]));
                            if (a.b && 1 === a.a.$ && !a.b.b) {
                                var c = a.a;
                                return h([
                                    A2(Gi, c.a, A2(yt, u, c.b))
                                ]);
                            }
                            return a;
                        }
                        var i = r.a;
                        return h([
                            A2(Gi, i.a, n(s = i.b.a))
                        ]);
                    }
                    break n;
                case 2:
                    var o = r.a;
                    return h([
                        A2(Ei, o.a, A2(bo, n, o.b))
                    ]);
                case 3:
                    var f = r.a, s = f.e;
                    return A2(xe, A4(so, f.a, f.b, f.c, f.d), n(s));
                default:
                    return r;
            }
        }
        return A2(yt, u = r.a, A2(bo, n, r.b));
    }), lo = F4(function(n, r, t, e) {
        return {
            aH: e,
            G: t,
            I: r,
            aY: n
        };
    }), vo = 3432918353, po = 461845907, ho = F2(function(n, r) {
        return (65535 & r) * n + (((r >>> 16) * n & 65535) << 16);
    }), qo = F2(function(n, r) {
        return r << n | r >>> 32 - n;
    }), yo = F2(function(n, r) {
        return A2(ho, 5, A2(qo, 13, n ^ A2(ho, po, A2(qo, 15, A2(ho, vo, r))))) + 3864292196;
    }), Uo = F2(function(n, r) {
        var t = r.G | (255 & Xt(n)) << r.aY;
        return 24 === r.aY ? {
            aH: r.aH + 1,
            G: 0,
            I: A2(yo, r.I, t),
            aY: 0
        } : {
            aH: r.aH + 1,
            G: t,
            I: r.I,
            aY: r.aY + 8
        };
    }), mo = F2(function(n, r) {
        var t, e, u, a;
        return ((a = A2(ho, 3266489909, (u = A2(ho, 2246822507, (e = ((t = A3(hu, Uo, A4(lo, 0, n, 0, 0), r)).G ? t.I ^ A2(ho, po, A2(qo, 15, A2(ho, vo, t.G))) : t.I) ^ t.aH) ^ e >>> 16)) ^ u >>> 13)) ^ a >>> 16) >>> 0;
    }), Wo = O, Vo = function(n) {
        n: for(;;)switch(n){
            case 0:
                return "0";
            case 1:
                return "1";
            case 2:
                return "2";
            case 3:
                return "3";
            case 4:
                return "4";
            case 5:
                return "5";
            case 6:
                return "6";
            case 7:
                return "7";
            case 8:
                return "8";
            case 9:
                return "9";
            case 10:
                return "a";
            case 11:
                return "b";
            case 12:
                return "c";
            case 13:
                return "d";
            case 14:
                return "e";
            case 15:
                return "f";
            default:
                continue n;
        }
    }, To = F2(function(n, r) {
        for(;;){
            if (16 > r) return A2(yt, Vo(r), n);
            n = A2(yt, Vo(A2(Wo, 16, r)), n), r = r / 16 | 0;
        }
    }), Ko = function(n) {
        return Zu(0 > n ? A2(yt, "-", A2(To, l, -n)) : A2(To, l, n));
    }, ko = function(n) {
        return n.b ? Dt(n.a) : Zt;
    }, Oo = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.b.b) {
                    n = n.b;
                    continue n;
                }
                return Dt(h([
                    n.a
                ]));
            }
            return Zt;
        }
    }, zo = function(n) {
        var r, t = function(n) {
            return n.b ? A2(yt, n.a, t(n.b)) : l;
        };
        return h([
            (r = t(n), {
                $: 9,
                a: r
            })
        ]);
    }, Do = function(n) {
        return h([
            n
        ]);
    }, Zo = F2(function(n, r) {
        return r.$ ? r : A2(Gi, n, h([
            r.a
        ]));
    }), Ho = F5(function(n, r, t, e, u) {
        return u.$ ? u : A5(so, n, r, t, e, u.a);
    }), Qo = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(Gi, n, h([
                    r.a
                ]));
            case 1:
                var t = r.b;
                return A2(Gi, d(n, r.a), t);
            case 2:
                var e = r.b;
                return A2(Ei, r.a, A2(xe, Qo(n), e));
            case 3:
                return A5(so, r.a, r.b, r.c, r.d, r.e);
            default:
                return r;
        }
    }), Po = function(n) {
        return n;
    }, Mo = F4(function(n, r, e, u) {
        var a = function(n) {
            return A2(Iu, l, xu(n));
        }, c = A2(So, r, A2(Iu, l, Oo(u))), i = function() {
            var n = o(ko(c), function(n) {
                n: for(;;){
                    if (n.b) {
                        if (n.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return Dt(n.a);
                    }
                    return Zt;
                }
            }(u));
            if (n.a.$ || n.b.$) return u;
            var r = n.a.a, e = n.b.a;
            return d(A2(Oc, Rt(u) - 1, u), h([
                t(e, r) ? e : r
            ]));
        }();
        return d(i, d(a(A2(Iu, l, A2(wc, function(r) {
            return Rc(A2(Ci, So(n), A2(xe, Do, A2(bo, e, r))));
        }, Oo(u)))), a(c)));
    }), So = F2(function(n, r) {
        if (!n.b) return r;
        switch(n.a.$){
            case 0:
                return A2(So, c = n.b, A2(_i, n.a.a, r));
            case 1:
                var t = n.a;
                return A4(Mo, y = t.b, c = n.b, oo(t.a), r);
            case 2:
                var e = n.a, u = e.a, a = e.b, c = n.b, i = F2(function(n, r) {
                    var t = n.c, e = r.b, a = r.c;
                    return A3(gi, n.a, d(n.b, A2(yt, o(u, r.a), e)), function(n) {
                        n: for(;;){
                            if (n.b) {
                                var r = n.a;
                                if (1 === r.$) {
                                    n = n.b;
                                    continue n;
                                }
                                return r;
                            }
                            return Zt;
                        }
                    }(h([
                        a,
                        t
                    ])));
                }), f = function(n) {
                    switch(n.$){
                        case 0:
                            var t = n.a, e = t.a, u = t.b, a = t.c, c = A2(Ni, function(n) {
                                return A2(xe, i(n), A2(yt, e, u));
                            }, fo(r)), o = c.b ? h([
                                Ji(A3(ji, c.a, c.b, l))
                            ]) : l;
                            return A2(So, a, o);
                        case 1:
                            return A2(xo, n.a, n.b);
                        case 2:
                            return A2(Io, n.a, n.b);
                        case 3:
                            var f = n.e;
                            return A2(xe, A4(Ho, n.a, n.b, n.c, n.d), Lo(f));
                        case 4:
                            return h([
                                A2(Yi, n.a, n.b)
                            ]);
                        case 5:
                            return h([
                                $i(n.a)
                            ]);
                        case 6:
                            return h([
                                Ai(n.a)
                            ]);
                        case 7:
                            return h([
                                Xi(n.a)
                            ]);
                        default:
                            return zo(n.a);
                    }
                };
                return Rc(d(h([
                    A2(So, c, r)
                ]), A2(xe, f, A2(Ni, Po, a))));
            case 3:
                var s = n.a;
                return A4(Mo, y = s.b, c = n.b, to(s.a), r);
            case 5:
                var b = n.a.a, v = (c = n.b, function(n) {
                    return A2(Hu, "_", Ko(A2(mo, 15739, n)));
                }(b));
                return A2(Lc, A2(So, c, A2(_i, "animation-name:" + v, r)), h([
                    Ui({
                        d5: b,
                        eE: v
                    })
                ]));
            case 4:
                var p = n.a, q = p.a, y = p.b, U = (c = n.b, function() {
                    var n = fo(r);
                    if (n.b) {
                        var t = n.a, e = n.b;
                        return A2(xe, Zo(q), A2(So, y, Do(Ji(A3(ji, t, e, l)))));
                    }
                    return l;
                }());
                return d(A2(So, c, r), U);
            default:
                return A2(So, d(n.a.a, c = n.b), r);
        }
    }), Lo = function(n) {
        return A2(So, n.c, h([
            Ji(A3(ji, n.a, n.b, l))
        ]));
    }, Ro = function(n) {
        if (n.b) {
            var r = n.b;
            return d(Fo(n.a), Ro(r));
        }
        return l;
    }, xo = F2(function(n, r) {
        return A2(Ni, function(r) {
            return A2(xe, Qo(n), Lo(r));
        }, r);
    }), Io = F2(function(n, r) {
        var t = Ro(A2(Ni, Po, r));
        return h([
            A2(Ei, n, t)
        ]);
    }), Fo = function(n) {
        switch(n.$){
            case 0:
                return Lo(r = n.a);
            case 1:
                return A2(xo, n.a, n.b);
            case 2:
                return A2(Io, n.a, n.b);
            case 3:
                var r = n.e;
                return A2(xe, A4(Ho, n.a, n.b, n.c, n.d), Lo(r));
            case 4:
                return h([
                    A2(Yi, n.a, n.b)
                ]);
            case 5:
                return h([
                    $i(n.a)
                ]);
            case 6:
                return h([
                    Ai(n.a)
                ]);
            case 7:
                return h([
                    Xi(n.a)
                ]);
            default:
                return zo(n.a);
        }
    }, wo = function(n) {
        var r, t, e;
        return function(n) {
            var r = n.cK, t = n.cZ, e = n.da, u = n.d6;
            return A2(Mt, "\n\n", A2(Vi, A2(fa, pi, Ke), h([
                Wi(r),
                A2(Mt, "\n", A2(xe, Oi, t)),
                A2(Mt, "\n", A2(xe, zi, e)),
                A2(Mt, "\n\n", A2(xe, wi, u))
            ])));
        }(function(n) {
            var r = n.cK, t = n.cZ, e = n.da, u = n.d6, a = A3(Re, yi, o(Aa, l), u);
            return {
                cK: r,
                d6: A2(mi, a.a, a.b),
                cZ: t,
                da: e
            };
        }((t = (r = n).cZ, e = r.da, {
            cK: r.cK,
            d6: Ro(A2(Ni, Po, r.dv)),
            cZ: t,
            da: e
        })));
    }, No = function(n) {
        return A2(Mt, "\n\n", A2(xe, wo, n));
    }, Xo = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), $o = F2(function(n, r) {
        var t;
        return h([
            (t = A3(Xo, A3(gi, r, l, Zt), l, n), {
                $: 0,
                a: t
            })
        ]);
    }), Yo = function(n) {
        return {
            cK: Zt,
            cZ: l,
            da: l,
            dv: n
        };
    }, go = F2(function(n, r) {
        return A2(Ur, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), Vr(r));
    }), jo = Un, Jo = function(n) {
        var r = function(n) {
            return qi(n) ? "unstyled" : A2(Hu, "_", Ko(A2(mo, 15739, No(Do(Yo(Do(A2($o, n, li(l)))))))));
        }(n), t = A2(go, "className", jo(r));
        return A3(di, t, n, r);
    }, Eo = function(n) {
        return n.b;
    }, Ao = F3(function(n, r, t) {
        return o(A2(n, t.a, r.a), A2(n, t.b, r.b));
    }), Go = F2(function(n, r) {
        return o(n(r.a), n(r.b));
    }), Co = function(n) {
        var r = n.e6, t = n.dU, e = n.d3, u = A2(Go, function(n) {
            return n / e;
        }, n.dX), a = A2(Go, ee(1.6), A2(Go, zt(20), A3(Ao, It, r, t))), c = A2(Go, ee(-0.5), a);
        return o(A3(Ao, zt, c, u), a);
    }, Bo = F2(function(n, r) {
        return A2(mr, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), Vr(r));
    }), _o = F2(function(n, r) {
        return A3(di, A2(Bo, n, r), l, "");
    }), nf = _o("d"), rf = _o("fill"), tf = _o("id"), ef = function(n) {
        return {
            $: 1,
            a: n
        };
    }, uf = F4(function(n, r, t, e) {
        return {
            dU: r,
            dX: t,
            d3: e,
            e6: n
        };
    }), af = F4(function(n, r, t, e) {
        return {
            bD: r,
            dV: e,
            bW: n,
            bX: t
        };
    }), cf = A4(af, "", 0, o(0, 0), A4(uf, o(0, 0), o(0, 0), o(0, 0), 0)), of = D, ff = Z, sf = function(n) {
        var r = n.a, t = n.b;
        return o(r * of(t), r * ff(t));
    }, bf = F2(function(n, r) {
        var t;
        return t = A2(Go, ee(r), sf(o(1, _c(n)))), o(t.a, -t.b);
    }), df = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lf = function(n) {
        return {
            $: 8,
            a: n
        };
    }, vf = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), pf = {
        $: 4
    }, hf = ec(h([
        o("0", o(h([
            df(o(8.287671, .410959)),
            A2(vf, o(0, .876712), o(-0.431507, 1.616438)),
            A2(vf, o(-0.431507, .739726), o(-1.171232, 1.171233)),
            A2(vf, o(-0.739726, .431507), o(-1.616439, .431507)),
            A2(vf, o(-0.876712, 0), o(-1.616438, -0.431507)),
            A2(vf, o(-0.739726, -0.431507), o(-1.171233, -1.171233)),
            A2(vf, o(-0.431507, -0.739726), o(-0.431507, -1.616438)),
            ef(o(0, -3.493151)),
            A2(vf, o(0, -0.876712), o(.431507, -1.616438)),
            A2(vf, o(.431507, -0.739726), o(1.171233, -1.171233)),
            A2(vf, o(.739726, -0.431507), o(1.616438, -0.431507)),
            A2(vf, o(.876712, 0), o(1.616439, .431507)),
            A2(vf, o(.739726, .431507), o(1.171232, 1.171233)),
            A2(vf, o(.431507, .739726), o(.431507, 1.616438)),
            ef(o(0, 3.493151)),
            df(o(-5.945205, 0)),
            A2(vf, o(0, .465753), o(.178082, .958904)),
            ef(o(4.835616, -5.90411)),
            A2(vf, o(-0.369863, -0.575342), o(-0.972602, -0.917808)),
            A2(vf, o(-0.60274, -0.342466), o(-1.315069, -0.342466)),
            A2(vf, o(-0.739726, 0), o(-1.363014, .363014)),
            A2(vf, o(-0.623288, .363014), o(-0.99315, .986302)),
            A2(vf, o(-0.369863, .623288), o(-0.369863, 1.363013)),
            ef(o(0, 3.493151)),
            df(o(5.452055, -3.493151)),
            A2(vf, o(0, -0.465753), o(-0.178083, -0.958904)),
            ef(o(-4.835616, 5.90411)),
            A2(vf, o(.369863, .589041), o(.972603, .931507)),
            A2(vf, o(.60274, .342466), o(1.315068, .342465)),
            A2(vf, o(.739726, 0), o(1.363014, -0.369863)),
            A2(vf, o(.623288, -0.369863), o(.993151, -0.99315)),
            A2(vf, o(.369863, -0.623288), o(.369863, -1.363014)),
            ef(o(0, -3.493151)),
            pf,
            df(o(-5.452055, 3.493151)),
            df(o(5.945205, 0)),
            df(o(-8.287671, -0.410959)),
            df(o(10, 0))
        ]), 10)),
        o("1", o(h([
            df(o(4.821918, 2.917808)),
            ef(o(0, -7.287671)),
            A2(vf, o(-0.452055, .69863), o(-1.184932, 1.109589)),
            A2(vf, o(-0.732877, .410959), o(-1.59589, .410959)),
            ef(o(0, -0.493151)),
            A2(vf, o(.753425, 0), o(1.390411, -0.376712)),
            A2(vf, o(.636986, -0.376712), o(1.013698, -1.013699)),
            A2(vf, o(.376712, -0.636986), o(.376713, -1.390411)),
            ef(o(.49315, 0)),
            ef(o(0, 9.041096)),
            ef(o(2.876713, 0)),
            ef(o(0, .50685)),
            ef(o(-6.246576, 0)),
            ef(o(0, -0.50685)),
            ef(o(2.876713, 0)),
            pf,
            df(o(-4.821918, -2.917808)),
            df(o(10, 0))
        ]), 10)),
        o("2", o(h([
            df(o(8.027397, 2.917808)),
            ef(o(0, .50685)),
            ef(o(-5.917808, 0)),
            ef(o(0, -0.50685)),
            ef(o(2.054795, -2.260274)),
            ef(o(1.863013, -2.027397)),
            ef(o(.164384, -0.178082)),
            A2(vf, o(.547945, -0.575342), o(.849315, -1.047945)),
            A2(vf, o(.30137, -0.472603), o(.30137, -1.020548)),
            A2(vf, o(0, -0.616438), o(-0.308219, -1.123288)),
            A2(vf, o(-0.308219, -0.506849), o(-0.849315, -0.794521)),
            A2(vf, o(-0.541096, -0.287671), o(-1.198631, -0.287671)),
            A2(vf, o(-0.630137, 0), o(-1.171233, .315069)),
            A2(vf, o(-0.541096, .315068), o(-0.856164, .856164)),
            A2(vf, o(-0.315068, .541096), o(-0.315068, 1.184932)),
            ef(o(-0.50685, 0)),
            A2(vf, o(0, -0.780822), o(.383562, -1.431507)),
            A2(vf, o(.383562, -0.650685), o(1.034247, -1.034247)),
            A2(vf, o(.650685, -0.383562), o(1.431506, -0.383561)),
            A2(vf, o(.808219, 0), o(1.458904, .349315)),
            A2(vf, o(.650685, .349315), o(1.027398, .965753)),
            A2(vf, o(.376712, .616438), o(.376712, 1.383562)),
            A2(vf, o(0, .684932), o(-0.342466, 1.219178)),
            A2(vf, o(-0.342466, .534247), o(-0.945205, 1.191781)),
            ef(o(-0.164384, .178082)),
            ef(o(-3.602739, 3.945205)),
            ef(o(5.232876, 0)),
            pf,
            df(o(-8.027397, -2.917808)),
            df(o(10, 0))
        ]), 10)),
        o("3", o(h([
            df(o(4.232877, -1.520548)),
            ef(o(2.958904, -4.054794)),
            ef(o(-4.876713, 0)),
            ef(o(0, -0.50685)),
            ef(o(5.50685, 0)),
            ef(o(0, .50685)),
            ef(o(-2.178082, 2.972602)),
            A2(vf, o(.726027, .136986), o(1.308219, .575343)),
            A2(vf, o(.582192, .438356), o(.917808, 1.09589)),
            A2(vf, o(.335616, .657534), o(.335616, 1.410959)),
            A2(vf, o(0, .849315), o(-0.424657, 1.575343)),
            A2(vf, o(-0.424658, .726027), o(-1.143836, 1.150684)),
            A2(vf, o(-0.719178, .424658), o(-1.568493, .424658)),
            A2(vf, o(-0.849315, 0), o(-1.568493, -0.424658)),
            A2(vf, o(-0.719178, -0.424658), o(-1.143836, -1.150684)),
            A2(vf, o(-0.424658, -0.726027), o(-0.424657, -1.575343)),
            ef(o(.493151, 0)),
            A2(vf, o(0, .712329), o(.356164, 1.321918)),
            A2(vf, o(.356164, .609589), o(.965753, .965753)),
            A2(vf, o(.609589, .356164), o(1.321918, .356165)),
            A2(vf, o(.712329, 0), o(1.321918, -0.356165)),
            A2(vf, o(.609589, -0.356164), o(.965753, -0.965753)),
            A2(vf, o(.356164, -0.609589), o(.356165, -1.321918)),
            A2(vf, o(0, -0.671233), o(-0.321918, -1.246575)),
            A2(vf, o(-0.321918, -0.575342), o(-0.876712, -0.945206)),
            A2(vf, o(-0.554795, -0.369863), o(-1.212329, -0.424657)),
            ef(o(-0.657534, .904109)),
            ef(o(-0.410959, -0.287671)),
            pf,
            df(o(-4.232877, 1.520548)),
            df(o(10, 0))
        ]), 10)),
        o("4", o(h([
            df(o(6.287671, -6.123288)),
            ef(o(.50685, 0)),
            ef(o(0, 6.575343)),
            ef(o(1.657534, 0)),
            ef(o(0, .49315)),
            ef(o(-1.657534, 0)),
            ef(o(0, 2.479453)),
            ef(o(-0.50685, 0)),
            ef(o(0, -2.479453)),
            ef(o(-4.602739, 0)),
            ef(o(0, -0.506849)),
            ef(o(4.602739, -6.561644)),
            df(o(0, 6.575343)),
            ef(o(0, -5.69863)),
            ef(o(-4, 5.69863)),
            ef(o(4, 0)),
            pf,
            df(o(0, -6.575343)),
            df(o(-6.287671, 6.123288)),
            df(o(10, 0))
        ]), 10)),
        o("5", o(h([
            df(o(2.205479, -6.09589)),
            ef(o(5.630137, 0)),
            ef(o(0, .506849)),
            ef(o(-5.123287, 0)),
            ef(o(0, 3.780822)),
            A2(vf, o(.452055, -0.479452), o(1.061644, -0.739726)),
            A2(vf, o(.609589, -0.260274), o(1.280822, -0.260274)),
            A2(vf, o(.876712, 0), o(1.616438, .410959)),
            A2(vf, o(.739726, .410959), o(1.171233, 1.143835)),
            A2(vf, o(.431507, .732877), o(.431507, 1.664384)),
            A2(vf, o(0, .931507), o(-0.431507, 1.664383)),
            A2(vf, o(-0.431507, .732877), o(-1.171233, 1.143836)),
            A2(vf, o(-0.739726, .410959), o(-1.616438, .410959)),
            A2(vf, o(-0.794521, 0), o(-1.486302, -0.369863)),
            A2(vf, o(-0.691781, -0.369863), o(-1.143835, -1.006849)),
            A2(vf, o(-0.452055, -0.636986), o(-0.561644, -1.40411)),
            ef(o(.506849, 0)),
            A2(vf, o(.109589, .643836), o(.493151, 1.157534)),
            A2(vf, o(.383562, .513699), o(.952054, .815069)),
            A2(vf, o(.568493, .30137), o(1.239727, .30137)),
            A2(vf, o(.739726, 0), o(1.363013, -0.342466)),
            A2(vf, o(.623288, -0.342466), o(.986302, -0.958904)),
            A2(vf, o(.363014, -0.616438), o(.363013, -1.410959)),
            A2(vf, o(0, -0.794521), o(-0.363013, -1.417808)),
            A2(vf, o(-0.363014, -0.623288), o(-0.986302, -0.965754)),
            A2(vf, o(-0.623288, -0.342466), o(-1.363013, -0.342465)),
            A2(vf, o(-0.712329, 0), o(-1.328768, .356164)),
            A2(vf, o(-0.616438, .356164), o(-0.986301, .958904)),
            ef(o(-0.534247, 0)),
            ef(o(0, -5.09589)),
            pf,
            df(o(-2.205479, 6.09589)),
            df(o(10, 0))
        ]), 10)),
        o("6", o(h([
            df(o(6.589041, -6.082192)),
            ef(o(-2.643836, 3.643836)),
            A2(vf, o(.547945, -0.219178), o(1.123288, -0.219178)),
            A2(vf, o(.849315, 0), o(1.575343, .424657)),
            A2(vf, o(.726027, .424658), o(1.143835, 1.143836)),
            A2(vf, o(.417808, .719178), o(.417808, 1.568493)),
            A2(vf, o(0, .849315), o(-0.424657, 1.575343)),
            A2(vf, o(-0.424658, .726027), o(-1.143836, 1.150684)),
            A2(vf, o(-0.719178, .424658), o(-1.568493, .424658)),
            A2(vf, o(-0.849315, 0), o(-1.568493, -0.424658)),
            A2(vf, o(-0.719178, -0.424658), o(-1.143836, -1.150684)),
            A2(vf, o(-0.424658, -0.726027), o(-0.424657, -1.575343)),
            A2(vf, o(0, -1.027397), o(.60274, -1.849315)),
            ef(o(3.438356, -4.712329)),
            ef(o(.616438, 0)),
            df(o(-1.520548, 9.20548)),
            A2(vf, o(.712329, 0), o(1.321918, -0.356165)),
            A2(vf, o(.609589, -0.356164), o(.965753, -0.965753)),
            A2(vf, o(.356164, -0.609589), o(.356165, -1.321918)),
            A2(vf, o(0, -0.712329), o(-0.356165, -1.315068)),
            A2(vf, o(-0.356164, -0.60274), o(-0.965753, -0.958905)),
            A2(vf, o(-0.609589, -0.356164), o(-1.321918, -0.356164)),
            A2(vf, o(-0.712329, 0), o(-1.321918, .356164)),
            A2(vf, o(-0.609589, .356164), o(-0.965753, .958905)),
            A2(vf, o(-0.356164, .60274), o(-0.356164, 1.315068)),
            A2(vf, o(0, .712329), o(.356164, 1.321918)),
            A2(vf, o(.356164, .609589), o(.965753, .965753)),
            A2(vf, o(.609589, .356164), o(1.321918, .356165)),
            pf,
            df(o(1.520548, -9.20548)),
            df(o(-6.589041, 6.082192)),
            df(o(10, 0))
        ]), 10)),
        o("7", o(h([
            df(o(3.232877, 3.424658)),
            ef(o(4.424657, -9.041096)),
            ef(o(-5.739726, 0)),
            ef(o(0, -0.50685)),
            ef(o(6.30137, 0)),
            ef(o(0, .50685)),
            ef(o(-4.424657, 9.041096)),
            ef(o(-0.561644, 0)),
            pf,
            df(o(-3.232877, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("8", o(h([
            df(o(5.068493, 3.630137)),
            A2(vf, o(-0.794521, 0), o(-1.472603, -0.39726)),
            A2(vf, o(-0.678082, -0.39726), o(-1.075342, -1.075343)),
            A2(vf, o(-0.39726, -0.678082), o(-0.39726, -1.472602)),
            A2(vf, o(0, -0.90411), o(.506849, -1.643836)),
            A2(vf, o(.506849, -0.739726), o(1.328767, -1.068493)),
            A2(vf, o(-0.534247, -0.30137), o(-0.863014, -0.842466)),
            A2(vf, o(-0.328767, -0.541096), o(-0.328767, -1.171233)),
            A2(vf, o(0, -0.630137), o(.308219, -1.157534)),
            A2(vf, o(.308219, -0.527397), o(.842466, -0.835617)),
            A2(vf, o(.534247, -0.308219), o(1.150685, -0.308219)),
            A2(vf, o(.630137, 0), o(1.157534, .308219)),
            A2(vf, o(.527397, .308219), o(.835617, .835617)),
            A2(vf, o(.308219, .527397), o(.308219, 1.157534)),
            A2(vf, o(0, .643836), o(-0.321918, 1.178082)),
            A2(vf, o(-0.321918, .534247), o(-0.869863, .835617)),
            A2(vf, o(.808219, .328767), o(1.321918, 1.068493)),
            A2(vf, o(.513699, .739726), o(.513699, 1.643836)),
            A2(vf, o(0, .794521), o(-0.397261, 1.472602)),
            A2(vf, o(-0.39726, .678082), o(-1.075342, 1.075343)),
            A2(vf, o(-0.678082, .39726), o(-1.472603, .39726)),
            df(o(-1.79452, -7.671233)),
            A2(vf, o(0, .479452), o(.239726, .89726)),
            A2(vf, o(.239726, .417808), o(.657534, .657535)),
            A2(vf, o(.417808, .239726), o(.89726, .239726)),
            A2(vf, o(.479452, 0), o(.89726, -0.239726)),
            A2(vf, o(.417808, -0.239726), o(.657535, -0.657535)),
            A2(vf, o(.239726, -0.417808), o(.239726, -0.89726)),
            A2(vf, o(0, -0.479452), o(-0.239726, -0.89726)),
            A2(vf, o(-0.239726, -0.417808), o(-0.657535, -0.657534)),
            A2(vf, o(-0.417808, -0.239726), o(-0.89726, -0.239726)),
            A2(vf, o(-0.479452, 0), o(-0.89726, .239726)),
            A2(vf, o(-0.417808, .239726), o(-0.657534, .657534)),
            A2(vf, o(-0.239726, .417808), o(-0.239726, .89726)),
            df(o(1.79452, 7.164384)),
            A2(vf, o(.657534, 0), o(1.219178, -0.328767)),
            A2(vf, o(.561644, -0.328767), o(.890411, -0.890411)),
            A2(vf, o(.328767, -0.561644), o(.328767, -1.219178)),
            A2(vf, o(0, -0.657534), o(-0.328767, -1.219179)),
            A2(vf, o(-0.328767, -0.561644), o(-0.890411, -0.890411)),
            A2(vf, o(-0.561644, -0.328767), o(-1.219178, -0.328767)),
            A2(vf, o(-0.657534, 0), o(-1.219178, .328767)),
            A2(vf, o(-0.561644, .328767), o(-0.890411, .890411)),
            A2(vf, o(-0.328767, .561644), o(-0.328767, 1.219179)),
            A2(vf, o(0, .657534), o(.328767, 1.219178)),
            A2(vf, o(.328767, .561644), o(.890411, .890411)),
            A2(vf, o(.561644, .328767), o(1.219178, .328767)),
            pf,
            df(o(-1.79452, -7.164384)),
            df(o(1.79452, 7.671233)),
            df(o(-5.068493, -3.630137)),
            df(o(10, 0))
        ]), 10)),
        o("9", o(h([
            df(o(3.547945, 3.424658)),
            ef(o(2.643836, -3.643836)),
            A2(vf, o(-0.506849, .205479), o(-1.123288, .205479)),
            A2(vf, o(-0.849315, 0), o(-1.568493, -0.424657)),
            A2(vf, o(-0.719178, -0.424658), o(-1.143836, -1.143836)),
            A2(vf, o(-0.424658, -0.719178), o(-0.424657, -1.568493)),
            A2(vf, o(0, -0.849315), o(.424657, -1.575342)),
            A2(vf, o(.424658, -0.726027), o(1.143836, -1.143836)),
            A2(vf, o(.719178, -0.417808), o(1.568493, -0.417808)),
            A2(vf, o(.849315, 0), o(1.568493, .417808)),
            A2(vf, o(.719178, .417808), o(1.143836, 1.143836)),
            A2(vf, o(.424658, .726027), o(.424657, 1.575342)),
            A2(vf, o(0, 1.027397), o(-0.602739, 1.849315)),
            ef(o(0, .013699)),
            ef(o(-3.438356, 4.712329)),
            ef(o(-0.616439, 0)),
            df(o(-1.123287, -6.575343)),
            A2(vf, o(0, .712329), o(.356164, 1.315069)),
            A2(vf, o(.356164, .60274), o(.965753, .958904)),
            A2(vf, o(.609589, .356164), o(1.321918, .356164)),
            A2(vf, o(.712329, 0), o(1.321918, -0.356164)),
            A2(vf, o(.609589, -0.356164), o(.965753, -0.958904)),
            A2(vf, o(.356164, -0.60274), o(.356165, -1.315069)),
            A2(vf, o(0, -0.712329), o(-0.356165, -1.321918)),
            A2(vf, o(-0.356164, -0.609589), o(-0.965753, -0.965753)),
            A2(vf, o(-0.609589, -0.356164), o(-1.321918, -0.356165)),
            A2(vf, o(-0.712329, 0), o(-1.321918, .356165)),
            A2(vf, o(-0.609589, .356164), o(-0.965753, .965753)),
            A2(vf, o(-0.356164, .609589), o(-0.356164, 1.321918)),
            pf,
            df(o(1.123287, 6.575343)),
            df(o(-3.547945, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("A", o(h([
            df(o(9.561644, 3.424658)),
            ef(o(-8.986302, 0)),
            ef(o(4.493151, -9.739726)),
            ef(o(4.493151, 9.739726)),
            df(o(-8.191781, -0.50685)),
            ef(o(7.39726, 0)),
            ef(o(-3.69863, -8.027397)),
            ef(o(-3.69863, 8.027397)),
            pf,
            df(o(8.191781, .50685)),
            df(o(-9.561644, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("B", o(h([
            df(o(5.739726, -6.109589)),
            A2(vf, o(.90411, 0), o(1.438356, .273973)),
            A2(vf, o(.643836, .328767), o(.993151, .904109)),
            A2(vf, o(.349315, .575342), o(.349315, 1.287671)),
            A2(vf, o(0, .671233), o(-0.356164, 1.239726)),
            A2(vf, o(-0.356164, .568493), o(-0.972603, .897261)),
            A2(vf, o(.739726, .260274), o(1.246575, .904109)),
            A2(vf, o(.506849, .643836), o(.506849, 1.452055)),
            A2(vf, o(0, .712329), o(-0.363013, 1.308219)),
            A2(vf, o(-0.363014, .59589), o(-0.965754, .938356)),
            A2(vf, o(-0.30137, .164384), o(-0.671233, .246576)),
            A2(vf, o(-0.369863, .082192), o(-0.986301, .082192)),
            ef(o(-4.219178, 0)),
            ef(o(0, -9.534247)),
            ef(o(4, 0)),
            pf,
            df(o(-5.739726, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("C", o(h([
            df(o(9, -0.178082)),
            A2(vf, o(.013699, 1.794521), o(-1.027397, 2.80137)),
            A2(vf, o(-1.041096, 1.006849), o(-2.863014, 1.006849)),
            A2(vf, o(-1.082192, 0), o(-1.993151, -0.493151)),
            A2(vf, o(-0.910959, -0.493151), o(-1.445205, -1.39726)),
            A2(vf, o(-0.534247, -0.90411), o(-0.534247, -2.082192)),
            ef(o(0, -2)),
            A2(vf, o(0, -1.164384), o(.513699, -2.068493)),
            A2(vf, o(.513699, -0.90411), o(1.410959, -1.404109)),
            A2(vf, o(.89726, -0.5), o(2.006849, -0.5)),
            A2(vf, o(1.821918, 0), o(2.856165, .99315)),
            A2(vf, o(1.034247, .993151), o(1.047945, 2.80137)),
            ef(o(-2.465754, 0)),
            A2(vf, o(-0.013699, -0.69863), o(-0.376712, -1.082192)),
            A2(vf, o(-0.363014, -0.383562), o(-1.061644, -0.383561)),
            A2(vf, o(-0.630137, 0), o(-1.041096, .39726)),
            A2(vf, o(-0.410959, .39726), o(-0.410959, 1.123288)),
            ef(o(0, 2.232876)),
            A2(vf, o(0, .726027), o(.431507, 1.130137)),
            A2(vf, o(.431507, .40411), o(1.061644, .40411)),
            A2(vf, o(1.438356, 0), o(1.438356, -1.479452)),
            ef(o(2.452055, 0)),
            pf,
            df(o(-9, .178082)),
            df(o(10, 0))
        ]), 10)),
        o("D", o(h([
            df(o(1.643836, 3.424658)),
            ef(o(0, -9.534247)),
            ef(o(3.547945, 0)),
            A2(vf, o(1.041096, 0), o(1.924657, .520548)),
            A2(vf, o(.883562, .520548), o(1.40411, 1.404109)),
            A2(vf, o(.520548, .883562), o(.520548, 1.924658)),
            ef(o(0, 1.835616)),
            A2(vf, o(0, 1.041096), o(-0.520548, 1.924658)),
            A2(vf, o(-0.520548, .883562), o(-1.40411, 1.40411)),
            A2(vf, o(-0.883562, .520548), o(-1.924657, .520548)),
            ef(o(-3.547945, 0)),
            pf,
            df(o(-1.643836, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("E", o(h([
            df(o(1.643836, -6.109589)),
            ef(o(6.945205, 0)),
            ef(o(0, 2.410959)),
            ef(o(-4.452055, 0)),
            ef(o(0, 1.205479)),
            ef(o(3.69863, 0)),
            ef(o(0, 2.287672)),
            ef(o(-3.69863, 0)),
            ef(o(0, 1.219178)),
            ef(o(4.452055, 0)),
            ef(o(0, 2.410959)),
            ef(o(-6.945205, 0)),
            ef(o(0, -9.534247)),
            pf,
            df(o(-1.643836, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("F", o(h([
            df(o(8.849315, -6.109589)),
            ef(o(0, .506849)),
            ef(o(-6.561644, 0)),
            ef(o(0, 3.054795)),
            ef(o(5.260274, 0)),
            ef(o(0, 2.410959)),
            ef(o(-5.260274, 0)),
            ef(o(0, 3.561644)),
            ef(o(-0.506849, 0)),
            ef(o(0, -9.534247)),
            ef(o(7.068493, 0)),
            pf,
            df(o(-8.849315, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("G", o(h([
            df(o(5, -5.808219)),
            A2(vf, o(-0.917808, 0), o(-1.705479, .458904)),
            A2(vf, o(-0.787671, .458904), o(-1.253425, 1.246575)),
            A2(vf, o(-0.465753, .787671), o(-0.465754, 1.719178)),
            ef(o(0, 1.80822)),
            A2(vf, o(0, .972603), o(.273973, 1.602739)),
            A2(vf, o(.383562, .890411), o(1.164384, 1.452055)),
            A2(vf, o(.780822, .561644), o(1.753424, .630137)),
            ef(o(0, -4.452055)),
            ef(o(4.178082, 0)),
            ef(o(0, .90411)),
            A2(vf, o(0, .876712), o(-0.260273, 1.561644)),
            A2(vf, o(-0.424658, 1.136986), o(-1.424658, 1.821917)),
            A2(vf, o(-1, .684932), o(-2.260274, .684932)),
            A2(vf, o(-1.191781, 0), o(-2.171233, -0.650685)),
            A2(vf, o(-0.979452, -0.650685), o(-1.431507, -1.732877)),
            A2(vf, o(-0.328767, -0.767123), o(-0.328767, -1.821917)),
            ef(o(0, -1.80822)),
            A2(vf, o(0, -1.068493), o(.527397, -1.972602)),
            A2(vf, o(.527397, -0.90411), o(1.431507, -1.431507)),
            A2(vf, o(.90411, -0.527397), o(1.972603, -0.527397)),
            A2(vf, o(.890411, 0), o(1.630137, .29452)),
            A2(vf, o(.739726, .294521), o(1.260274, .856164)),
            A2(vf, o(.424658, .465753), o(.691781, 1.041096)),
            A2(vf, o(.267123, .575342), o(.267123, 1.164384)),
            ef(o(-0.493151, 0)),
            A2(vf, o(-0.013699, -0.506849), o(-0.253424, -1)),
            A2(vf, o(-0.239726, -0.493151), o(-0.609589, -0.890411)),
            A2(vf, o(-0.917808, -0.958904), o(-2.493151, -0.958904)),
            df(o(3.438356, 4.958904)),
            ef(o(-3.178082, 0)),
            ef(o(0, 3.958904)),
            A2(vf, o(.986301, -0.068493), o(1.773973, -0.623288)),
            A2(vf, o(.787671, -0.554795), o(1.157534, -1.472602)),
            A2(vf, o(.246575, -0.643836), o(.246575, -1.452055)),
            ef(o(0, -0.410959)),
            pf,
            df(o(-3.438356, -4.958904)),
            df(o(-5, 5.808219)),
            df(o(10, 0))
        ]), 10)),
        o("H", o(h([
            df(o(1.39726, 3.424658)),
            ef(o(0, -9.534247)),
            ef(o(.50685, 0)),
            ef(o(0, 2.69863)),
            A2(vf, o(1.410959, 0), o(2.671232, .541096)),
            A2(vf, o(1.260274, .541096), o(2.20548, 1.506849)),
            A2(vf, o(.945205, .965753), o(1.452055, 2.212329)),
            ef(o(0, -6.958904)),
            ef(o(.506849, 0)),
            ef(o(0, 9.534247)),
            ef(o(-0.506849, 0)),
            A2(vf, o(0, -1.712329), o(-0.849315, -3.171233)),
            A2(vf, o(-0.849315, -1.458904), o(-2.30822, -2.30822)),
            A2(vf, o(-1.458904, -0.849315), o(-3.171232, -0.849315)),
            ef(o(0, 6.328768)),
            ef(o(-0.50685, 0)),
            pf,
            df(o(-1.39726, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("I", o(h([
            df(o(1.986301, -3.69863)),
            ef(o(0, -2.410959)),
            ef(o(6.164384, 0)),
            ef(o(0, 2.410959)),
            ef(o(-2.835617, 0)),
            ef(o(0, 4.712329)),
            ef(o(2.835617, 0)),
            ef(o(0, 2.410959)),
            ef(o(-6.164384, 0)),
            ef(o(0, -2.410959)),
            ef(o(2.835617, 0)),
            ef(o(0, -4.712329)),
            ef(o(-2.835617, 0)),
            pf,
            df(o(-1.986301, 3.69863)),
            df(o(10, 0))
        ]), 10)),
        o("J", o(h([
            df(o(6.30137, -3.69863)),
            ef(o(-2.684932, 0)),
            ef(o(0, -2.410959)),
            ef(o(5.178083, 0)),
            ef(o(0, 5.657534)),
            A2(vf, o(0, 1.273973), o(-0.50685, 2.19863)),
            A2(vf, o(-0.506849, .924658), o(-1.390411, 1.40411)),
            A2(vf, o(-0.883562, .479452), o(-1.965753, .479452)),
            A2(vf, o(-1.041096, 0), o(-1.924658, -0.520548)),
            A2(vf, o(-0.883562, -0.520548), o(-1.404109, -1.40411)),
            A2(vf, o(-0.520548, -0.883562), o(-0.520548, -1.924657)),
            ef(o(2.49315, 0)),
            A2(vf, o(0, .630137), o(.363014, 1.054794)),
            A2(vf, o(.363014, .424658), o(.979452, .424658)),
            A2(vf, o(.657534, 0), o(1.020548, -0.417808)),
            A2(vf, o(.363014, -0.417808), o(.363014, -1.226028)),
            ef(o(0, -3.315068)),
            pf,
            df(o(-6.30137, 3.69863)),
            df(o(10, 0))
        ]), 10)),
        o("K", o(h([
            df(o(5.205479, -2.136986)),
            ef(o(3.972603, 5.561644)),
            ef(o(-7.671233, 0)),
            ef(o(0, -9.534247)),
            ef(o(7.671233, 0)),
            ef(o(-3.972603, 3.972603)),
            df(o(-0.356164, .356164)),
            ef(o(-2.835616, 2.835617)),
            ef(o(0, 1.863013)),
            ef(o(6.19178, 0)),
            ef(o(-3.356164, -4.69863)),
            pf,
            df(o(.356164, -0.356164)),
            df(o(-5.205479, 2.136986)),
            df(o(10, 0))
        ]), 10)),
        o("L", o(h([
            df(o(9.232877, 1)),
            ef(o(0, 2.424658)),
            ef(o(-7.260274, 0)),
            ef(o(0, -9.534247)),
            ef(o(.506849, 0)),
            ef(o(0, 7.109589)),
            ef(o(6.753425, 0)),
            pf,
            df(o(-9.232877, -1)),
            df(o(10, 0))
        ]), 10)),
        o("M", o(h([
            df(o(1.219178, -6.123288)),
            ef(o(.547945, 0)),
            ef(o(3.328767, 5.890411)),
            ef(o(3.315069, -5.890411)),
            ef(o(.506849, 0)),
            ef(o(0, 9.534247)),
            ef(o(-7.69863, 0)),
            ef(o(0, -9.534247)),
            df(o(.506849, 9.041096)),
            ef(o(6.684932, 0)),
            ef(o(0, -8.013698)),
            ef(o(-3.082192, 5.424657)),
            ef(o(-0.479452, 0)),
            ef(o(-3.123288, -5.506849)),
            ef(o(0, 8.09589)),
            pf,
            df(o(-0.506849, -9.041096)),
            df(o(-1.219178, 6.123288)),
            df(o(10, 0))
        ]), 10)),
        o("N", o(h([
            df(o(1.356164, 3.410959)),
            ef(o(0, -9.534247)),
            ef(o(.534247, 0)),
            ef(o(6.657534, 6.479452)),
            ef(o(0, -6.479452)),
            ef(o(.50685, 0)),
            ef(o(0, 9.534247)),
            ef(o(-7.698631, 0)),
            pf,
            df(o(-1.356164, -3.410959)),
            df(o(10, 0))
        ]), 10)),
        o("O", o(h([
            df(o(1.09589, -2.39726)),
            A2(vf, o(0, -1.068493), o(.534247, -1.986302)),
            A2(vf, o(.534247, -0.917808), o(1.445205, -1.452054)),
            A2(vf, o(.910959, -0.534247), o(1.993151, -0.534247)),
            A2(vf, o(1.082192, 0), o(1.993151, .534247)),
            A2(vf, o(.910959, .534247), o(1.445205, 1.452054)),
            A2(vf, o(.534247, .917808), o(.534247, 1.986302)),
            ef(o(0, 2.109589)),
            A2(vf, o(0, 1.068493), o(-0.534247, 1.986301)),
            A2(vf, o(-0.534247, .917808), o(-1.445205, 1.452055)),
            A2(vf, o(-0.910959, .534247), o(-1.993151, .534247)),
            A2(vf, o(-1.082192, 0), o(-1.993151, -0.534247)),
            A2(vf, o(-0.910959, -0.534247), o(-1.445205, -1.452055)),
            A2(vf, o(-0.534247, -0.917808), o(-0.534247, -1.986301)),
            ef(o(0, -2.109589)),
            df(o(2.493151, 2.109589)),
            A2(vf, o(0, .657534), o(.410959, 1.123287)),
            A2(vf, o(.410959, .465753), o(1.068493, .465754)),
            A2(vf, o(.643836, 0), o(1.054795, -0.465754)),
            A2(vf, o(.410959, -0.465753), o(.410959, -1.123287)),
            ef(o(0, -2.123288)),
            A2(vf, o(0, -0.671233), o(-0.410959, -1.123288)),
            A2(vf, o(-0.410959, -0.452055), o(-1.054795, -0.452054)),
            A2(vf, o(-0.657534, 0), o(-1.068493, .452054)),
            A2(vf, o(-0.410959, .452055), o(-0.410959, 1.123288)),
            ef(o(0, 2.123288)),
            pf,
            df(o(-2.493151, -2.109589)),
            df(o(-1.09589, 2.39726)),
            df(o(10, 0))
        ]), 10)),
        o("P", o(h([
            df(o(1.90411, 3.424658)),
            ef(o(0, -9.534247)),
            ef(o(3.986301, 0)),
            A2(vf, o(1, 0), o(1.726027, .369863)),
            A2(vf, o(.835616, .424658), o(1.328767, 1.212329)),
            A2(vf, o(.493151, .787671), o(.493151, 1.732876)),
            A2(vf, o(0, .945205), o(-0.486301, 1.739726)),
            A2(vf, o(-0.486301, .794521), o(-1.321918, 1.219179)),
            A2(vf, o(-0.712329, .369863), o(-1.739726, .369863)),
            ef(o(-1.493151, 0)),
            ef(o(0, 2.890411)),
            ef(o(-2.49315, 0)),
            pf,
            df(o(-1.90411, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("Q", o(h([
            df(o(5.041096, -6.369863)),
            A2(vf, o(1.082192, 0), o(1.993151, .534247)),
            A2(vf, o(.910959, .534247), o(1.445205, 1.445205)),
            A2(vf, o(.534247, .910959), o(.534247, 1.993151)),
            ef(o(0, 2.09589)),
            A2(vf, o(0, .821918), o(-0.342466, 1.616438)),
            ef(o(1.328767, 1.30137)),
            ef(o(-1.684932, 1.753425)),
            ef(o(-1.273972, -1.246575)),
            A2(vf, o(-0.945205, .547945), o(-2, .547945)),
            A2(vf, o(-1.082192, 0), o(-1.993151, -0.534247)),
            A2(vf, o(-0.910959, -0.534247), o(-1.445205, -1.445205)),
            A2(vf, o(-0.534247, -0.910959), o(-0.534247, -1.993151)),
            ef(o(0, -2.09589)),
            A2(vf, o(0, -1.082192), o(.534247, -1.993151)),
            A2(vf, o(.534247, -0.910959), o(1.445205, -1.445205)),
            A2(vf, o(.910959, -0.534247), o(1.993151, -0.534247)),
            df(o(-1.479452, 6.068493)),
            A2(vf, o(0, .60274), o(.431507, 1.041096)),
            A2(vf, o(.431507, .438356), o(1.034246, .438356)),
            A2(vf, o(.60274, 0), o(1.034247, -0.438356)),
            A2(vf, o(.431507, -0.438356), o(.431507, -1.041096)),
            ef(o(0, -2.09589)),
            A2(vf, o(0, -0.60274), o(-0.431507, -1.027398)),
            A2(vf, o(-0.431507, -0.424658), o(-1.034247, -0.424657)),
            A2(vf, o(-0.60274, 0), o(-1.034246, .424657)),
            A2(vf, o(-0.431507, .424658), o(-0.431507, 1.027398)),
            ef(o(0, 2.09589)),
            pf,
            df(o(1.479452, -6.068493)),
            df(o(-5.041096, 6.369863)),
            df(o(10, 0))
        ]), 10)),
        o("R", o(h([
            df(o(9.013699, 3.424658)),
            ef(o(-7.328767, 0)),
            ef(o(0, -9.534247)),
            ef(o(3.712328, 0)),
            A2(vf, o(1.191781, 0), o(1.945206, .424657)),
            A2(vf, o(.739726, .410959), o(1.150685, 1.123288)),
            A2(vf, o(.410959, .712329), o(.410959, 1.575343)),
            A2(vf, o(0, 1.068493), o(-0.657535, 1.910959)),
            A2(vf, o(-0.657534, .842466), o(-1.657534, 1.116438)),
            ef(o(2.424658, 3.383562)),
            df(o(-6.465754, -9.027398)),
            ef(o(3.726028, 5.20548)),
            A2(vf, o(.917808, -0.191781), o(1.520548, -0.917808)),
            A2(vf, o(.60274, -0.726027), o(.602739, -1.671233)),
            A2(vf, o(0, -0.753425), o(-0.369863, -1.369863)),
            A2(vf, o(-0.369863, -0.616438), o(-1.041096, -0.945206)),
            A2(vf, o(-0.60274, -0.30137), o(-1.575342, -0.30137)),
            ef(o(-2.863014, 0)),
            df(o(-0.356164, .328767)),
            ef(o(0, 4.917809)),
            ef(o(3.520548, 0)),
            ef(o(-3.520548, -4.917809)),
            df(o(0, 8.191781)),
            ef(o(5.863014, 0)),
            ef(o(-2, -2.780822)),
            ef(o(-0.424658, .013699)),
            ef(o(-3.438356, 0)),
            ef(o(0, 2.767123)),
            pf,
            df(o(0, -8.191781)),
            df(o(.356164, -0.328767)),
            df(o(6.465754, 9.027398)),
            df(o(-9.013699, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("S", o(h([
            df(o(5.136986, 3.671233)),
            A2(vf, o(-1.986301, 0), o(-3.061644, -0.938356)),
            A2(vf, o(-1.075342, -0.938356), o(-1.061643, -2.815069)),
            ef(o(2.232876, 0)),
            A2(vf, o(-0.013699, .780822), o(.465754, 1.191781)),
            A2(vf, o(.479452, .410959), o(1.342466, .410959)),
            A2(vf, o(.712329, 0), o(1.123287, -0.232877)),
            A2(vf, o(.410959, -0.232877), o(.410959, -0.712329)),
            A2(vf, o(0, -0.39726), o(-0.417808, -0.575342)),
            A2(vf, o(-0.417808, -0.178082), o(-0.828767, -0.253425)),
            A2(vf, o(-0.410959, -0.075342), o(-0.50685, -0.089041)),
            A2(vf, o(-1.054795, -0.205479), o(-1.821917, -0.5)),
            A2(vf, o(-0.767123, -0.294521), o(-1.287672, -0.89726)),
            A2(vf, o(-0.520548, -0.60274), o(-0.520548, -1.589041)),
            A2(vf, o(0, -0.986301), o(.520548, -1.678082)),
            A2(vf, o(.520548, -0.691781), o(1.390411, -1.034247)),
            A2(vf, o(.869863, -0.342466), o(1.897261, -0.342466)),
            A2(vf, o(1.246575, 0), o(2.157534, .465754)),
            A2(vf, o(.910959, .465753), o(1.431507, 1.410959)),
            A2(vf, o(.260274, .452055), o(.315068, .869863)),
            A2(vf, o(.054795, .417808), o(.054795, .815068)),
            ef(o(-2.232877, 0)),
            A2(vf, o(0, -0.739726), o(-0.39726, -1.089041)),
            A2(vf, o(-0.39726, -0.349315), o(-1.232877, -0.349315)),
            A2(vf, o(-0.671233, 0), o(-1.041096, .232877)),
            A2(vf, o(-0.369863, .232877), o(-0.369863, .630137)),
            A2(vf, o(0, .438356), o(.493151, .643835)),
            A2(vf, o(.493151, .205479), o(1.246575, .369863)),
            A2(vf, o(1.232877, .246575), o(1.924658, .472603)),
            A2(vf, o(.691781, .226027), o(1.19863, .80137)),
            A2(vf, o(.506849, .575342), o(.506849, 1.616438)),
            A2(vf, o(0, .986301), o(-0.547945, 1.69863)),
            A2(vf, o(-0.547945, .712329), o(-1.445206, 1.089042)),
            A2(vf, o(-0.89726, .376712), o(-1.938356, .376712)),
            pf,
            df(o(-5.136986, -3.671233)),
            df(o(10, 0))
        ]), 10)),
        o("T", o(h([
            df(o(4.821918, 3.424658)),
            ef(o(0, -7.123288)),
            ef(o(-3.60274, 0)),
            ef(o(0, -2.410959)),
            ef(o(7.69863, 0)),
            ef(o(0, 2.410959)),
            ef(o(-3.60274, 0)),
            ef(o(0, 7.123288)),
            ef(o(-0.49315, 0)),
            pf,
            df(o(-4.821918, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("U", o(h([
            df(o(5.068493, 3.630137)),
            A2(vf, o(-1.041096, 0), o(-1.924657, -0.520548)),
            A2(vf, o(-0.883562, -0.520548), o(-1.40411, -1.40411)),
            A2(vf, o(-0.520548, -0.883562), o(-0.520548, -1.924657)),
            ef(o(0, -5.890411)),
            ef(o(7.69863, 0)),
            ef(o(0, 5.890411)),
            A2(vf, o(0, 1.041096), o(-0.520548, 1.924657)),
            A2(vf, o(-0.520548, .883562), o(-1.404109, 1.40411)),
            A2(vf, o(-0.883562, .520548), o(-1.924658, .520548)),
            pf,
            df(o(-5.068493, -3.630137)),
            df(o(10, 0))
        ]), 10)),
        o("V", o(h([
            df(o(.575342, -6.123288)),
            ef(o(8.986302, 0)),
            ef(o(-4.493151, 9.739726)),
            ef(o(-4.493151, -9.739726)),
            df(o(4.493151, 8.534247)),
            ef(o(3.712329, -8.027397)),
            ef(o(-7.410959, 0)),
            ef(o(3.69863, 8.027397)),
            pf,
            df(o(-4.493151, -8.534247)),
            df(o(-0.575342, 6.123288)),
            df(o(10, 0))
        ]), 10)),
        o("W", o(h([
            df(o(4.808219, -2.849315)),
            ef(o(-0.876712, -3.260274)),
            ef(o(5.657534, 0)),
            ef(o(-2.561644, 9.534247)),
            ef(o(-0.534246, 0)),
            ef(o(-1.424658, -5.30137)),
            ef(o(-1.424657, 5.30137)),
            ef(o(-0.534247, 0)),
            ef(o(-2.561644, -9.534247)),
            ef(o(.520548, 0)),
            ef(o(2.30137, 8.589041)),
            ef(o(1.438356, -5.328767)),
            df(o(4.123288, -2.753425)),
            ef(o(-4.342466, 0)),
            ef(o(.739726, 2.753425)),
            ef(o(1.438356, 5.328767)),
            ef(o(2.164384, -8.082192)),
            pf,
            df(o(-4.123288, 2.753425)),
            df(o(-4.808219, 2.849315)),
            df(o(10, 0))
        ]), 10)),
        o("X", o(h([
            df(o(1.027397, 3.424658)),
            ef(o(3.739726, -4.767124)),
            ef(o(-3.739726, -4.767123)),
            ef(o(8.095891, 0)),
            ef(o(-3.739726, 4.767123)),
            ef(o(3.739726, 4.767124)),
            ef(o(-8.095891, 0)),
            df(o(4.041096, -5.178083)),
            ef(o(3.027397, -3.849315)),
            ef(o(-6.041095, 0)),
            ef(o(3.013698, 3.849315)),
            df(o(3.027397, 4.671233)),
            ef(o(-3.027397, -3.849315)),
            ef(o(-3.013698, 3.849315)),
            ef(o(6.041095, 0)),
            pf,
            df(o(-3.027397, -4.671233)),
            df(o(-4.041096, 5.178083)),
            df(o(-1.027397, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("Y", o(h([
            df(o(1, -6.109589)),
            ef(o(8.136986, 0)),
            ef(o(-3.808219, 5.630137)),
            ef(o(0, 3.90411)),
            ef(o(-0.506849, 0)),
            ef(o(0, -3.90411)),
            ef(o(-3.821918, -5.630137)),
            pf,
            df(o(-1, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("Z", o(h([
            df(o(7.958904, -5.60274)),
            ef(o(-6.273972, 0)),
            ef(o(0, -0.506849)),
            ef(o(6.931506, 0)),
            ef(o(0, 9.534247)),
            ef(o(-7.082191, 0)),
            ef(o(0, -0.50685)),
            ef(o(6.424657, -8.520548)),
            df(o(.150685, 8.520548)),
            ef(o(0, -7.876712)),
            ef(o(-5.945205, 7.876712)),
            ef(o(5.945205, 0)),
            pf,
            df(o(-0.150685, -8.520548)),
            df(o(-7.958904, 5.60274)),
            df(o(10, 0))
        ]), 10)),
        o("a", o(h([
            df(o(4.808219, -6.109589)),
            ef(o(.534247, 0)),
            ef(o(3.917808, 9.534247)),
            ef(o(-0.547945, 0)),
            ef(o(-1.287671, -3.150685)),
            ef(o(-4.698631, 0)),
            ef(o(-1.301369, 3.150685)),
            ef(o(-0.534247, 0)),
            ef(o(3.917808, -9.534247)),
            df(o(-1.876712, 5.890411)),
            ef(o(4.287671, 0)),
            ef(o(-2.150685, -5.232877)),
            ef(o(-2.136986, 5.232877)),
            pf,
            df(o(1.876712, -5.890411)),
            df(o(-4.808219, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("b", o(h([
            df(o(6.986301, -5.835616)),
            A2(vf, o(.643836, .328767), o(.993151, .904109)),
            A2(vf, o(.349315, .575342), o(.349315, 1.287671)),
            A2(vf, o(0, .671233), o(-0.349315, 1.239726)),
            A2(vf, o(-0.349315, .568493), o(-0.965753, .897261)),
            A2(vf, o(.726027, .246575), o(1.205479, .904109)),
            A2(vf, o(.479452, .657534), o(.479452, 1.452055)),
            A2(vf, o(0, .712329), o(-0.356164, 1.315069)),
            A2(vf, o(-0.356164, .60274), o(-0.945206, .931506)),
            A2(vf, o(-0.30137, .164384), o(-0.671233, .246576)),
            A2(vf, o(-0.369863, .082192), o(-0.986301, .082192)),
            ef(o(-4, 0)),
            ef(o(0, -9.534247)),
            ef(o(3.808219, 0)),
            A2(vf, o(.90411, 0), o(1.438356, .273973)),
            df(o(-0.219178, 3.931506)),
            A2(vf, o(.493151, -0.246575), o(.780822, -0.712328)),
            A2(vf, o(.287671, -0.465753), o(.287671, -1.027398)),
            A2(vf, o(0, -0.630137), o(-0.328767, -1.102739)),
            A2(vf, o(-0.328767, -0.472603), o(-0.835616, -0.691781)),
            A2(vf, o(-0.383562, -0.164384), o(-1.287671, -0.164384)),
            ef(o(-3.150685, 0)),
            ef(o(0, 3.917808)),
            ef(o(3.39726, 0)),
            A2(vf, o(.712329, 0), o(1.136986, -0.219178)),
            df(o(.328767, 4.616439)),
            A2(vf, o(.506849, -0.260274), o(.80822, -0.760274)),
            A2(vf, o(.30137, -0.5), o(.301369, -1.089041)),
            A2(vf, o(0, -0.616438), o(-0.315068, -1.116439)),
            A2(vf, o(-0.315068, -0.5), o(-0.849315, -0.746575)),
            A2(vf, o(-0.410959, -0.191781), o(-1.109589, -0.191781)),
            ef(o(-3.69863, 0)),
            ef(o(0, 4.123288)),
            ef(o(3.520548, 0)),
            A2(vf, o(.520548, 0), o(.821917, -0.054795)),
            A2(vf, o(.30137, -0.054795), o(.520548, -0.164383)),
            pf,
            df(o(-0.328767, -4.616439)),
            df(o(.219178, -3.931506)),
            df(o(-6.986301, 5.835616)),
            df(o(10, 0))
        ]), 10)),
        o("c", o(h([
            df(o(1.794521, -0.219178)),
            A2(vf, o(0, .90411), o(.458904, 1.671233)),
            A2(vf, o(.458904, .767123), o(1.232876, 1.219178)),
            A2(vf, o(.773973, .452055), o(1.678083, .452055)),
            A2(vf, o(.931507, 0), o(1.684931, -0.369863)),
            A2(vf, o(.753425, -0.369863), o(1.184932, -1.027398)),
            A2(vf, o(.431507, -0.657534), o(.445205, -1.479452)),
            ef(o(.493151, 0)),
            A2(vf, o(0, .945205), o(-0.5, 1.719178)),
            A2(vf, o(-0.5, .773973), o(-1.369863, 1.219179)),
            A2(vf, o(-0.869863, .445205), o(-1.938356, .445205)),
            A2(vf, o(-1.041096, 0), o(-1.931507, -0.520548)),
            A2(vf, o(-0.890411, -0.520548), o(-1.410959, -1.40411)),
            A2(vf, o(-0.520548, -0.883562), o(-0.520548, -1.924657)),
            ef(o(0, -2.246575)),
            A2(vf, o(0, -1.041096), o(.513698, -1.924658)),
            A2(vf, o(.513699, -0.883562), o(1.397261, -1.40411)),
            A2(vf, o(.883562, -0.520548), o(1.924657, -0.520547)),
            A2(vf, o(1.054795, 0), o(1.924658, .445205)),
            A2(vf, o(.869863, .445205), o(1.376712, 1.219178)),
            A2(vf, o(.506849, .773973), o(.506849, 1.719178)),
            ef(o(-0.49315, 0)),
            A2(vf, o(-0.013699, -0.821918), o(-0.452055, -1.479452)),
            A2(vf, o(-0.438356, -0.657534), o(-1.184932, -1.027397)),
            A2(vf, o(-0.746575, -0.369863), o(-1.678082, -0.369863)),
            A2(vf, o(-0.90411, 0), o(-1.671233, .452055)),
            A2(vf, o(-0.767123, .452055), o(-1.219178, 1.219178)),
            A2(vf, o(-0.452055, .767123), o(-0.452054, 1.671233)),
            ef(o(0, 2.246575)),
            pf,
            df(o(-1.794521, .219178)),
            df(o(10, 0))
        ]), 10)),
        o("d", o(h([
            df(o(4.972603, -6.109589)),
            A2(vf, o(1.041096, 0), o(1.924657, .520548)),
            A2(vf, o(.883562, .520548), o(1.40411, 1.404109)),
            A2(vf, o(.520548, .883562), o(.520548, 1.924658)),
            ef(o(0, 1.835616)),
            A2(vf, o(0, 1.041096), o(-0.520548, 1.924658)),
            A2(vf, o(-0.520548, .883562), o(-1.40411, 1.40411)),
            A2(vf, o(-0.883562, .520548), o(-1.924657, .520548)),
            ef(o(-3.520548, 0)),
            ef(o(0, -9.534247)),
            ef(o(3.520548, 0)),
            df(o(3.342465, 3.849315)),
            A2(vf, o(0, -0.90411), o(-0.452054, -1.671233)),
            A2(vf, o(-0.452055, -0.767123), o(-1.226028, -1.219178)),
            A2(vf, o(-0.773973, -0.452055), o(-1.678082, -0.452055)),
            ef(o(-3, 0)),
            ef(o(0, 8.520548)),
            ef(o(3, 0)),
            A2(vf, o(.90411, 0), o(1.678082, -0.452055)),
            A2(vf, o(.773973, -0.452055), o(1.226028, -1.219178)),
            A2(vf, o(.452055, -0.767123), o(.452054, -1.671233)),
            ef(o(0, -1.835616)),
            pf,
            df(o(-3.342465, -3.849315)),
            df(o(-4.972603, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("e", o(h([
            df(o(1.780822, -6.109589)),
            ef(o(6.712329, 0)),
            ef(o(0, .506849)),
            ef(o(-6.20548, 0)),
            ef(o(0, 3.863014)),
            ef(o(5.397261, 0)),
            ef(o(0, .506849)),
            ef(o(-5.397261, 0)),
            ef(o(0, 4.150685)),
            ef(o(6.20548, 0)),
            ef(o(0, .50685)),
            ef(o(-6.712329, 0)),
            ef(o(0, -9.534247)),
            pf,
            df(o(-1.780822, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("f", o(h([
            df(o(1.90411, -6.109589)),
            ef(o(7.109589, 0)),
            ef(o(0, .506849)),
            ef(o(-6.60274, 0)),
            ef(o(0, 4)),
            ef(o(5.342466, 0)),
            ef(o(0, .50685)),
            ef(o(-5.342466, 0)),
            ef(o(0, 4.520548)),
            ef(o(-0.506849, 0)),
            ef(o(0, -9.534247)),
            pf,
            df(o(-1.90411, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("g", o(h([
            df(o(8.424658, 1.465753)),
            A2(vf, o(-0.369863, .945205), o(-1.342466, 1.554795)),
            A2(vf, o(-0.972603, .609589), o(-2.082192, .609589)),
            A2(vf, o(-1.068493, 0), o(-1.972603, -0.534247)),
            A2(vf, o(-0.90411, -0.534247), o(-1.431507, -1.472602)),
            A2(vf, o(-0.527397, -0.938356), o(-0.527397, -2.061644)),
            ef(o(0, -1.917808)),
            A2(vf, o(0, -1.09589), o(.527397, -2)),
            A2(vf, o(.527397, -0.90411), o(1.424658, -1.431507)),
            A2(vf, o(.89726, -0.527397), o(1.979452, -0.527397)),
            A2(vf, o(.890411, 0), o(1.630137, .29452)),
            A2(vf, o(.739726, .294521), o(1.260274, .856164)),
            A2(vf, o(.424658, .465753), o(.691781, 1.041096)),
            A2(vf, o(.267123, .575342), o(.267123, 1.164384)),
            ef(o(-0.493151, 0)),
            A2(vf, o(-0.013699, -0.506849), o(-0.253424, -1)),
            A2(vf, o(-0.239726, -0.493151), o(-0.609589, -0.890411)),
            A2(vf, o(-0.917808, -0.958904), o(-2.493151, -0.958904)),
            A2(vf, o(-0.945205, 0), o(-1.732877, .458904)),
            A2(vf, o(-0.787671, .458904), o(-1.239726, 1.246575)),
            A2(vf, o(-0.452055, .787671), o(-0.452055, 1.746576)),
            ef(o(0, 1.917808)),
            A2(vf, o(0, 1), o(.458905, 1.815068)),
            A2(vf, o(.458904, .815068), o(1.246575, 1.280822)),
            A2(vf, o(.787671, .465753), o(1.719178, .465754)),
            A2(vf, o(.945205, 0), o(1.732877, -0.458904)),
            A2(vf, o(.787671, -0.458904), o(1.239726, -1.246576)),
            A2(vf, o(.452055, -0.787671), o(.452055, -1.719178)),
            ef(o(0, -0.479452)),
            ef(o(-3.424658, 0)),
            ef(o(0, -0.506849)),
            ef(o(3.931507, 0)),
            ef(o(0, 4.712329)),
            ef(o(-0.506849, 0)),
            ef(o(0, -1.958905)),
            pf,
            df(o(-8.424658, -1.465753)),
            df(o(10, 0))
        ]), 10)),
        o("h", o(h([
            df(o(1.39726, 3.424658)),
            ef(o(0, -9.534247)),
            ef(o(.50685, 0)),
            ef(o(0, 4.506849)),
            ef(o(6.328767, 0)),
            ef(o(0, -4.506849)),
            ef(o(.506849, 0)),
            ef(o(0, 9.534247)),
            ef(o(-0.506849, 0)),
            ef(o(0, -4.520548)),
            ef(o(-6.328767, 0)),
            ef(o(0, 4.520548)),
            ef(o(-0.50685, 0)),
            pf,
            df(o(-1.39726, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("i", o(h([
            df(o(8.164384, -6.109589)),
            ef(o(0, .506849)),
            ef(o(-2.849316, 0)),
            ef(o(0, 8.520548)),
            ef(o(2.849316, 0)),
            ef(o(0, .50685)),
            ef(o(-6.178083, 0)),
            ef(o(0, -0.50685)),
            ef(o(2.835617, 0)),
            ef(o(0, -8.520548)),
            ef(o(-2.835617, 0)),
            ef(o(0, -0.506849)),
            ef(o(6.178083, 0)),
            pf,
            df(o(-8.164384, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("j", o(h([
            df(o(4.90411, 3.630137)),
            A2(vf, o(-0.972603, 0), o(-1.80822, -0.445205)),
            A2(vf, o(-0.835616, -0.445205), o(-1.369863, -1.226028)),
            A2(vf, o(-0.534247, -0.780822), o(-0.630137, -1.726027)),
            ef(o(.50685, 0)),
            A2(vf, o(.09589, .808219), o(.561644, 1.472602)),
            A2(vf, o(.465753, .664384), o(1.184931, 1.041096)),
            A2(vf, o(.719178, .376712), o(1.554795, .376713)),
            A2(vf, o(.917808, 0), o(1.684931, -0.452055)),
            A2(vf, o(.767123, -0.452055), o(1.219178, -1.246575)),
            A2(vf, o(.452055, -0.794521), o(.452055, -1.780822)),
            ef(o(0, -5.246576)),
            ef(o(-4.273973, 0)),
            ef(o(0, -0.506849)),
            ef(o(4.767124, 0)),
            ef(o(0, 5.753425)),
            A2(vf, o(0, 1.123288), o(-0.513699, 2.034246)),
            A2(vf, o(-0.513699, .910959), o(-1.39726, 1.431507)),
            A2(vf, o(-0.883562, .520548), o(-1.938356, .520548)),
            pf,
            df(o(-4.90411, -3.630137)),
            df(o(10, 0))
        ]), 10)),
        o("k", o(h([
            df(o(2.013699, -6.109589)),
            ef(o(0, 6.452055)),
            ef(o(6.465753, -6.452055)),
            ef(o(.712329, 0)),
            ef(o(-3.986302, 3.972603)),
            ef(o(3.972603, 5.561644)),
            ef(o(-0.60274, 0)),
            ef(o(-3.726027, -5.20548)),
            ef(o(-2.835616, 2.835617)),
            ef(o(0, 2.369863)),
            ef(o(-0.50685, 0)),
            ef(o(0, -9.534247)),
            ef(o(.50685, 0)),
            pf,
            df(o(-2.013699, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("l", o(h([
            df(o(2.123288, 3.424658)),
            ef(o(0, -9.534247)),
            ef(o(.506849, 0)),
            ef(o(0, 9.027397)),
            ef(o(6.643836, 0)),
            ef(o(0, .50685)),
            ef(o(-7.150685, 0)),
            pf,
            df(o(-2.123288, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("m", o(h([
            df(o(1.726027, 3.424658)),
            ef(o(-0.506849, 0)),
            ef(o(0, -9.534247)),
            ef(o(.547945, 0)),
            ef(o(3.328767, 5.876712)),
            ef(o(3.315069, -5.876712)),
            ef(o(.506849, 0)),
            ef(o(0, 9.534247)),
            ef(o(-0.506849, 0)),
            ef(o(0, -8.520548)),
            ef(o(-3.082192, 5.438356)),
            ef(o(-0.479452, 0)),
            ef(o(-3.123288, -5.50685)),
            ef(o(0, 8.589042)),
            pf,
            df(o(-1.726027, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("n", o(h([
            df(o(1.342466, 3.424658)),
            ef(o(0, -9.534247)),
            ef(o(.534246, 0)),
            ef(o(6.657535, 6.465753)),
            ef(o(0, -6.465753)),
            ef(o(.506849, 0)),
            ef(o(0, 9.534247)),
            ef(o(-0.506849, 0)),
            ef(o(0, -2.356165)),
            ef(o(-6.684932, -6.520548)),
            ef(o(0, 8.876713)),
            ef(o(-0.506849, 0)),
            pf,
            df(o(-1.342466, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("o", o(h([
            df(o(5.068493, -6.315068)),
            A2(vf, o(1.068493, 0), o(1.972603, .527397)),
            A2(vf, o(.90411, .527397), o(1.431507, 1.431507)),
            A2(vf, o(.527397, .90411), o(.527397, 1.972602)),
            ef(o(0, 2.082192)),
            A2(vf, o(0, 1.068493), o(-0.527397, 1.972603)),
            A2(vf, o(-0.527397, .90411), o(-1.431507, 1.431507)),
            A2(vf, o(-0.90411, .527397), o(-1.972603, .527397)),
            A2(vf, o(-1.068493, 0), o(-1.972603, -0.527397)),
            A2(vf, o(-0.90411, -0.527397), o(-1.431506, -1.431507)),
            A2(vf, o(-0.527397, -0.90411), o(-0.527398, -1.972603)),
            ef(o(0, -2.082192)),
            A2(vf, o(0, -1.068493), o(.527398, -1.972602)),
            A2(vf, o(.527397, -0.90411), o(1.431506, -1.431507)),
            A2(vf, o(.90411, -0.527397), o(1.972603, -0.527397)),
            df(o(-3.424657, 6.013698)),
            A2(vf, o(0, .931507), o(.458904, 1.719178)),
            A2(vf, o(.458904, .787671), o(1.246575, 1.246576)),
            A2(vf, o(.787671, .458904), o(1.719178, .458904)),
            A2(vf, o(.931507, 0), o(1.719178, -0.458904)),
            A2(vf, o(.787671, -0.458904), o(1.246576, -1.246576)),
            A2(vf, o(.458904, -0.787671), o(.458904, -1.719178)),
            ef(o(0, -2.082192)),
            A2(vf, o(0, -0.931507), o(-0.458904, -1.719178)),
            A2(vf, o(-0.458904, -0.787671), o(-1.246576, -1.246575)),
            A2(vf, o(-0.787671, -0.458904), o(-1.719178, -0.458904)),
            A2(vf, o(-0.931507, 0), o(-1.719178, .458904)),
            A2(vf, o(-0.787671, .458904), o(-1.246575, 1.246575)),
            A2(vf, o(-0.458904, .787671), o(-0.458904, 1.719178)),
            ef(o(0, 2.082192)),
            pf,
            df(o(3.424657, -6.013698)),
            df(o(-5.068493, 6.315068)),
            df(o(10, 0))
        ]), 10)),
        o("p", o(h([
            df(o(2.410959, 3.424658)),
            ef(o(-0.506849, 0)),
            ef(o(0, -9.534247)),
            ef(o(3.835616, 0)),
            A2(vf, o(.958904, 0), o(1.773973, .410959)),
            A2(vf, o(.815068, .410959), o(1.29452, 1.164383)),
            A2(vf, o(.479452, .753425), o(.479452, 1.739726)),
            A2(vf, o(0, .945205), o(-0.486301, 1.739726)),
            A2(vf, o(-0.486301, .794521), o(-1.321918, 1.219179)),
            A2(vf, o(-0.726027, .369863), o(-1.739726, .369863)),
            ef(o(-3.328767, 0)),
            ef(o(0, 2.890411)),
            df(o(0, -3.397261)),
            ef(o(3.328767, 0)),
            A2(vf, o(.876712, 0), o(1.438356, -0.273972)),
            A2(vf, o(.726027, -0.342466), o(1.164384, -1.027398)),
            A2(vf, o(.438356, -0.684932), o(.438356, -1.520548)),
            A2(vf, o(0, -0.821918), o(-0.438356, -1.506849)),
            A2(vf, o(-0.438356, -0.684932), o(-1.178082, -1.027397)),
            A2(vf, o(-0.561644, -0.273973), o(-1.424658, -0.273973)),
            ef(o(-3.328767, 0)),
            ef(o(0, 5.630137)),
            pf,
            df(o(0, 3.397261)),
            df(o(-2.410959, -3.424658)),
            df(o(10, 0))
        ]), 10)),
        o("q", o(h([
            df(o(9.027397, 3.547945)),
            ef(o(-0.369863, .328767)),
            ef(o(-1.068493, -1.219178)),
            A2(vf, o(-0.520548, .465753), o(-1.171233, .712329)),
            A2(vf, o(-0.650685, .246575), o(-1.376712, .246575)),
            A2(vf, o(-1.068493, 0), o(-1.972603, -0.527397)),
            A2(vf, o(-0.90411, -0.527397), o(-1.431507, -1.431507)),
            A2(vf, o(-0.527397, -0.90411), o(-0.527397, -1.972602)),
            ef(o(0, -2.082192)),
            A2(vf, o(0, -1.068493), o(.527397, -1.972603)),
            A2(vf, o(.527397, -0.90411), o(1.431507, -1.431507)),
            A2(vf, o(.90411, -0.527397), o(1.972603, -0.527397)),
            A2(vf, o(1.068493, 0), o(1.972603, .527397)),
            A2(vf, o(.90411, .527397), o(1.431506, 1.431507)),
            A2(vf, o(.527397, .90411), o(.527398, 1.972603)),
            ef(o(0, 2.082192)),
            A2(vf, o(0, .739726), o(-0.267124, 1.417808)),
            A2(vf, o(-0.267123, .678082), o(-0.746575, 1.212328)),
            ef(o(1.068493, 1.232877)),
            df(o(-0.561644, -5.945205)),
            A2(vf, o(0, -0.931507), o(-0.458904, -1.719178)),
            A2(vf, o(-0.458904, -0.787671), o(-1.246575, -1.246576)),
            A2(vf, o(-0.787671, -0.458904), o(-1.719178, -0.458904)),
            A2(vf, o(-0.931507, 0), o(-1.719178, .458904)),
            A2(vf, o(-0.787671, .458904), o(-1.253425, 1.246576)),
            A2(vf, o(-0.465753, .787671), o(-0.465753, 1.719178)),
            ef(o(0, 2.082192)),
            A2(vf, o(0, .931507), o(.465753, 1.719178)),
            A2(vf, o(.465753, .787671), o(1.253425, 1.246575)),
            A2(vf, o(.787671, .458904), o(1.719178, .458904)),
            A2(vf, o(.616438, 0), o(1.184931, -0.212329)),
            A2(vf, o(.568493, -0.212329), o(1.034247, -0.609589)),
            ef(o(-1.438356, -1.643835)),
            ef(o(.383561, -0.328768)),
            ef(o(1.410959, 1.616439)),
            A2(vf, o(.39726, -0.465753), o(.623288, -1.041096)),
            A2(vf, o(.226027, -0.575342), o(.226027, -1.205479)),
            ef(o(0, -2.082192)),
            pf,
            df(o(.561644, 5.945205)),
            df(o(-9.027397, -3.547945)),
            df(o(10, 0))
        ]), 10)),
        o("r", o(h([
            df(o(7.136986, -5.794521)),
            A2(vf, o(.821918, .383562), o(1.294521, 1.136987)),
            A2(vf, o(.472603, .753425), o(.472603, 1.671233)),
            A2(vf, o(0, 1.068493), o(-0.650685, 1.910959)),
            A2(vf, o(-0.650685, .842466), o(-1.664384, 1.116438)),
            ef(o(2.424658, 3.383562)),
            ef(o(-0.60274, 0)),
            ef(o(-2.342466, -3.287672)),
            ef(o(-0.438356, .013699)),
            ef(o(-3.438356, 0)),
            ef(o(0, 3.273973)),
            ef(o(-0.506849, 0)),
            ef(o(0, -9.534247)),
            ef(o(3.630136, 0)),
            A2(vf, o(.60274, 0), o(1.034247, .075342)),
            A2(vf, o(.431507, .075342), o(.787671, .239726)),
            df(o(-1.369863, 5.438357)),
            A2(vf, o(.712329, 0), o(1.315069, -0.356165)),
            A2(vf, o(.60274, -0.356164), o(.958904, -0.958904)),
            A2(vf, o(.356164, -0.60274), o(.356164, -1.315068)),
            A2(vf, o(0, -0.794521), o(-0.417808, -1.438357)),
            A2(vf, o(-0.417808, -0.643836), o(-1.157534, -0.958904)),
            A2(vf, o(-0.534247, -0.219178), o(-1.50685, -0.219178)),
            ef(o(-3.123287, 0)),
            ef(o(0, 5.246576)),
            ef(o(3.575342, 0)),
            pf,
            df(o(1.369863, -5.438357)),
            df(o(-7.136986, 5.794521)),
            df(o(10, 0))
        ]), 10)),
        o("s", o(h([
            df(o(5.273973, -1.136986)),
            A2(vf, o(-1.164384, -0.232877), o(-1.897261, -0.513699)),
            A2(vf, o(-0.732877, -0.280822), o(-1.150685, -0.767123)),
            A2(vf, o(-0.417808, -0.486301), o(-0.417808, -1.253425)),
            A2(vf, o(0, -0.794521), o(.417808, -1.39726)),
            A2(vf, o(.417808, -0.60274), o(1.178083, -0.931507)),
            A2(vf, o(.760274, -0.328767), o(1.760274, -0.328767)),
            A2(vf, o(.958904, 0), o(1.760274, .404109)),
            A2(vf, o(.80137, .40411), o(1.267123, 1.130137)),
            A2(vf, o(.465753, .726027), o(.465753, 1.657535)),
            ef(o(-0.506849, 0)),
            A2(vf, o(0, -0.808219), o(-0.39726, -1.424658)),
            A2(vf, o(-0.39726, -0.616438), o(-1.082192, -0.952055)),
            A2(vf, o(-0.684932, -0.335616), o(-1.520548, -0.335616)),
            A2(vf, o(-0.739726, 0), o(-1.383562, .232877)),
            A2(vf, o(-0.643836, .232877), o(-1.047945, .712328)),
            A2(vf, o(-0.40411, .479452), o(-0.40411, 1.20548)),
            A2(vf, o(0, .657534), o(.383562, 1.047945)),
            A2(vf, o(.383562, .390411), o(1, .59589)),
            A2(vf, o(.616438, .205479), o(1.726028, .438357)),
            A2(vf, o(1.123288, .232877), o(1.746575, .445205)),
            A2(vf, o(.623288, .212329), o(1.054794, .70548)),
            A2(vf, o(.431507, .493151), o(.431507, 1.383561)),
            A2(vf, o(0, .890411), o(-0.472602, 1.5)),
            A2(vf, o(-0.472603, .609589), o(-1.253425, .910959)),
            A2(vf, o(-0.780822, .30137), o(-1.69863, .30137)),
            A2(vf, o(-1.136986, 0), o(-2, -0.424658)),
            A2(vf, o(-0.863014, -0.424658), o(-1.321918, -1.19863)),
            A2(vf, o(-0.458904, -0.773973), o(-0.458904, -1.773972)),
            ef(o(.506849, 0)),
            A2(vf, o(0, .876712), o(.390411, 1.534246)),
            A2(vf, o(.390411, .657534), o(1.130137, 1.020548)),
            A2(vf, o(.739726, .363014), o(1.753425, .363014)),
            A2(vf, o(1.260274, 0), o(2.089041, -0.60274)),
            A2(vf, o(.828767, -0.60274), o(.828767, -1.643835)),
            A2(vf, o(0, -0.712329), o(-0.356164, -1.095891)),
            A2(vf, o(-0.356164, -0.383562), o(-0.897261, -0.554794)),
            A2(vf, o(-0.541096, -0.171233), o(-1.623287, -0.390411)),
            pf,
            df(o(-5.273973, 1.136986)),
            df(o(10, 0))
        ]), 10)),
        o("t", o(h([
            df(o(8.917808, -6.109589)),
            ef(o(0, .506849)),
            ef(o(-3.60274, 0)),
            ef(o(0, 9.027398)),
            ef(o(-0.49315, 0)),
            ef(o(0, -9.027398)),
            ef(o(-3.60274, 0)),
            ef(o(0, -0.506849)),
            ef(o(7.69863, 0)),
            pf,
            df(o(-8.917808, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("u", o(h([
            df(o(1.219178, -6.109589)),
            ef(o(.506849, 0)),
            ef(o(0, 5.890411)),
            A2(vf, o(0, .90411), o(.452055, 1.671233)),
            A2(vf, o(.452055, .767123), o(1.219178, 1.219178)),
            A2(vf, o(.767123, .452055), o(1.671233, .452055)),
            A2(vf, o(.90411, 0), o(1.671233, -0.452055)),
            A2(vf, o(.767123, -0.452055), o(1.219178, -1.219178)),
            A2(vf, o(.452055, -0.767123), o(.452055, -1.671233)),
            ef(o(0, -5.890411)),
            ef(o(.506849, 0)),
            ef(o(0, 5.890411)),
            A2(vf, o(0, 1.041096), o(-0.520548, 1.924657)),
            A2(vf, o(-0.520548, .883562), o(-1.404109, 1.40411)),
            A2(vf, o(-0.883562, .520548), o(-1.924658, .520548)),
            A2(vf, o(-1.041096, 0), o(-1.924657, -0.520548)),
            A2(vf, o(-0.883562, -0.520548), o(-1.40411, -1.40411)),
            A2(vf, o(-0.520548, -0.883562), o(-0.520548, -1.924657)),
            ef(o(0, -5.890411)),
            pf,
            df(o(-1.219178, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("v", o(h([
            df(o(1.410959, -6.109589)),
            ef(o(3.643836, 8.863014)),
            ef(o(3.643835, -8.863014)),
            ef(o(.534247, 0)),
            ef(o(-3.917809, 9.534247)),
            ef(o(-0.534246, 0)),
            ef(o(-3.917808, -9.534247)),
            ef(o(.547945, 0)),
            pf,
            df(o(-1.410959, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("w", o(h([
            df(o(9.589041, -6.109589)),
            ef(o(-2.561644, 9.534247)),
            ef(o(-0.534246, 0)),
            ef(o(-1.424658, -5.30137)),
            ef(o(-1.424657, 5.30137)),
            ef(o(-0.534247, 0)),
            ef(o(-2.561644, -9.534247)),
            ef(o(.520548, 0)),
            ef(o(2.30137, 8.589041)),
            ef(o(1.438356, -5.328767)),
            ef(o(-0.876712, -3.260274)),
            ef(o(.520548, 0)),
            ef(o(.876712, 3.260274)),
            ef(o(1.438356, 5.328767)),
            ef(o(2.30137, -8.589041)),
            ef(o(.520548, 0)),
            pf,
            df(o(-9.589041, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("x", o(h([
            df(o(4.739726, -1.342466)),
            ef(o(-3.657534, -4.767123)),
            ef(o(.657534, 0)),
            ef(o(3.328767, 4.342466)),
            ef(o(3.342466, -4.342466)),
            ef(o(.643836, 0)),
            ef(o(-3.657535, 4.767123)),
            ef(o(3.657535, 4.767124)),
            ef(o(-0.643836, 0)),
            ef(o(-3.342466, -4.342466)),
            ef(o(-3.328767, 4.342466)),
            ef(o(-0.657534, 0)),
            ef(o(3.657534, -4.767124)),
            pf,
            df(o(-4.739726, 1.342466)),
            df(o(10, 0))
        ]), 10)),
        o("y", o(h([
            df(o(1.69863, -6.109589)),
            ef(o(3.383562, 5.09589)),
            ef(o(3.356164, -5.09589)),
            ef(o(.60274, 0)),
            ef(o(-3.712329, 5.630137)),
            ef(o(0, 3.90411)),
            ef(o(-0.506849, 0)),
            ef(o(0, -3.90411)),
            ef(o(-3.726028, -5.630137)),
            ef(o(.60274, 0)),
            pf,
            df(o(-1.69863, 6.109589)),
            df(o(10, 0))
        ]), 10)),
        o("z", o(h([
            df(o(8.616438, -6.109589)),
            ef(o(-0.013698, .506849)),
            ef(o(-6.438356, 8.520548)),
            ef(o(6.452054, 0)),
            ef(o(0, .50685)),
            ef(o(-7.082191, 0)),
            ef(o(0, -0.50685)),
            ef(o(6.424657, -8.520548)),
            ef(o(-6.273972, 0)),
            ef(o(0, -0.506849)),
            ef(o(6.931506, 0)),
            pf,
            df(o(-8.616438, 6.109589)),
            df(o(10, 0))
        ]), 10))
    ])), qf = F2(function(n, r) {
        return 0 > a(n, r) ? n : r;
    }), yf = F5(function(n, r, t, e, u) {
        return {
            $: 9,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), Uf = F3(function(n, r, t) {
        return {
            $: 5,
            a: n,
            b: r,
            c: t
        };
    }), mf = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), Wf = Q, Vf = L, Tf = function(n) {
        var r = n.a, t = n.b;
        return o(Vf(r * r + t * t), A2(Wf, t, r));
    }, Kf = F2(function(n, r) {
        var t = Tf(n).b, e = function(n) {
            var r = Tf(n);
            return sf(o(r.a, r.b + t));
        };
        switch(r.$){
            case 0:
                return df(e(r.a));
            case 1:
                return ef(e(r.a));
            case 5:
                var u = r.b, a = r.c;
                return A3(Uf, e(r.a), e(u), e(a));
            case 6:
                return u = r.b, A2(mf, e(r.a), e(u));
            case 7:
                return u = r.b, A2(vf, e(r.a), e(u));
            case 8:
                return lf(e(r.a));
            case 9:
                var c = r.b, i = r.c, f = r.d;
                return u = r.e, A5(yf, e(r.a), c, i, f, e(u));
            default:
                return r;
        }
    }), kf = function(n) {
        switch(n.$){
            case 0:
                var r = n.a, t = r.b;
                return "m" + gc(s = r.a) + " " + gc(t);
            case 1:
                var e = n.a;
                return t = e.b, "l" + gc(s = e.a) + " " + gc(t);
            case 2:
                return "h" + gc(s = n.a);
            case 3:
                return "v" + gc(t = n.a);
            case 4:
                return "z";
            case 5:
                var u = n.a, a = u.b, c = n.b, i = c.a, o = c.b, f = n.c, s = f.a;
                return t = f.b, "c" + gc(u.a) + " " + gc(a) + " " + gc(i) + " " + gc(o) + " " + gc(s) + " " + gc(t);
            case 6:
                var b = n.a, d = (o = b.b, n.b);
                return s = d.a, t = d.b, "s" + gc(i = b.a) + " " + gc(o) + " " + gc(s) + " " + gc(t);
            case 7:
                var l = n.a, v = (a = l.b, n.b);
                return s = v.a, t = v.b, "q" + gc(l.a) + " " + gc(a) + " " + gc(s) + " " + gc(t);
            case 8:
                var p = n.a;
                return t = p.b, "t" + gc(s = p.a) + " " + gc(t);
            default:
                var h = n.a, q = h.b, y = n.b, U = n.c, m = n.d, W = n.e, V = W.a, T = W.b;
                return "a" + gc(h.a) + " " + gc(q) + " " + gc(_c(y)) + " " + (U ? "1" : "0") + " " + (m ? "1" : "0") + " " + gc(V) + " " + gc(T);
        }
    }, Of = F2(function(n, r) {
        var t = r.a, e = n.bW, u = n.bD, a = n.bX, c = n.dV, i = A2(bf, u, r.b), o = A2(Mt, "", A2(xe, kf, A2(xe, Kf(i), t))), f = A3(Ao, zt, i, a), s = A3(Ao, zt, A2(Go, function(n) {
            return n / 2;
        }, i), a), b = {
            dU: A3(Ao, te, c.dU, f),
            dX: A3(Ao, zt, c.dX, s),
            d3: c.d3 + 1,
            e6: A3(Ao, qf, c.e6, f)
        };
        return A4(af, d(e, o), u, f, b);
    }), zf = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Zt;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(nc, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return Dt(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), Df = F4(function(n, r, t, e) {
        var u = n ? lf : ef, c = e.bW, i = e.bD, o = e.bX, f = e.dV, b = A2(bf, i, 10), l = A3(Ao, zt, b, o), v = {
            dU: A3(Ao, te, f.dU, l),
            dX: f.dX,
            d3: f.d3,
            e6: A3(Ao, qf, f.e6, l)
        }, p = A3(Ao, zt, A2(Go, function(n) {
            return n / 2;
        }, b), o), h = function(n) {
            return A4(af, c, function(n) {
                return n > 360 ? n - 360 : 0 > a(n, -360) ? n + 360 : n;
            }(n), o, v);
        };
        switch(t.$){
            case 0:
                return A4(af, d(c, kf(u(b))), i, l, s(v, {
                    dX: A3(Ao, zt, f.dX, p),
                    d3: f.d3 + 1
                }));
            case 3:
                return A4(af, d(c, kf(df(b))), i, l, v);
            case 4:
                var q = t.a;
                return A2(Iu, e, A2(wc, Of(e), A2(zf, q, hf)));
            case 2:
                return h(i + r);
            default:
                return h(i - r);
        }
    }), Zf = function(n) {
        var r = n.d1, t = A3(Lt, A2(Df, n.d4, n.e7), cf, function(n) {
            var r = n.a, t = n.b, e = F2(function(n, r) {
                return r.$ ? h([
                    r
                ]) : n;
            });
            return A3(Lt, F2(function(n, r) {
                return A2(Ni, e(n), r);
            }), r, t);
        }(r)), e = t.bX, u = e.b;
        return {
            dV: t.dV,
            ex: "M 0 0 " + t.bW,
            eG: "M " + gc(e.a) + " " + gc(u) + " " + kf(ef(A2(bf, t.bD, 10)))
        };
    }, Hf = F4(function(n, r, t, e) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Qf = Hf, Pf = Qf("http://www.w3.org/2000/svg"), Mf = Pf("circle"), Sf = _o("cx"), Lf = _o("cy"), Rf = A3(Nu, 200, 200, 200), xf = _o("r"), If = function(n) {
        return A2(Mt, "", n);
    }, Ff = function(n) {
        var r, t = n.b, e = n.c, u = n.d, a = function(n) {
            return Sa(1e4 * n) / 100;
        };
        return If(h([
            "rgba(",
            gc(a(n.a)),
            "%,",
            gc(a(t)),
            "%,",
            gc(a(e)),
            "%,",
            gc((r = u, Sa(1e3 * r) / 1e3)),
            ")"
        ]));
    }, wf = F2(function(n, r) {
        return A2(Mf, h([
            Sf(gc(n)),
            Lf(gc(r)),
            xf("1"),
            rf(Ff(Rf))
        ]), l);
    }), Nf = Pf("path"), Xf = ju("#b91c1c"), $f = _o("stroke"), Yf = _o("stroke-dasharray"), gf = _o("stroke-linecap"), jf = _o("stroke-width"), Jf = _o("style"), Ef = Pf("svg"), Af = _o("viewBox"), Gf = F3(function(n, r, t) {
        var e, u, a = A2(lc, he, h([
            A2(wc, tf, n)
        ])), c = t.cz, i = t.dy, o = t.dK, f = t.dq, s = o.a, b = o.b, v = (e = t.dC).$ ? Zf(t) : e.a, p = v.ex, q = v.eG, y = Co(v.dV), U = y.a, m = U.a, W = U.b, V = y.b, T = V.a, K = V.b, k = r ? h([
            A2(wf, 0, 0),
            A2(Nf, h([
                nf(q),
                $f(Ff(Xf)),
                Yf("1")
            ]), l)
        ]) : l;
        return A2(Ef, d(h([
            Af((u = h([
                m,
                W,
                T,
                K
            ]), A2(Mt, " ", A2(xe, gc, u)))),
            Jf("display: block; height: 100%; width: 100%; background-color: " + Ff(c) + "; transform: translate(" + gc(s) + "px, " + gc(b) + "px)scale(" + gc(f) + ")")
        ]), a), A2(yt, A2(Nf, h([
            nf(p),
            $f(Ff(i)),
            jf(gc(t.dz)),
            gf("square"),
            rf("none")
        ]), l), k));
    }), Cf = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Bf = lr, _f = F2(function(n, r) {
        var t = n.b, e = n.c;
        return qi(t) ? r : A3(tc, e, t, r);
    }), ns = function(n) {
        return n.a;
    }, rs = function(n) {
        return or(Wr(n));
    }, ts = F2(function(n, r) {
        return A2(ir, n, Wr(r));
    }), es = function(n) {
        return cr(Wr(n));
    }, us = function(n) {
        return ar(Wr(n));
    }, as = F2(function(n, r) {
        var t = n.a, e = n.b, u = r.a, a = r.b;
        switch(e.$){
            case 4:
                return o(A2(yt, o(t, d = e.a), u), a);
            case 0:
                var c = e.a, i = e.c, f = A3(Lt, cs, o(l, A3(Lt, _f, a, q = e.b)), i), s = f.a, b = f.b, d = A3(es, c, A2(xe, ns, q), $t(s));
                return o(A2(yt, o(t, d), u), b);
            case 1:
                var v = e.a, p = (c = e.b, i = e.d, A3(Lt, cs, o(l, A3(Lt, _f, a, q = e.c)), i));
                return s = p.a, b = p.b, d = A4(us, v, c, A2(xe, ns, q), $t(s)), o(A2(yt, o(t, d), u), b);
            case 2:
                c = e.a, i = e.c;
                var h = A3(Lt, as, o(l, A3(Lt, _f, a, q = e.b)), i);
                return s = h.a, b = h.b, d = A3(rs, c, A2(xe, ns, q), $t(s)), o(A2(yt, o(t, d), u), b);
            default:
                v = e.a, c = e.b, i = e.d;
                var q, y = A3(Lt, as, o(l, A3(Lt, _f, a, q = e.c)), i);
                return s = y.a, b = y.b, d = A4(ts, v, c, A2(xe, ns, q), $t(s)), o(A2(yt, o(t, d), u), b);
        }
    }), cs = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 4:
                return o(A2(yt, s = n.a, t), e);
            case 0:
                var u = n.a, a = n.c, c = A3(Lt, cs, o(l, A3(Lt, _f, e, p = n.b)), a), i = c.a, f = c.b, s = A3(es, u, A2(xe, ns, p), $t(i));
                return o(A2(yt, s, t), f);
            case 1:
                var b = n.a, d = (u = n.b, a = n.d, A3(Lt, cs, o(l, A3(Lt, _f, e, p = n.c)), a));
                return i = d.a, f = d.b, s = A4(us, b, u, A2(xe, ns, p), $t(i)), o(A2(yt, s, t), f);
            case 2:
                u = n.a, a = n.c;
                var v = A3(Lt, as, o(l, A3(Lt, _f, e, p = n.b)), a);
                return i = v.a, f = v.b, s = A3(rs, u, A2(xe, ns, p), $t(i)), o(A2(yt, s, t), f);
            default:
                b = n.a, u = n.b, a = n.d;
                var p, h = A3(Lt, as, o(l, A3(Lt, _f, e, p = n.c)), a);
                return i = h.a, f = h.b, s = A4(ts, b, u, A2(xe, ns, p), $t(i)), o(A2(yt, s, t), f);
        }
    }), is = F2(function(n, r) {
        return A5(Ba, 1, n, r, Ea, Ea);
    }), os = F2(function(n, r) {
        for(;;){
            if (!r.b) return n;
            var t = r.a, e = t.b, u = t.c, a = r.b;
            Ke(u) || (n = Dt(o(u, e))), r = a;
        }
    }), fs = function(n) {
        var r = A2(os, Zt, n);
        if (1 === r.$) return Aa;
        var t = r.a;
        return A2(is, t.a, t.b);
    }, ss = ur, bs = function(n) {
        var r;
        return A2($o, n.b, li(h([
            (r = n.a, {
                $: 0,
                a: r
            })
        ])));
    }, ds = function(n) {
        return A3(es, "style", l, Do(ss(No(Do(Yo(A2(xe, bs, mt(n))))))));
    }, ls = F3(function(n, r, t) {
        var e = A2(xe, ns, r), u = fs(r), a = A3(Lt, cs, o(l, u), t), c = a.a, i = ds(a.b);
        return A3(es, n, e, A2(yt, i, $t(c)));
    }), vs = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var e = r.b;
            if (t(n, r.a.a)) return !0;
            r = e;
        }
    }), ps = F2(function(n, r) {
        n: for(;;){
            if (r.b) {
                var t = r.b, e = "_" + r.a.a;
                if (A2(vs, e, t)) {
                    n = e, r = t;
                    continue n;
                }
                return e;
            }
            return n;
        }
    }), hs = F2(function(n, r) {
        return o(A2(ps, "_", r), ds(n));
    }), qs = F3(function(n, r, t) {
        var e = A2(xe, ns, r), u = fs(r), a = A3(Lt, as, o(l, u), t), c = a.a;
        return A3(rs, n, e, A2(yt, A2(hs, a.b, c), $t(c)));
    }), ys = F4(function(n, r, t, e) {
        var u = A2(xe, ns, t), a = fs(t), c = A3(Lt, as, o(l, a), e), i = c.a;
        return A4(ts, n, r, u, A2(yt, A2(hs, c.b, i), $t(i)));
    }), Us = F4(function(n, r, t, e) {
        var u = A2(xe, ns, t), a = fs(t), c = A3(Lt, cs, o(l, a), e), i = c.a, f = ds(c.b);
        return A4(us, n, r, u, A2(yt, f, $t(i)));
    }), ms = function(n) {
        switch(n.$){
            case 4:
                return n.a;
            case 0:
                return A3(ls, n.a, n.b, n.c);
            case 1:
                return A4(Us, n.a, n.b, n.c, n.d);
            case 2:
                return A3(qs, n.a, n.b, n.c);
            default:
                return A4(ys, n.a, n.b, n.c, n.d);
        }
    }, Ws = F4(function(n, r, t, e) {
        return ms(A3(n, r, t, e));
    }), Vs = F4(function(n, r, t, e) {
        return Cf(A5(Bf, Ws, n, r, t, e));
    }), Ts = Vs(Gf), Ks = {
        a8: 0,
        bX: 0,
        b1: 0,
        W: "fixed"
    }, ks = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Os = ks, zs = Os("div"), Ds = F2(function(n, r) {
        return A2(ii, n, r.W);
    }), Zs = Ds("position"), Hs = F2(function(n, r) {
        return A2(zs, A2(yt, Jo(h([
            Zs(Ks)
        ])), n), r);
    }), Qs = Ds("height"), Ps = {
        B: 0,
        aX: 0,
        W: "hidden",
        bB: 0
    }, Ms = F2(function(n, r) {
        return A3(di, A2(go, n, r), l, "");
    }), Ss = F2(function(n, r) {
        return A2(Ms, n, jo(r));
    }), Ls = Ss("id"), Rs = 240, xs = function(n) {
        return A2(de, n, A3(le, Bu, A2(Eu, "clientX", Au), A2(Eu, "clientY", Au)));
    }, Is = F3(function(n, r, t) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t
        };
    }), Fs = Is, ws = F2(function(n, r) {
        return A3(di, A2(Ta, n, r), l, "");
    }), Ns = F2(function(n, r) {
        return A2(ws, n, Da(r));
    }), Xs = function(n) {
        return o(n, !0);
    }, $s = F2(function(n, r) {
        return A2(ws, n, Va(r));
    }), Ys = C, gs = on, js = Ds("overflow"), Js = F3(function(n, r, t) {
        return {
            cu: 0,
            cH: 0,
            aP: 0,
            w: 0,
            bi: 0,
            aU: 0,
            af: 0,
            aV: 0,
            aW: 0,
            av: 0,
            aw: 0,
            U: 0,
            ah: t,
            a$: 0,
            a1: r,
            bz: n,
            W: d(gc(t), r)
        };
    }), Es = A2(Js, 0, "%"), As = A2(Js, 0, "px"), Gs = Ds("right"), Cs = F4(function(n, r, t, e) {
        return {
            X: e,
            ao: t,
            d_: 0,
            au: r,
            aB: n,
            W: A2(si, "rgba", d(A2(xe, Pt, h([
                n,
                r,
                t
            ])), h([
                gc(e)
            ])))
        };
    }), Bs = function(n) {
        return Sa(255 * A3(Gc, 0, 1, n));
    }, _s = function(n) {
        var r = Xu(n), t = r.au, e = r.ao, u = r.X;
        return A4(Cs, Bs(r.aB), Bs(t), Bs(e), u);
    }, nb = Ds("top"), rb = Ds("width"), tb = {
        bi: 0,
        aU: 0,
        af: 0,
        aV: 0,
        aW: 0,
        av: 0,
        aw: 0,
        bl: 0,
        ah: 0,
        bU: 0,
        a1: "",
        bz: 0,
        W: "0"
    }, eb = function(n) {
        var r;
        return A2(Hs, h([
            Jo(h([
                oi(_s(n.cz)),
                Zs(Ks),
                Qs(A3(bi, Es(100), 1, As(40))),
                nb(As(40)),
                rb(A3(bi, Es(100), 1, As(Rs))),
                Gs(tb),
                js(Ps)
            ])),
            Ls("mainImg"),
            (r = ai, A2($s, "wheel", A2(de, Xs, function(n) {
                return A5(gs, n, A2(Eu, "deltaX", Au), A2(Eu, "deltaY", Au), A2(Eu, "shiftKey", Ys), A3(le, Bu, A2(Eu, "clientX", Au), A2(Eu, "clientY", Au)));
            }(r)))),
            A2(Ns, "mousedown", xs(ui))
        ]), h([
            A3(Fs, "div", h([
                Ls("MainImgKeyedWrapper"),
                Jo(h([
                    rb(Es(100)),
                    Qs(Es(100)),
                    oi(_s(n.cz))
                ]))
            ]), h([
                o("_MainImg", A3(Ts, Dt("MainSVG"), !1, n))
            ]))
        ]));
    }, ub = A4(ku, 0, 0, 0, 1), ab = A3(Nu, 255, 72, 146), cb = {
        cz: ub,
        d1: mu(h([
            h([
                su,
                su,
                su,
                su,
                su,
                su,
                su
            ]),
            h([
                su,
                bu,
                bu,
                lu,
                bu,
                bu,
                su,
                bu,
                bu,
                lu,
                bu,
                bu,
                su,
                bu,
                bu,
                lu,
                bu,
                bu
            ]),
            h([
                fu("W"),
                fu("E"),
                fu("L"),
                fu("C"),
                fu("O"),
                fu("M"),
                fu("E"),
                du,
                du,
                lu,
                lu,
                lu,
                lu,
                lu,
                lu,
                lu,
                du,
                du,
                du,
                lu,
                lu,
                du,
                du,
                du,
                lu,
                lu,
                fu("T"),
                fu("O"),
                du,
                du,
                lu,
                lu,
                lu,
                lu,
                du,
                du,
                du,
                lu,
                lu,
                du,
                du,
                du,
                fu("G"),
                fu("E"),
                fu("N"),
                fu("A"),
                fu("R"),
                fu("T"),
                du,
                du,
                lu,
                lu,
                lu,
                lu,
                lu,
                lu,
                du,
                lu,
                lu,
                lu,
                lu,
                du,
                lu
            ])
        ])),
        d4: 0,
        dq: 1.1,
        dy: ab,
        dz: .01,
        dC: Zt,
        dK: o(0, 0),
        e7: ua(1)
    }, ib = {
        an: Zt,
        aJ: !1,
        N: 0,
        q: A2(ei, "ColorWheel1", Dt(ca.dy)),
        ap: Yc.eC,
        o: 1,
        bK: 0,
        aS: 100,
        bc: Zt,
        er: cb,
        bf: eb(cb),
        T: o(0, 0),
        bL: o(0, 0),
        bN: 0,
        bh: o(0, 0),
        ae: 16,
        bo: !1,
        v: !1,
        ak: !1,
        A: na,
        bs: Ec(ra),
        M: gc(cb.e7),
        dM: Zt,
        K: 1,
        bA: 1e-4
    }, ob = A2(de, function(n) {
        return s(ib, {
            er: n
        });
    }, Cu(h([
        _u
    ]))), fb = function(n) {
        return {
            k: n,
            c8: l,
            bp: !1
        };
    }, sb = Cu(h([
        A2(cu, ob, ve(fb))
    ])), bb = A2(fa, jo, function(n) {
        var r = function(n) {
            return 2 > me(n) ? "0" + n : n;
        }, t = Xu(n), e = t.au, u = t.ao;
        return "#" + (r(Ko(Bs(t.aB))) + (r(Ko(Bs(e))) + r(Ko(Bs(u)))));
    }), db = function(n) {
        switch(n.$){
            case 0:
                return "D";
            case 1:
                return "R";
            case 2:
                return "L";
            case 3:
                return "S";
            default:
                return "_" + Qu(n.a);
        }
    }, lb = function(n) {
        return jo(If(A2(xe, db, n)));
    }, vb = F2(function(n, r) {
        return A3(Lt, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), pb = function(n) {
        return A2(yt, n.a, n.b);
    }, hb = function(n) {
        return A2(vb, lb, pb(n));
    }, qb = function(n) {
        return jo(n ? "curve" : "line");
    }, yb = Un, Ub = function(n) {
        return A3(Lt, F2(function(n, r) {
            return A3(mn, n.a, n.b, r);
        }), {}, n);
    }, mb = function(n) {
        var r = n.e7, t = n.cz, e = n.dy, u = n.dz, a = n.dK, c = n.dq, i = n.d4;
        return Ub(h([
            o(Gu.d1, hb(n.d1)),
            o(Gu.e7, yb(r)),
            o(Gu.cz, bb(t)),
            o(Gu.dy, bb(e)),
            o(Gu.dz, yb(u)),
            o(Gu.bv, yb(a.a)),
            o(Gu.bw, yb(a.b)),
            o(Gu.dq, yb(c)),
            o(Gu.d4, qb(i))
        ]));
    }, Wb = F4(function(n, r, t, e) {
        return {
            aH: e,
            G: t,
            I: r,
            aY: n
        };
    }), Vb = 3432918353, Tb = 461845907, Kb = F2(function(n, r) {
        return (65535 & r) * n + (((r >>> 16) * n & 65535) << 16);
    }), kb = F2(function(n, r) {
        return r << n | r >>> 32 - n;
    }), Ob = F2(function(n, r) {
        return A2(Kb, 5, A2(kb, 13, n ^ A2(Kb, Tb, A2(kb, 15, A2(Kb, Vb, r))))) + 3864292196;
    }), zb = F2(function(n, r) {
        var t = r.G | (255 & Xt(n)) << r.aY;
        return 24 === r.aY ? {
            aH: r.aH + 1,
            G: 0,
            I: A2(Ob, r.I, t),
            aY: 0
        } : {
            aH: r.aH + 1,
            G: t,
            I: r.I,
            aY: r.aY + 8
        };
    }), Db = F2(function(n, r) {
        var t, e, u, a;
        return ((a = A2(Kb, 3266489909, (u = A2(Kb, 2246822507, (e = ((t = A3(hu, zb, A4(Wb, 0, n, 0, 0), r)).G ? t.I ^ A2(Kb, Tb, A2(kb, 15, A2(Kb, Vb, t.G))) : t.I) ^ t.aH) ^ e >>> 16)) ^ u >>> 13)) ^ a >>> 16) >>> 0;
    }), Zb = function(n) {
        return A2(Db, 8871, A2(Qt, 0, mb(n)));
    }, Hb = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Qb = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Pb = A2($c, {
        dT: F3(function(n, r, t) {
            return t;
        }),
        ew: 0,
        eD: 0,
        eS: 2
    }, Qb), Mb = {
        ap: Pb.eC,
        x: l,
        be: Zt,
        bs: Ec(Hb)
    }, Sb = A2(de, function(n) {
        return s(Mb, {
            x: n
        });
    }, Wu(A2(de, function(n) {
        return {
            G: Zb(n),
            er: n
        };
    }, _u))), Lb = "editor", Rb = "gallery", xb = Cu(h([
        A3(le, Bu, A2(Eu, Lb, sb), A2(Eu, Rb, Sb))
    ])), Ib = function(n) {
        return A2(vb, mb, A2(xe, function(n) {
            return n.er;
        }, n.x));
    }, Fb = function(n) {
        var r, t = n.x;
        return Ub(h([
            o(Lb, (r = n.k, mb(r.k.er))),
            o(Rb, Ib(t))
        ]));
    }, wb = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nb = {
        $: 1
    }, Xb = F2(function(n) {
        return n;
    }), $b = function(n) {
        return A2(ru, Xb(n(Nb)), Me(0));
    }, Yb = A2(ba, function(n) {
        return {
            $: 13,
            a: n
        };
    }, da("mainImg")), gb = Xn, jb = function() {
        return A2(gb, wb, uu(h([
            Yb,
            $b(ra)
        ])));
    }, Jb = Sn, Eb = F2(function(n, r) {
        return A2(ru, function() {
            return r;
        }, Jb(n));
    }), Ab = A2(Eb, 5e3, 1), Gb = F2(function(n, r) {
        return s(r, {
            d1: n
        });
    }), Cb = {
        er: A2(Gb, mu(h([
            h([
                su,
                su,
                su,
                su,
                su,
                su,
                su
            ]),
            h([
                su,
                bu,
                bu,
                lu,
                bu,
                bu,
                su,
                bu,
                bu,
                lu,
                bu,
                bu,
                su,
                bu,
                bu,
                lu,
                bu,
                bu
            ]),
            h([
                fu("A"),
                fu("B"),
                fu("C"),
                du,
                du,
                lu,
                lu,
                lu,
                du,
                du,
                lu
            ])
        ])), cb),
        ca: !0,
        b0: !1,
        bA: 1e-4
    }, Bb = fb(ib), _b = {
        er: cb,
        ca: !0,
        b0: !1,
        bA: 1e-4
    }, nd = function(n) {
        return {
            $: 8,
            a: n
        };
    }, rd = "ART  ", td = F2(function(n, r) {
        return $t(A2(yt, n, $t(r)));
    }), ed = F2(function(n, r) {
        return A2(Uu, r.a, A2(td, n, r.b));
    }), ud = F2(function(n, r) {
        if (r.b) {
            var t = r.b;
            return A2(yt, r.a, A3(Re, F2(function(r, t) {
                return A2(yt, n, A2(yt, r, t));
            }), l, t));
        }
        return l;
    }), ad = A2(pu, Du, xe(fu)), cd = function(n) {
        var r = A2(xe, ad, A2(St, " ", n)), t = Rc(A2(ud, h([
            lu
        ]), r)), e = d(h([
            du,
            du
        ]), d(A2(Jc, Rt(t), lu), h([
            du,
            du
        ])));
        return d(t, e);
    }, id = F2(function(n, r) {
        var t = A2(xe, cd, h(n.split(/\r\n|\r|\n/g))), e = Rc(A2(Jc, Rt(t) - 1, h([
            lu,
            lu
        ]))), u = Rt(e) > 0 ? d(h([
            du,
            du,
            du
        ]), d(e, h([
            du
        ]))) : l, a = d(Rc(A2(ud, h([
            du,
            lu,
            lu,
            du,
            du,
            du
        ]), t)), d(u, h([
            lu
        ])));
        return A2(ed, a, function(n) {
            return mu(h([
                A2(Jc, n, su),
                h([
                    su,
                    du,
                    du,
                    lu,
                    du,
                    du
                ])
            ]));
        }(r));
    }), od = F2(function(n, r) {
        return s(r, {
            dz: n
        });
    }), fd = .001, sd = {
        aK: 20,
        er: A2(od, .01, A2(Gb, A2(id, rd, 20), cb)),
        ca: !0,
        bs: Ec(nd),
        bA: fd,
        bC: rd
    }, bd = F2(function(n, r) {
        return {
            aL: Cb,
            k: Bb,
            x: Mb,
            ay: r,
            dM: n,
            a3: 0,
            a4: _b,
            a6: sd
        };
    }), dd = F2(function(n, r) {
        switch(n.$){
            case 1:
                return 1;
            case 0:
            default:
                return 0;
            case 4:
                return r ? 0 : 2;
            case 2:
                return 3;
            case 3:
                return 4;
        }
    }), ld = {
        $: 5
    }, vd = {
        $: 3
    }, pd = F5(function(n, r, t, e, u) {
        return {
            at: e,
            az: t,
            al: r,
            W: u,
            aE: n
        };
    }), hd = F2(function(n, r) {
        return A5(pd, r.aE, r.al, r.az, r.at, n(r.W));
    }), qd = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = r.aE, u = r.al, a = r.az, c = r.at;
            return A2(xe, hd(r.W), t(A5(pd, e, u, a, c, n)));
        };
    }), yd = function(n) {
        switch(n){
            case 0:
                return "editor";
            case 1:
                return "gallery";
            case 2:
                return "";
            case 3:
                return "writing";
            default:
                return "dev";
        }
    }, Ud = function(n) {
        return function(r) {
            var e = r.aE, u = r.al, a = r.az, c = r.at, i = r.W;
            if (u.b) {
                var o = u.a, f = u.b;
                return t(o, n) ? h([
                    A5(pd, A2(yt, o, e), f, a, c, i)
                ]) : l;
            }
            return l;
        };
    }, md = F2(function(n, r) {
        return A2(qd, n, Ud(yd(r)));
    }), Wd = A2(md, vd, 4), Vd = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Td = F8(function(n, r, t, e, u, a, c, i) {
        return {
            cz: t,
            d1: n,
            d4: i,
            dq: c,
            dy: e,
            dz: u,
            dK: a,
            e7: r
        };
    }), Kd = fn, kd = F2(function(n, r) {
        var t = r;
        return function(r) {
            return n(t(r));
        };
    }), Od = F3(function(n, r, t) {
        var e = r, u = t;
        return function(r) {
            return A2(n, e(r), u(r));
        };
    }), zd = F9(function(n, r, t, e, u, a, c, i, o) {
        var f = r, s = t, b = e, d = u, l = a, v = c, p = i, h = o;
        return function(r) {
            return A8(n, f(r), s(r), b(r), d(r), l(r), v(r), p(r), h(r));
        };
    }), Dd = F2(function(n, r) {
        return function(t) {
            return r(A2(Iu, l, A2(zf, n, t)));
        };
    }), Zd = function(n) {
        return n.$ ? Zt : Dt(n.a);
    }, Hd = A9(zd, Td, A2(pc = F2(function(n, r) {
        var t;
        return A2(kd, Fa(A2(pu, Kd(r), Zd)), (t = n(Gu), A2(Dd, t, function(n) {
            return n.b && !n.b.b ? Dt(n.a) : Zt;
        })));
    }), function(n) {
        return n.d1;
    }, Vu), A2(pc, function(n) {
        return n.e7;
    }, Au), A2(pc, function(n) {
        return n.cz;
    }, Ju), A2(pc, function(n) {
        return n.dy;
    }, Ju), A2(pc, function(n) {
        return n.dz;
    }, Au), A3(Od, wa(Bu), A2(pc, function(n) {
        return n.bv;
    }, Au), A2(pc, function(n) {
        return n.bw;
    }, Au)), A2(pc, function(n) {
        return n.dq;
    }, Au), A2(pc, function(n) {
        return n.d4;
    }, Tu)), Qd = F2(function(n, r) {
        var t = n, e = r;
        return function(n) {
            return A2(Ni, e, t(n));
        };
    }), Pd = A2(F2(function(n, r) {
        return A2(Qd, n, function(n) {
            var r = n;
            return function(n) {
                var t = n.az;
                return h([
                    A5(pd, n.aE, n.al, t, n.at, (0, n.W)(r(t)))
                ]);
            };
        }(r));
    }), Ud(yd(0)), Hd), Md = A2(qd, Vd, Pd), Sd = A2(md, {
        $: 1
    }, 1), Ld = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(yt, n.a, Ld(n.b)) : l;
    }, Rd = F2(function(n, r) {
        return Dt(1 === r.$ ? h([
            n
        ]) : A2(yt, n, r.a));
    }), xd = function(n) {
        try {
            return Dt(decodeURIComponent(n));
        } catch (n) {
            return Zt;
        }
    }, Id = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return c = t.b, i = t.c, e = t.d, s = t.e, A5(Ba, 1, n.b, n.c, A5(Ba, 0, r.b, r.c, r.d, r.e), A5(Ba, 0, c, i, e, s));
            }
            var e, u = n.d, a = n.e, c = a.b, i = a.c, o = (e = a.d).d, f = e.e, s = a.e;
            return A5(Ba, 0, e.b, e.c, A5(Ba, 1, n.b, n.c, A5(Ba, 0, u.b, u.c, u.d, u.e), o), A5(Ba, 1, c, i, f, s));
        }
        return n;
    }, Fd = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, b = t.d, d = t.e, A5(Ba, 1, e = n.b, u = n.c, A5(Ba, 0, r.b, r.c, r.d, i = r.e), A5(Ba, 0, f, s, b, d));
            }
            var e = n.b, u = n.c, a = n.d, c = a.d, i = a.e, o = n.e, f = o.b, s = o.c, b = o.d, d = o.e;
            return A5(Ba, 0, a.b, a.c, A5(Ba, 1, c.b, c.c, c.d, c.e), A5(Ba, 1, e, u, i, A5(Ba, 0, f, s, b, d)));
        }
        return n;
    }, wd = F7(function(n, r, t, e, u, a, c) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === c.$ && 1 === c.a) {
                    if (-1 === c.d.$) {
                        if (1 === c.d.a) return Fd(r);
                        break n;
                    }
                    return Fd(r);
                }
                break n;
            }
            return r;
        }
        return A5(Ba, t, a.b, a.c, a.d, A5(Ba, 0, e, u, a.e, c));
    }), Nd = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, c = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var i = Id(n);
                    if (-1 === i.$) {
                        var o = i.e;
                        return A5(_a, i.a, i.b, i.c, Nd(i.d), o);
                    }
                    return Ea;
                }
                return A5(Ba, r, t, e, Nd(u), c);
            }
            return A5(Ba, r, t, e, Nd(u), c);
        }
        return Ea;
    }, Xd = F2(function(n, r) {
        if (-2 === r.$) return Ea;
        var t = r.a, e = r.b, u = r.c, c = r.d, i = r.e;
        if (0 > a(n, e)) {
            if (-1 === c.$ && 1 === c.a) {
                var o = c.d;
                if (-1 !== o.$ || o.a) {
                    var f = Id(r);
                    if (-1 === f.$) {
                        var s = f.e;
                        return A5(_a, f.a, f.b, f.c, A2(Xd, n, f.d), s);
                    }
                    return Ea;
                }
                return A5(Ba, t, e, u, A2(Xd, n, c), i);
            }
            return A5(Ba, t, e, u, A2(Xd, n, c), i);
        }
        return A2($d, n, A7(wd, n, r, t, e, u, c, i));
    }), $d = F2(function(n, r) {
        if (-1 === r.$) {
            var e = r.a, u = r.b, a = r.c, c = r.d, i = r.e;
            if (t(n, u)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(i);
                return -1 === o.$ ? A5(_a, e, o.b, o.c, c, Nd(i)) : Ea;
            }
            return A5(_a, e, u, a, c, A2(Xd, n, i));
        }
        return Ea;
    }), Yd = F2(function(n, r) {
        var t = A2(Xd, n, r);
        return -1 !== t.$ || t.a ? t : A5(Ba, 1, t.b, t.c, t.d, t.e);
    }), gd = F3(function(n, r, t) {
        var e = r(A2(zf, n, t));
        return e.$ ? A2(Yd, n, t) : A3(tc, n, e.a, t);
    }), jd = F2(function(n, r) {
        var t = A2(St, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, u = xd(t.a);
            if (1 === u.$) return r;
            var a = u.a, c = xd(e);
            return 1 === c.$ ? r : A3(gd, a, Rd(c.a), r);
        }
        return r;
    }), Jd = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.al;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return Dt(r.W);
                    }
                    return Dt(r.W);
                }
                return Zt;
            }
        }(n(A5(pd, l, function(n) {
            var r = A2(St, "/", n);
            return Ld(r.b && "" === r.a ? r.b : r);
        }(r.ai), 1 === (t = r.dh).$ ? Aa : A3(Re, jd, Aa, A2(St, "&", t.a)), r.cU, he)));
    }), Ed = A2(qd, {
        $: 4
    }, function(n) {
        return h([
            n
        ]);
    }), Ad = A2(md, {
        $: 2
    }, 3), Gd = function(n) {
        var r, t = A2(Jd, (r = h([
            Ed,
            Ad,
            Md,
            Sd,
            Wd
        ]), function(n) {
            return A2(Ni, function(r) {
                return r(n);
            }, r);
        }), n);
        return t.$ ? ld : t.a;
    }, Cd = tt, Bd = An("saveModelToLocalStorage", he), _d = F2(function(n, r) {
        var t, e = 1 === (t = o(n.d1, n.e7)).a.$ && 1 === t.b.$ ? r.dC : Zt;
        return {
            cz: A2(Iu, r.cz, n.cz),
            d1: A2(Iu, r.d1, n.d1),
            d4: A2(Iu, r.d4, n.d4),
            dq: A2(Iu, r.dq, n.dq),
            dy: A2(Iu, r.dy, n.dy),
            dz: A2(Iu, r.dz, n.dz),
            dC: e,
            dK: A2(Iu, r.dK, n.dK),
            e7: A2(Iu, r.e7, n.e7)
        };
    }), nl = F2(function(n, r) {
        return s(r, {
            d_: n
        });
    }), rl = F2(function(n, r) {
        return nl(r ? n.cz : n.dy);
    }), tl = F2(function(n, r) {
        return s(r, {
            q: A3(rl, n, r.N, r.q),
            er: n,
            M: gc(n.e7)
        });
    }), el = F2(function(n, r) {
        return A2(tl, A2(_d, n, r.er), r);
    }), ul = F2(function(n, r) {
        return s(r, {
            k: A2(el, n, r.k)
        });
    }), al = F2(function(n, r) {
        return s(r, {
            dM: Dt(n)
        });
    }), cl = F2(function(n, r) {
        return s(r, {
            k: A2(al, n, r.k)
        });
    }), il = F3(function(n, r, t) {
        var e = Gd(r), u = A2(bd, r, t), a = function() {
            var r = A2(au, xb, n);
            if (r.$) return f(Bb, Mb, !1);
            var t = r.a;
            return f(t.a, t.b, !0);
        }(), c = a.a, i = a.b, b = a.c, d = function() {
            switch(e.$){
                case 0:
                    return o(A2(ul, e.a, c), A2(Cd, t, yd(0)));
                case 5:
                    return o(c, A2(Cd, t, yd(0)));
                default:
                    return o(c, la);
            }
        }(), l = d.b, v = s(u, {
            k: A2(cl, r, d.a),
            x: i,
            a3: A2(dd, e, b)
        });
        return o(v, uu(h([
            Bd(Fb(v)),
            l,
            A2(gb, tu, jb()),
            A2(gb, eu, Ab)
        ])));
    }), ol = function(n) {
        return {
            $: 6,
            a: n
        };
    }, fl = function(n) {
        return {
            $: 3,
            a: n
        };
    }, sl = function(n) {
        return {
            $: 5,
            a: n
        };
    }, bl = Xn, dl = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ll = F2(function(n, r) {
        return {
            dg: r,
            dD: n
        };
    }), vl = Me(A2(ll, Aa, Aa)), pl = F2(function(n, r) {
        var t = n.a, e = n.b, u = A2(zf, t, r);
        return A3(tc, t, 1 === u.$ ? h([
            e
        ]) : A2(yt, e, u.a), r);
    }), hl = bt, ql = zn, yl = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, a = ql(A2(hl, e, A2(oc, n, e)));
            return A2(Ie, function(r) {
                return A3(yl, n, u, A3(tc, e, r, t));
            }, a);
        }
        return Me(t);
    }), Ul = F3(function(n, r, t) {
        var e = t.dg, u = F3(function(n, r, t) {
            var e = t.c;
            return f(t.a, t.b, A2(Ie, function() {
                return e;
            }, uc(r)));
        }), a = A3(Lt, pl, Aa, r), c = A6(cc, F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return f(A2(yt, n, t.a), e, u);
        }), F4(function(n, r, t, e) {
            var u = e.c;
            return f(e.a, A3(tc, n, t, e.b), u);
        }), u, a, e, f(l, Aa, Me(0))), i = c.a, o = c.b;
        return A2(Ie, function(n) {
            return Me(A2(ll, a, n));
        }, A2(Ie, function() {
            return A3(yl, n, i, o);
        }, c.c));
    }), ml = he, Wl = (hc = ml, Vn(function(n) {
        n(Wn(hc(Date.now())));
    }));
    Ln.Time = Rn(vl, Ul, F3(function(n, r, t) {
        var e = A2(zf, r, t.dD);
        if (1 === e.$) return Me(t);
        var u = e.a;
        return A2(Ie, function() {
            return Me(t);
        }, A2(Ie, function(r) {
            return Ne(A2(xe, function(t) {
                return A2(Xe, n, t(r));
            }, u));
        }, Wl));
    }), 0, F2(function(n, r) {
        return A2(dl, r.a, A2(fa, n, r.b));
    }));
    var Vl = wn("Time"), Tl = F2(function(n, r) {
        return Vl(A2(dl, n, r));
    }), Kl = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kl = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ol = F3(function(n, r, t) {
        return {
            ch: t,
            dk: r,
            dB: n
        };
    }), zl = Me(A3(Ol, l, Zt, 0)), Dl = Vn(function(n) {
        n(Wn(Date.now()));
    }), Zl = Vn(function(n) {
        var r = _r(function() {
            n(Wn(Date.now()));
        });
        return function() {
            Br(r);
        };
    });
    Ln["Browser.AnimationManager"] = Rn(zl, F3(function(n, r, t) {
        var e = t.dk, u = t.ch, a = o(e, r);
        return 1 === a.a.$ ? a.b.b ? A2(Ie, function(n) {
            return A2(Ie, function(t) {
                return Me(A3(Ol, r, Dt(n), t));
            }, Dl);
        }, ql(A2(Ie, oc(n), Zl))) : zl : a.b.b ? Me(A3(Ol, r, e, u)) : A2(Ie, function() {
            return zl;
        }, uc(a.a.a));
    }), F3(function(n, r, t) {
        var e = t.dB, u = t.ch, a = function(t) {
            return A2(Xe, n, (0, t.a)(t.$ ? r - u : ml(r)));
        };
        return A2(Ie, function(n) {
            return A2(Ie, function() {
                return Me(A3(Ol, e, Dt(n), r));
            }, Ne(A2(xe, a, e)));
        }, ql(A2(Ie, oc(n), Zl)));
    }), 0, F2(function(n, r) {
        return r.$ ? kl(A2(fa, n, r.a)) : {
            $: 0,
            a: A2(fa, n, r.a)
        };
    }));
    var Hl = wn("Browser.AnimationManager"), Ql = function(n) {
        return Hl(kl(n));
    }, Pl = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Ml = function(n) {
        return {
            $: 26,
            a: n
        };
    }, Sl = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ll = function(n) {
        return {
            $: 42,
            a: n
        };
    }, Rl = function(n) {
        return {
            $: 17,
            a: n
        };
    }, xl = {
        $: 16
    }, Il = function(n) {
        return {
            $: 32,
            a: n
        };
    }, Fl = F2(function(n, r) {
        return {
            $: 14,
            a: n,
            b: r
        };
    }), wl = Bn("copyToClipboardResult", Ys), Nl = function(n) {
        return A2(de, n, A2(Eu, "key", ou));
    }, Xl = _, $l = Bn("midiEvent", Xl), Yl = A2(yc, 0, "keydown"), gl = function(n) {
        return {
            $: 1,
            a: n
        };
    }, jl = {
        $: 3
    }, Jl = A3(le, Bu, A2(Eu, "offsetX", Au), A2(Eu, "offsetY", Au)), El = function(n) {
        return n.ax ? Ya(h([
            Uc(A2(de, gl, Jl)),
            mc(ve(jl))
        ])) : ga;
    }, Al = function(n) {
        var r = A3(yc, 1, "resize", A2(Eu, "target", A3(le, Fl, A2(Eu, "innerWidth", ma), A2(Eu, "innerHeight", ma)))), t = n.v ? Ql(Il) : ga, e = n.bo ? Ya(h([
            Uc(xs(Rl)),
            mc(ve(xl))
        ])) : ga, u = n.bK ? ga : Yl(Nl(Sl));
        return Ya(h([
            u,
            e,
            t,
            $l(Ll),
            wl(Ml),
            r,
            A2(bl, Pl, El(n.q)),
            Yc.e3(n.ap)
        ]));
    }, Gl = {
        $: 0
    }, Cl = function(n) {
        return n.dC.$ ? s(n, {
            dC: Dt(Zf(n))
        }) : n;
    }, Bl = function(n) {
        return {
            G: n.G,
            er: Cl(n.er)
        };
    }, _l = F2(function(n, r) {
        return s(r, {
            x: A2(yt, Bl({
                G: Zb(n),
                er: n
            }), r.x)
        });
    }), nv = A2(Eb, 5e3, 1), rv = uu(h([
        A2(ru, Xb({
            $: 8
        }), Me(0)),
        $b(Hb)
    ])), tv = ft("focus"), ev = uu(h([
        A2(ba, Xb({
            $: 7
        }), tv("WritingInput")),
        $b(nd)
    ])), uv = F2(function(n, r) {
        switch(r){
            case 0:
                return A2(gb, tu, jb());
            case 1:
                return A2(gb, fl, rv);
            case 2:
                return A2(gb, eu, Ab);
            case 3:
                return A2(gb, sl, ev);
            default:
                return A2(gb, ol, nv);
        }
    }), av = rt, cv = F2(function(n, r) {
        return 1 === n.$ ? r : r + ":" + Pt(n.a);
    }), iv = F3(function(n, r, t) {
        return 1 === r.$ ? t : d(t, d(n, r.a));
    }), ov = {
        $: 0
    }, fv = function(n) {
        var r = Xu(n), e = r.aB, u = r.au, a = r.ao, c = r.X, i = A2(te, e, A2(te, u, a)), o = i, f = i - A2(qf, e, A2(qf, u, a)), s = function() {
            if (f) {
                if (t(i, e)) {
                    var n = (u - a) / f;
                    return 0 > n ? n + 6 : n;
                }
                return t(i, u) ? (a - e) / f + 2 : t(i, a) ? (e - u) / f + 4 : 0;
            }
            return 0;
        }();
        return {
            dO: c,
            el: _c(60 * s),
            eZ: o ? f / o : 0,
            fa: o
        };
    }, sv = F2(function(n, r) {
        return s(r, {
            dy: n
        });
    }), bv = F2(function(n, r) {
        return s(r, {
            dC: Zt,
            e7: n
        });
    }), dv = F2(function(n, r) {
        switch(n){
            case 0:
                var t = r.er.e7 - r.bA, e = fv(r.er.dy), u = A4(ni, e.el + .02, e.eZ, e.fa, e.dO);
                return f(s(r, {
                    er: A2(od, A2(qf, 1.01 * r.er.dz, .1), A2(bv, t, A2(sv, u, r.er))),
                    bA: A2(qf, 1.17 * r.bA, .03)
                }), la, ov);
            case 1:
                return f(s(r, {
                    b0: !0
                }), la, ov);
            default:
                return f(r, la, {
                    $: 1,
                    a: r.er
                });
        }
    }), lv = function(n) {
        return {
            $: 41,
            a: n
        };
    }, vv = {
        $: 45
    }, pv = {
        $: 2
    }, hv = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qv = {
        $: 0
    }, yv = F2(function(n, r) {
        return s(r, {
            d1: A2(ed, n, r.d1),
            dC: Zt
        });
    }), Uv = function(n) {
        return A2(yv, h([
            su
        ]), n);
    }, mv = F4(function(n, r, t, e) {
        var u = A3(Ao, It, r, t), a = A2(te, e.dq - .01 * n, .1);
        return s(e, {
            dq: a,
            dK: A3(Ao, It, u, A2(Go, function(n) {
                return n * a / e.dq;
            }, A3(Ao, zt, e.dK, u)))
        });
    }), Wv = F3(function(n, r, t) {
        return s(t, {
            er: A4(mv, n, r, t.T, t.er)
        });
    }), Vv = ft("blur"), Tv = An("copyTextToClipboard", jo), Kv = null, kv = An("downloadSvg", function() {
        return Kv;
    }), Ov = An("downloadSvgAsJpeg", function() {
        return Kv;
    }), zv = F2(function(n, r) {
        return 1 > a(Rt(r), n) ? r : d(A2(Oc, n, r), A2(Vc, n + 1, r));
    }), Dv = function(n) {
        return Rt(pb(n));
    }, Zv = F2(function(n, r) {
        return 1 === Dv(r) ? A2(Uu, h([
            su
        ]), l) : a(n, Dv(r)) > -1 ? r : mu(A2(zv, n, pb(r)));
    }), Hv = F2(function(n, r) {
        return s(r, {
            d1: A2(Zv, n, r.d1),
            dC: Zt
        });
    }), Qv = F2(function(n, r) {
        return ko(A2(Vc, n, pb(r)));
    }), Pv = F2(function(n, r) {
        var t = A2(Qv, n, r.d1);
        return t.$ ? r : s(r, {
            d1: A2(ed, t.a, r.d1),
            dC: Zt
        });
    }), Mv = function(n) {
        return Dv(n.d1);
    }, Sv = function(n) {
        return s(n, {
            o: Mv(n.er) - 1
        });
    }, Lv = F2(function(n, r) {
        return Sv(s(n, {
            er: A2(Pv, r, n.er)
        }));
    }), Rv = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), xv = function(n) {
        var r = n.b;
        return A2(Rv, 1664525 * n.a + r >>> 0, r);
    }, Iv = A2(Ie, function(n) {
        var r, t;
        return Me((r = n, t = xv(A2(Rv, 0, 1013904223)), xv(A2(Rv, t.a + r >>> 0, t.b))));
    }, Wl), Fv = F2(function(n, r) {
        return n(r);
    }), wv = F3(function(n, r, t) {
        if (r.b) {
            var e = r.b, u = A2(Fv, r.a, t), a = u.b;
            return A2(Ie, function() {
                return A3(wv, n, e, a);
            }, A2(Xe, n, u.a));
        }
        return Me(t);
    }), Nv = F3(function(n, r, t) {
        return Me(t);
    }), Xv = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r), u = e.b;
            return o(n(e.a), u);
        };
    });
    Ln.Random = Rn(Iv, wv, Nv, F2(function(n, r) {
        return A2(Xv, n, r);
    }));
    var $v, Yv, gv, jv, Jv, Ev, Av, Gv, Cv, Bv = wn("Random"), _v = F2(function(n, r) {
        return Bv(A2(Xv, n, r));
    }), np = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rp = function(n) {
        return A2(ba, np, da(n.bd));
    }, tp = function(n) {
        return A2(Eb, 3e3, {
            $: 43,
            a: n
        });
    }, ep = F2(function(n, r) {
        return s(r, {
            dK: n
        });
    }), up = F3(function(n, r, t) {
        return A2(ep, A3(Ao, zt, t.dK, A3(Ao, It, n, r)), t);
    }), ap = br, cp = F2(function(n, r) {
        return ms(n(r));
    }), ip = F2(function(n, r) {
        return Cf(A3(ap, cp, n, r));
    }), op = ip, fp = F3(function(n, r, e) {
        return mu(A2(Nt, F2(function(e, u) {
            return t(e, r) ? n(u) : u;
        }), pb(e)));
    }), sp = function(n) {
        return fp(td(n));
    }, bp = F3(function(n, r, t) {
        return s(t, {
            d1: A3(sp, n, r, t.d1),
            dC: Zt
        });
    }), dp = function(n) {
        return A2(zv, Rt(n) - 1, n);
    }, lp = fp(dp), vp = F2(function(n, r) {
        return s(r, {
            d1: A2(lp, n, r.d1),
            dC: Zt
        });
    }), pp = F2(function(n, r) {
        var t = function(r) {
            return s(n, {
                er: A3(bp, r, n.o, n.er)
            });
        };
        switch(r){
            case "ArrowLeft":
                return Dt(t(bu));
            case "ArrowRight":
                return Dt(t(du));
            case "ArrowUp":
                return Dt(t(su));
            case "ArrowDown":
                return Dt(t(lu));
            case "Backspace":
                return Dt(s(n, {
                    er: A2(vp, n.o, n.er)
                }));
            default:
                return Zt;
        }
    }), hp = F2(function(n, r) {
        var t = n.b;
        return A2(Pu, n.a, r) * t;
    }), qp = {
        cI: o(1.10172109893, 90767e-10),
        dz: o(1.10172109893, 90767e-10)
    }, yp = hp(qp.dz), Up = function(n) {
        return s(n, {
            dq: 1,
            dK: o(0, 0)
        });
    }, mp = F3(function(n, r, t) {
        return {
            d$: n,
            eO: r,
            fb: t
        };
    }), Wp = F2(function(n, r) {
        return A3(Re, Eu, r, n);
    }), Vp = cn, Tp = A4(Vp, mp, A2(Wp, h([
        "data",
        "0"
    ]), Au), A2(Wp, h([
        "data",
        "1"
    ]), Au), A2(Wp, h([
        "data",
        "2"
    ]), Au)), Kp = F2(function(n, r) {
        var t = Xu(r), e = t.X;
        return A4(ku, t.aB, t.au, A3(Gc, 0, 1, n), e);
    }), kp = F2(function(n, r) {
        var t = Xu(r), e = t.ao, u = t.X;
        return A4(ku, t.aB, A3(Gc, 0, 1, n), e, u);
    }), Op = F4(function(n, r, t, e) {
        var u = f(n, r, t), a = u.a, c = u.b, i = u.c, o = i > .5 ? i + c - i * c : i * (c + 1), s = 2 * i - o, b = function(n) {
            var r = 0 > n ? n + 1 : n > 1 ? n - 1 : n;
            return 1 > 6 * r ? s + (o - s) * r * 6 : 1 > 2 * r ? o : 2 > 3 * r ? s + (o - s) * (2 / 3 - r) * 6 : s;
        }, d = b(a - 1 / 3), l = b(a), v = b(a + 1 / 3);
        return A4(Ku, v, l, d, e);
    }), zp = x, Dp = function(n) {
        var r = n.a, e = n.b, u = n.c, a = n.d, c = A2(qf, r, A2(qf, e, u)), i = A2(te, r, A2(te, e, u)), o = (c + i) / 2, f = t(c, i) ? 0 : .5 > o ? (i - c) / (i + c) : (i - c) / (2 - i - c), s = (t(i, r) ? (e - u) / (i - c) : t(i, e) ? 2 + (u - r) / (i - c) : 4 + (r - e) / (i - c)) * (1 / 6);
        return {
            X: a,
            cY: zp(s) ? 0 : 0 > s ? s + 1 : s,
            c7: o,
            dp: f
        };
    }, Zp = F2(function(n, r) {
        var t = Dp(r), e = t.dp, u = t.c7, a = t.X;
        return A4(Op, A3(Gc, 0, 1, n), e, u, a);
    }), Hp = F2(function(n, r) {
        var t = Dp(r), e = t.X;
        return A4(Op, t.cY, t.dp, A3(Gc, 0, 1, n), e);
    }), Qp = F2(function(n, r) {
        var t = Xu(r), e = t.au, u = t.ao, a = t.X;
        return A4(ku, A3(Gc, 0, 1, n), e, u, a);
    }), Pp = F2(function(n, r) {
        var t = Dp(r), e = t.c7, u = t.X;
        return A4(Op, t.cY, A3(Gc, 0, 1, n), e, u);
    }), Mp = F2(function(n, r) {
        return s(r, {
            cz: n
        });
    }), Sp = F2(function(n, r) {
        var t = A2(au, Tp, n);
        if (t.$) return r;
        var e = t.a.d$, u = t.a.eO, a = t.a.fb;
        if (176 === e && 114 === u) {
            var c = r.er.e7 + (a - 64) * r.bA, i = gc(c);
            return s(r, {
                er: A2(bv, c, r.er),
                M: i
            });
        }
        return 176 !== e || 115 !== u || a ? 176 === e && 112 === u ? s(r, {
            bA: A2(te, r.bA + 501e-6 * (a - 64), 1e-4)
        }) : 176 !== e || 113 !== u || a ? 169 === e && 43 === u ? s(r, {
            A: hv(1 - a / 128)
        }) : 137 === e && 43 === u ? s(r, {
            A: na
        }) : 153 === e && 37 === u ? s(r, {
            K: -r.K
        }) : 153 === e && 36 === u ? s(r, {
            v: !r.v
        }) : 176 === e && 18 === u ? s(r, {
            er: A2(od, yp(a), r.er)
        }) : 176 === e && 93 === u ? s(r, {
            er: A2(Mp, A2(Qp, 2 * a, r.er.cz), r.er)
        }) : 176 === e && 73 === u ? s(r, {
            er: A2(Mp, A2(kp, 2 * a, r.er.cz), r.er)
        }) : 176 === e && 75 === u ? s(r, {
            er: A2(Mp, A2(Kp, 2 * a, r.er.cz), r.er)
        }) : 176 === e && 91 === u ? s(r, {
            er: A2(sv, A2(Qp, 2 * a, r.er.dy), r.er)
        }) : 176 === e && 79 === u ? s(r, {
            er: A2(sv, A2(kp, 2 * a, r.er.dy), r.er)
        }) : 176 === e && 72 === u ? s(r, {
            er: A2(sv, A2(Kp, 2 * a, r.er.dy), r.er)
        }) : 176 === e && 71 === u ? s(r, {
            er: A2(Mp, A2(Zp, a / 127, r.er.cz), r.er)
        }) : 176 === e && 76 === u ? s(r, {
            er: A2(Mp, A2(Pp, a / 127, r.er.cz), r.er)
        }) : 176 === e && 77 === u ? s(r, {
            er: A2(Mp, A2(Hp, a / 127, r.er.cz), r.er)
        }) : 176 === e && 19 === u ? s(r, {
            er: A2(sv, A2(Zp, a / 127, r.er.dy), r.er)
        }) : 176 === e && 16 === u ? s(r, {
            er: A2(sv, A2(Pp, a / 127, r.er.dy), r.er)
        }) : 176 === e && 17 === u ? s(r, {
            er: A2(sv, A2(Hp, a / 127, r.er.dy), r.er)
        }) : r : s(r, {
            bA: .01
        }) : s(r, {
            er: Up(r.er)
        });
    }), Lp = function(n) {
        var r = n.a, t = r.a, e = r.b, u = n.b, a = u.a, c = u.b, i = 1 === c ? 1 / 1e-8 : 1 / (1 - c), f = A2(Pu, e / a, i), s = A2(Pu, e, 1 - i) * A2(Pu, a, i), b = function(n) {
            return A2(Et, f, n / s);
        }, d = b(t), l = function(n) {
            return (n - d) / (1 - d);
        };
        return o(A2(pu, function(n) {
            return n * (1 - d) + d;
        }, function(n) {
            return s * A2(Pu, f, n);
        }), A2(pu, b, l));
    }, Rp = o(o(1e-4, 4), o(1, .9)), xp = o(o(5e-5, 2.000001), o(1, .9)), Ip = F2(function(n, r) {
        return s(r, {
            d4: n,
            dC: Zt
        });
    }), Fp = F2(function(n, r) {
        var t = function(r) {
            return Dt(s(n, {
                er: A2(bv, r, n.er),
                M: gc(r)
            }));
        }, e = F3(function(n, r, t) {
            var e = Lp(n);
            return (0, e.a)(A2(t, (0, e.b)(r), .01));
        }), u = function(r) {
            return s(n, {
                er: A2(od, A3(e, Rp, n.er.dz, r), n.er)
            });
        }, a = function(r) {
            return s(n, {
                bA: A3(e, xp, n.bA, r)
            });
        };
        switch(r){
            case "c":
                return Dt(s(n, {
                    er: Up(n.er)
                }));
            case "i":
                return Dt(A2(Lv, n, n.o));
            case "d":
                return Dt(function(n) {
                    var r = function(n) {
                        var r;
                        return s(n, {
                            d1: (r = n.d1, A2(Uu, r.a, dp(r.b))),
                            dC: Zt
                        });
                    }(n.er);
                    return s(n, {
                        o: A2(qf, n.o, Mv(r) - 1),
                        er: r
                    });
                }(n));
            case " ":
                return Dt(s(n, {
                    v: !n.v
                }));
            case "s":
                return Dt(s(n, 1 === n.A.$ ? {
                    A: na
                } : {
                    A: hv(.05)
                }));
            case ",":
                return Dt(a(It));
            case ".":
                return Dt(a(zt));
            case "r":
                return Dt(s(n, {
                    K: -1 * n.K
                }));
            case "-":
                return Dt(A3(Wv, 30, n.T, n));
            case "_":
                return Dt(A3(Wv, 1, n.T, n));
            case "=":
                return Dt(A3(Wv, -30, n.T, n));
            case "+":
                return Dt(A3(Wv, -1, n.T, n));
            case "[":
                return Dt(u(It));
            case "]":
                return Dt(u(zt));
            case "o":
                return Dt(s(n, {
                    er: A2(Ip, 1 === n.er.d4 ? 0 : 1, n.er)
                }));
            case "0":
                return t(179);
            case "1":
                return t(120);
            case "2":
                return t(90);
            case "3":
                return t(72);
            case "4":
                return t(60);
            case "5":
                return t(360 / 7);
            case "6":
                return t(45);
            case "7":
                return t(135);
            case "8":
                return t(144);
            case "9":
                return t(165);
            default:
                return Zt;
        }
    }), wp = F2(function(n, r) {
        var t, e, u = function(r) {
            return Dt(s(n, {
                er: A3(bp, r, n.o, n.er)
            }));
        };
        return " " === r ? u(lu) : A2(Fa, function(n) {
            var r = n.a;
            return me(n.b) > 0 ? Zt : u(fu(r));
        }, (e = (t = r).charCodeAt(0), isNaN(e) ? Zt : Dt(55296 > e || e > 56319 ? o(t[0], t.slice(1)) : o(t[0] + t[1], t.slice(2)))));
    }), Np = {
        cz: Zt,
        d1: Zt,
        d4: Zt,
        dq: Zt,
        dy: Zt,
        dz: Zt,
        dK: Zt,
        e7: Zt
    }, Xp = F3(function(n, r, t) {
        var e = r, u = t;
        return function(r) {
            var t = e(r), a = t.a, c = u(t.b), i = c.b;
            return o(A2(n, a, c.a), i);
        };
    }), $p = F2(function(n, r) {
        return A3(Xp, F2(function(n, r) {
            return o(n, r);
        }), n, r);
    }), Yp = function(n) {
        var r = n.a, t = 277803737 * (r ^ r >>> 4 + (r >>> 28));
        return (t >>> 22 ^ t) >>> 0;
    }, gp = F2(function(n, r) {
        return function(t) {
            var e = xv(t), u = Ac(r - n), a = Yp(e);
            return o((1 * (67108863 & Yp(t)) * 134217728 + 1 * (134217727 & a)) / 9007199254740992 * u + n, xv(e));
        };
    }), jp = A2(Xv, function(n) {
        return A3(ri, n, 1, 1);
    }, A2(gp, 0, 6.283185307179586)), Jp = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r), u = e.b;
            return n(e.a)(u);
        };
    }), Ep = F2(function(n, r) {
        return function(t) {
            var e = 0 > a(n, r) ? o(n, r) : o(r, n), u = e.a, c = e.b - u + 1;
            if (c - 1 & c) {
                var i = (-c >>> 0) % c >>> 0;
                return function(n) {
                    for(;;){
                        var r = Yp(n), t = xv(n);
                        if (a(r, i) >= 0) return o(r % c + u, t);
                        n = t;
                    }
                }(t);
            }
            return o(((c - 1 & Yp(t)) >>> 0) + u, xv(t));
        };
    }), Ap = F4(function(n, r, t, e) {
        for(;;){
            if (1 > r) return o(n, e);
            var u = t(e), a = u.b;
            n = A2(yt, u.a, n), r -= 1, e = a;
        }
    }), Gp = F2(function(n, r) {
        var t = r;
        return function(r) {
            return A4(Ap, l, n, t, r);
        };
    }), Cp = F3(function(n, r, t) {
        for(;;){
            var e = n.a, u = n.b;
            if (!r.b) return u;
            var c = r.a, i = r.b;
            if (1 > a(t, Ac(e))) return u;
            n = c, r = i, t -= Ac(e);
        }
    }), Bp = F2(function(n, r) {
        var t = function(n) {
            return Ac(n.a);
        }, e = t(n) + A3(Lt, zt, 0, A2(xe, t, r));
        return A2(Xv, A2(Cp, n, r), A2(gp, 0, e));
    }), _p = A2(Bp, o(20, su), h([
        o(15, bu),
        o(5, du),
        o(1, lu)
    ])), nh = A2(Xv, mu, A2(Gp, 4, A2(Jp, function(n) {
        return A2(Gp, n, _p);
    }, A2(Ep, 1, 50)))), rh = function(n) {
        var r = F2(function(n, r) {
            var t = r.a, e = r.b;
            switch(n.$){
                case 0:
                case 4:
                    return o(t + 1, e);
                default:
                    return o(t, e + 1);
            }
        }), t = function(n) {
            return A3(Lt, r, o(0, 0), n);
        };
        return A3(Lt, F2(function(n, r) {
            var t = r.a;
            return o(n.a * t, r.b + t * n.b);
        }), o(1, 0), A2(xe, t, pb(n)));
    }, th = function(n) {
        return mu(A2(xe, function(n) {
            return rh(A2(Uu, n, l)).a ? n : A2(yt, su, n);
        }, pb(n)));
    }, eh = A2(Xv, function(n) {
        var r = n.b;
        return s(Np, {
            d1: Dt(th(n.a)),
            dy: Dt(r)
        });
    }, A2($p, nh, jp)), uh = F2(function(n, r) {
        return A2(Xv, function(n) {
            return A2(Jc, n, su);
        }, A2(Ep, n, r));
    }), ah = F4(function(n, r, t, e) {
        return A2(Xv, function(n) {
            var r = n.a, t = n.b;
            return d(A2(Jc, r, su), A2(yt, bu, d(A2(Jc, t, su), A2(yt, bu, d(A2(Jc, r, su), A2(yt, bu, d(A2(Jc, t, su), h([
                bu
            ]))))))));
        }, A2($p, A2(Ep, n, r), A2(Ep, t, e)));
    }), ch = ($v = h([
        A2(uh, 5, 15),
        A4(ah, 1, 5, 3, 10),
        A2(uh, 5, 15),
        A4(ah, 1, 1, 3, 10)
    ]), A3(Re, F2(function(n, r) {
        return A2(Xv, function(n) {
            return A2(yt, n.a, n.b);
        }, A2($p, n, r));
    }), (Yv = l, function(n) {
        return o(Yv, n);
    }), $v)), ih = A2(Xv, mu, ch), oh = F3(function(n, r, t) {
        return A2(Xv, function(n) {
            var r = n.b;
            return f(n.a, r.a, r.b);
        }, A2($p, n, A2($p, r, t)));
    }), fh = A2(Xv, function(n) {
        var r = n.b, t = n.c;
        return s(Np, {
            d1: Dt(th(n.a)),
            dy: Dt(r),
            e7: Dt(t)
        });
    }, A3(oh, ih, jp, A2(gp, 0, 360))), sh = An("requestFullscreen", function() {
        return Kv;
    }), bh = function(n) {
        var r;
        return s(n, {
            d1: A2(ed, h([
                su
            ]), (r = n.d1, A2(Uu, r.a, l))),
            dC: Zt
        });
    }, dh = A2(pu, function(n) {
        return n.d1;
    }, pb), lh = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return Zt;
        var r = +n;
        return r == r ? Dt(r) : Zt;
    }, vh = F2(function(n, r) {
        var t = r.b;
        return o(n(r.a), t);
    }), ph = F2(function(n, r) {
        var t = n.a, e = n.b, u = fv(r);
        return A3(ri, e, t, u.fa);
    }), hh = F2(function(n, r) {
        var t = r.a, e = r.b, u = n.ba;
        if (u.$) return n.d_;
        var a = u.a, c = o(a.ec.a5, a.ec.aT), i = c.a, f = c.b, s = A2(vh, A2(Gc, 0, 1), Tf(o((t - i / 2) / (i / 2), (e - f / 2) / (f / 2))));
        return A2(ph, s, n.d_);
    }), qh = F2(function(n, r) {
        var e = t(r.ba, Zt) ? rp(r) : la;
        switch(n.$){
            case 4:
                var u = n.a, a = fv(r.d_);
                return f(s(r, {
                    d_: c = A3(ri, a.el, a.eZ, u)
                }), Dt(c), la);
            case 1:
                var c, i = n.a;
                return f(s(r, {
                    d_: c = A2(hh, r, i),
                    cd: i
                }), Dt(c), e);
            case 0:
                return f(s(r, {
                    ba: Zd(n.a)
                }), Zt, la);
            case 2:
                return f(s(r, {
                    ax: !0
                }), Zt, la);
            case 3:
                return f(s(r, {
                    ax: !1
                }), Zt, la);
            case 5:
                return f(s(r, {
                    bQ: n.a
                }), Zt, la);
            case 6:
                return f(s(r, {
                    bF: n.a
                }), Zt, la);
            default:
                return f(s(r, {
                    a9: !r.a9
                }), Zt, la);
        }
    }), yh = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Uh = function(n) {
        return s(n, {
            ad: !1
        });
    }, mh = F2(function(n, r) {
        return 0 > n ? Zt : ko(A2(Vc, n, r));
    }), Wh = F3(function(n, r, t) {
        if (0 > n) return t;
        var e = A2(Vc, n, t);
        if (e.b) {
            var u = e.b;
            return d(A2(Oc, n, t), A2(yt, r(e.a), u));
        }
        return t;
    }), Vh = F2(function(n, r) {
        return A2(Wh, n, Xb(r));
    }), Th = F3(function(n, r, t) {
        switch(r){
            case 0:
                return o({
                    ad: !0,
                    bk: !0
                }, la);
            case 1:
                return o(s(t, {
                    bk: !1
                }), A2(Eb, 200, n(2)));
            default:
                return o(s(t, {
                    ad: !!t.bk && t.ad
                }), la);
        }
    }), Kh = F2(function(n, r) {
        var e = r;
        if (1 === n.$) return o(s(e, {
            aN: A2(xe, Uh, e.aN),
            bS: Zt
        }), la);
        var u = n.a, a = n.b, c = e.aN, i = e.dG, f = e.bS, b = A2(mh, u, c);
        if (b.$) return o(e, la);
        var d = b.a, l = A3(Th, A2(pu, yh(u), i), a, d), v = l.a, p = l.b;
        return o(s(e, {
            aN: A2(Iu, he, A2(wc, function(n) {
                return !t(n, u) && v.ad ? A2(Wh, n, Uh) : he;
            }, f))(A3(Vh, u, v, c)),
            bS: v.ad ? Dt(u) : Zt
        }), p);
    }), kh = F2(function(n, r) {
        return A2(Uu, n, r.b);
    }), Oh = F2(function(n, r) {
        return s(r, {
            d1: A2(kh, aa(n), r.d1),
            dC: Zt,
            e7: ua(n)
        });
    }), zh = F2(function(n, r) {
        return s(n, {
            er: A2(Oh, r, n.er)
        });
    }), Dh = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Zh = function(n) {
        return encodeURIComponent(n);
    }, Hh = F2(function(n, r) {
        return A2(Dh, Zh(n), Zh(r));
    }), Qh = function(n) {
        return n.a + "=" + n.b;
    }, Ph = F2(function(n, r) {
        return s(r, {
            d1: mu(n),
            dC: Zt
        });
    }), Mh = F2(function(n, r) {
        return function(n) {
            var r = n.a, t = n.b, e = n.c;
            return f(function() {
                if (r.ak) return r;
                var n = Cl(r.er);
                return s(r, {
                    er: n,
                    bf: A2(op, eb, n)
                });
            }(), t, e);
        }(function() {
            switch(n.$){
                case 0:
                    var e = A2(Kh, n.a, r.bs), u = e.b;
                    return f(s(r, {
                        bs: e.a
                    }), u, qv);
                case 44:
                    var c = A3(Yc.e8, n.a, r.ap, dh(r.er)), i = c.a, b = c.b, l = t(b, dh(r.er)) ? o(r.er, pv) : o(A2(Ph, b, r.er), qv), v = l.a, p = l.b, q = o(Yc.bg(r.ap), Yc.bg(i)), y = (C = o(q.a, q.b)).a.$ || 1 !== C.b.$ ? Zt : Dt(C.a.a.eb);
                    return f(s(r, {
                        ap: i,
                        o: A2(Iu, r.o, y),
                        er: v
                    }), Yc.d0(i), p);
                case 40:
                    return f(r, A2(_v, lv, 1 === n.a ? fh : eh), pv);
                case 41:
                    var U = A2(_d, n.a, r.er);
                    return f(Sv(s(r, {
                        q: A3(rl, U, r.N, r.q),
                        er: U
                    })), la, qv);
                case 25:
                    var m = r.dM;
                    if (1 === m.$) return f(r, la, pv);
                    var W = m.a, V = (W.eW ? "https://" : "http://") + W.eo + function(n) {
                        return n.$ ? "" : ":" + Pt(n.a);
                    }(W.eV) + "/" + function(n) {
                        return d(yd(0), function(n) {
                            var r, t = F2(function(n, r) {
                                return A2(Hh, n(Gu), A2(Qt, 0, r));
                            });
                            return (r = h([
                                A2(t, function(n) {
                                    return n.d1;
                                }, hb(n.d1)),
                                A2(t, function(n) {
                                    return n.e7;
                                }, yb(n.e7)),
                                A2(t, function(n) {
                                    return n.cz;
                                }, bb(n.cz)),
                                A2(t, function(n) {
                                    return n.dy;
                                }, bb(n.dy)),
                                A2(t, function(n) {
                                    return n.dz;
                                }, yb(n.dz)),
                                A2(t, function(n) {
                                    return n.bv;
                                }, yb(n.dK.a)),
                                A2(t, function(n) {
                                    return n.bw;
                                }, yb(n.dK.b)),
                                A2(t, function(n) {
                                    return n.dq;
                                }, yb(n.dq)),
                                A2(t, function(n) {
                                    return n.d4;
                                }, qb(n.d4))
                            ])).b ? "?" + A2(Mt, "&", A2(xe, Qh, r)) : "";
                        }(n.er));
                    }(r);
                    return f(r, Tv(V), pv);
                case 26:
                    var T = n.a ? "URL copied!" : "There was an error :(";
                    return f(s(r, {
                        an: Dt(T)
                    }), uu(h([
                        tp(T),
                        $b(ra)
                    ])), pv);
                case 27:
                    return f(r, kv(0), pv);
                case 28:
                    return f(r, Ov(0), pv);
                case 39:
                    return f(r, sh(0), pv);
                case 5:
                    return f(s(r, {
                        o: 1,
                        er: bh(r.er)
                    }), la, qv);
                case 4:
                    return f(Sv(s(r, {
                        er: Uv(r.er)
                    })), la, qv);
                case 7:
                    return f(A2(Lv, r, n.a), la, qv);
                case 8:
                    return f(s(r, {
                        o: K = n.a
                    }), la, pv);
                case 9:
                    return f(s(r, {
                        bc: Dt(K = n.a)
                    }), la, pv);
                case 10:
                    return f(s(r, {
                        bc: Zt
                    }), la, pv);
                case 11:
                    var K;
                    return f(s(r, {
                        o: 1 > a(K = n.a, r.o) ? A2(te, 0, r.o - 1) : r.o,
                        er: A2(Hv, K, r.er)
                    }), la, qv);
                case 1:
                    var k = n.a, O = A2(wp, r, k), z = A2(Fp, r, k), D = A2(pp, r, k);
                    return D.$ ? 1 === r.bN ? O.$ ? f(r, la, pv) : f(O.a, la, qv) : "a" === k ? f(r, A2(ba, Xb(vv), tv("TurnAngle")), pv) : "R" === k ? f(r, A2(_v, lv, fh), qv) : f(z.$ ? r : z.a, la, pv) : f(D.a, la, qv);
                case 18:
                    return f(A3(Wv, n.b, n.d, r), la, qv);
                case 20:
                    var Z = A2(qh, n.a, r.q), H = Z.b, Q = (u = Z.c, s(r, {
                        q: Z.a
                    }));
                    return H.$ ? f(Q, A2(gb, Pl, u), pv) : f(s(Q, {
                        er: A2(r.N ? Mp : sv, H.a, r.er)
                    }), A2(gb, Pl, u), qv);
                case 19:
                    var P = n.a;
                    return f(s(r, {
                        N: P,
                        q: A3(rl, r.er, P, r.q)
                    }), la, pv);
                case 21:
                    var M = A2(Mp, r.er.dy, A2(sv, r.er.cz, r.er));
                    return f(s(r, {
                        q: A3(rl, M, r.N, r.q),
                        er: M
                    }), la, qv);
                case 22:
                    var S = n.a;
                    if ("" === S) return f(s(r, {
                        er: A2(bv, 0, r.er),
                        M: "0"
                    }), la, qv);
                    var L = lh(S);
                    return L.$ ? f(s(r, {
                        M: S
                    }), la, pv) : f(s(r, {
                        er: A2(bv, L.a, r.er),
                        M: S
                    }), la, r.v ? pv : qv);
                case 2:
                    var R = n.a, x = (_ = r.A).$ ? _.a * r.K * r.bA : r.K * r.bA, I = function(n) {
                        return A2(n, r.er.e7, x);
                    }, F = A2(fa, gc, I), w = function(n) {
                        return f(s(r, {
                            er: A2(bv, I(n), r.er),
                            M: F(n)
                        }), la, qv);
                    };
                    switch(R){
                        case "Escape":
                            return f(r, A2(ba, function() {
                                return vv;
                            }, Vv("TurnAngle")), pv);
                        case "ArrowUp":
                            return w(zt);
                        case "ArrowDown":
                            return w(It);
                        default:
                            return f(r, la, pv);
                    }
                case 3:
                    return f(s(r, {
                        bN: n.a
                    }), la, pv);
                case 23:
                    return f(s(r, {
                        er: A2(od, n.a, r.er)
                    }), la, qv);
                case 24:
                    return f(s(r, {
                        er: A2(Ip, 1 === r.er.d4 ? 0 : 1, r.er)
                    }), la, qv);
                case 15:
                    return f(s(r, {
                        bh: N = n.a,
                        bo: !0
                    }), la, pv);
                case 16:
                    return f(s(r, {
                        bo: !1
                    }), la, qv);
                case 17:
                    var N;
                    return f(s(r, {
                        er: A3(up, r.bh, N = n.a, r.er),
                        bh: N
                    }), la, pv);
                case 29:
                    return f(s(r, {
                        bK: n.a
                    }), la, pv);
                case 6:
                    return f(A2(zh, r, n.a), la, qv);
                case 13:
                    var X = n.a;
                    if (X.$) return f(r, la, pv);
                    var $ = X.a.ec, Y = $.ff, g = $.fg;
                    return f(s(r, {
                        T: o(Y + $.a5 / 2, g + $.aT / 2),
                        bL: o(Y, g)
                    }), la, pv);
                case 14:
                    return f(r, uu(h([
                        Yb,
                        A2(gb, Pl, rp(r.q))
                    ])), pv);
                case 30:
                    return f(s(r, {
                        v: !r.v
                    }), la, qv);
                case 31:
                    return f(s(r, {
                        aJ: !r.aJ
                    }), la, qv);
                case 32:
                    var j = F2(function(n, t) {
                        return s(t, {
                            q: A2(nl, n, t.q),
                            er: A2(r.N ? Mp : sv, n, t.er)
                        });
                    }), J = F2(function(n, r) {
                        return s(r, {
                            er: A2(bv, n, r.er),
                            M: gc(n)
                        });
                    }), E = function() {
                        var n = r.N ? r.er.cz : r.er.dy, t = fv(n);
                        return r.v && r.aJ ? A4(ni, t.el + .01, t.eZ, t.fa, t.dO) : n;
                    }();
                    return f((B = A2(J, function() {
                        if (r.v) {
                            var n = r.A;
                            return n.$ ? r.er.e7 + n.a * r.K * r.bA : r.er.e7 + r.K * r.bA;
                        }
                        return r.er.e7;
                    }(), A2(j, E, r)), r.ak ? s(B, {
                        v: !1
                    }) : B), la, pv);
                case 33:
                    return f(s(r, 1 === r.A.$ ? {
                        A: na
                    } : {
                        A: hv(.05)
                    }), la, pv);
                case 34:
                    return f(s(r, {
                        bA: n.a
                    }), la, pv);
                case 35:
                    return f(s(r, {
                        K: -1 * r.K
                    }), la, pv);
                case 36:
                    return f(s(r, {
                        ak: !1
                    }), la, pv);
                case 37:
                    var A = n.a;
                    if (r.ak) return f(r, la, pv);
                    var G = a(A, r.aS) > 0;
                    return f(s(r, {
                        ae: G ? A : r.ae,
                        ak: G
                    }), la, pv);
                case 38:
                    return f(s(r, {
                        aS: n.a
                    }), la, pv);
                case 12:
                    return f(s(r, {
                        an: Dt("Image saved!")
                    }), uu(h([
                        tp("Image saved!"),
                        $b(ra)
                    ])), {
                        $: 1,
                        a: r.er
                    });
                case 42:
                    return f(A2(Sp, n.a, r), la, pv);
                case 43:
                    return t(r.an, Dt(n.a)) ? f(s(r, {
                        an: Zt
                    }), la, pv) : f(r, la, pv);
                default:
                    return f(r, la, pv);
            }
            var C, B, _;
        }());
    }), Sh = F2(function(n, r) {
        if (n.$) {
            var t = A2(Mh, {
                $: 37,
                a: n.a
            }, r.k);
            return u = t.b, a = t.c, f(s(r, {
                k: t.a,
                bp: !1
            }), A2(gb, wb, u), a);
        }
        var e = A2(Mh, n.a, r.k), u = e.b, a = e.c;
        return f(s(r, {
            k: e.a,
            bp: !0
        }), A2(gb, wb, u), a);
    }), Lh = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Rh = {
        $: 2
    }, xh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ih = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Fh = {
        $: 1
    }, wh = F2(function(n, r) {
        return A2(ru, r, function(n) {
            return Vn(function(r) {
                (dt = document.createElement("input")).type = "file", dt.accept = A2(Mt, ",", n), dt.addEventListener("change", function(n) {
                    r(Wn(n.target.files[0]));
                }), vt(dt);
            });
        }(n));
    }), Nh = F2(function(n, r) {
        for(;;){
            if (!r.b) return Zt;
            var t = r.a, e = r.b;
            if (n(t)) return Dt(t);
            r = e;
        }
    }), Xh = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return Zt;
            var e = t.b;
            if (r(t.a)) return Dt(n);
            n += 1, t = e;
        }
    }), $h = Xh(0), Yh = F2(function(n, r) {
        if (0 > n) return r;
        var t = A2(Vc, n, r);
        if (t.b) {
            var e = t.b;
            return d(A2(Oc, n, r), e);
        }
        return r;
    }), gh = F3(function(n, r, t) {
        return A2(ru, Pe, A3(lt, n, r, t));
    }), jh = F2(function(n, r) {
        switch(n.$){
            case 0:
                return f(s(r, {
                    x: (l = A2($h, A2(pu, function(n) {
                        return n.G;
                    }, _t(n.a)), r.x)).$ ? r.x : A2(Yh, l.a, r.x)
                }), la, Fh);
            case 1:
                var t = A2(Nh, A2(pu, function(n) {
                    return n.G;
                }, _t(n.a)), r.x);
                return f(r, la, t.$ ? Rh : xh(Dt(t.a.er)));
            case 2:
                return f(r, la, xh(Zt));
            case 3:
                var e = A2(Qt, 4, Ib(r));
                return f(r, A3(gh, "genart-gallery.json", "application/json", e), Rh);
            case 4:
                return f(r, A2(wh, h([
                    "application/json"
                ]), Ih), Rh);
            case 5:
                return f(r, A2(ru, Lh, (b = n.a, Vn(function(n) {
                    var r = new FileReader;
                    return r.addEventListener("loadend", function() {
                        n(Wn(r.result));
                    }), r.readAsText(b), function() {
                        r.abort();
                    };
                }))), Rh);
            case 6:
                var u = A2(Kd, Sb, e = n.a);
                return u.$ ? f(r, la, Rh) : f(s(r, {
                    x: d(A2(xe, Bl, u.a.x), r.x)
                }), la, Fh);
            case 7:
                var a = A2(Kh, n.a, r.bs), c = a.b;
                return f(s(r, {
                    bs: a.a
                }), c, Fh);
            case 8:
                return f(s(r, {
                    x: A2(xe, Bl, r.x)
                }), la, Fh);
            case 9:
                return f(s(r, {
                    be: Dt(n.a)
                }), la, Fh);
            case 10:
                return f(s(r, {
                    be: Zt
                }), la, Fh);
            default:
                var i = A3(Pb.e8, n.a, r.ap, r.x), o = i.a;
                return f(s(r, {
                    ap: o,
                    x: i.b
                }), Pb.d0(o), Fh);
        }
        var b, l;
    }), Jh = {
        $: 0
    }, Eh = F2(function(n, r) {
        switch(n){
            case 0:
                var t = r.er.e7 - r.bA, e = fv(r.er.dy), u = A4(ni, e.el + .02, e.eZ, e.fa, e.dO);
                return f(s(r, {
                    er: A2(od, A2(qf, 1.01 * r.er.dz, .1), A2(bv, t, A2(sv, u, r.er))),
                    bA: A2(qf, 1.07 * r.bA, .03)
                }), la, Jh);
            case 1:
                return f(s(r, {
                    b0: !0
                }), la, Jh);
            default:
                return f(r, la, {
                    $: 1,
                    a: r.er
                });
        }
    }), Ah = {
        $: 2
    }, Gh = {
        $: 0
    }, Ch = F2(function(n, r) {
        return (n / 2 + 1) * r;
    }), Bh = F2(function(n, r) {
        switch(n.$){
            case 1:
                var t = n.a;
                return f(s(r, {
                    er: A2(bv, 90, A2(Gb, A2(id, t, r.aK), r.er)),
                    bA: fd,
                    bC: t
                }), la, Gh);
            case 3:
                var e = n.a;
                return f(s(r, {
                    aK: r.aK + e,
                    er: A2(Gb, A2(id, r.bC, r.aK + e), r.er)
                }), la, Gh);
            case 4:
                return f(s(r, {
                    er: A2(od, A2(Ch, n.a, r.er.dz), r.er)
                }), la, Gh);
            case 6:
                return f(s(r, {
                    er: A2(bv, 90, r.er),
                    bA: fd
                }), la, Gh);
            case 5:
                return f(s(r, {
                    ca: !r.ca,
                    bA: fd
                }), la, Gh);
            case 0:
                var u = r.er.e7 + r.bA, a = fv(r.er.dy);
                return f(s(r, {
                    er: A2(bv, u, A2(sv, A4(ni, a.el + .02, a.eZ, a.fa, a.dO), r.er)),
                    bA: A2(qf, 1.07 * r.bA, .03)
                }), la, Gh);
            case 2:
                return f(r, la, {
                    $: 1,
                    a: r.er
                });
            case 7:
                return f(r, la, Ah);
            default:
                var c = A2(Kh, n.a, r.bs), i = c.b;
                return f(s(r, {
                    bs: c.a
                }), i, Gh);
        }
    }), _h = F2(function(n, r) {
        return s(r, {
            k: A2(tl, n, r.k)
        });
    }), nq = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(dd, Gd(n.a), !1);
                return o(s(r, {
                    a3: t
                }), A2(uv, r, t));
            case 1:
                var e = n.a;
                return o(r, e.$ ? (V = e.a, A2(ru, Pe, Vn(function() {
                    try {
                        at.location = V;
                    } catch (n) {
                        tr.location.reload(!1);
                    }
                }))) : A2(av, r.ay, function(n) {
                    return A3(iv, "#", n.cU, A3(iv, "?", n.dh, d(A2(cv, n.eV, d(n.eW ? "https://" : "http://", n.eo)), n.ai)));
                }(e.a)));
            case 2:
                var u = A2(Sh, n.a, r.k), a = u.b, c = u.c, i = s(r, {
                    k: u.a
                }), f = A2(gb, tu, a);
                switch(c.$){
                    case 0:
                        return o(i, uu(h([
                            f,
                            Bd(Fb(i))
                        ])));
                    case 1:
                        var b = s(i, {
                            x: A2(_l, c.a, i.x)
                        });
                        return o(b, uu(h([
                            f,
                            Bd(Fb(b))
                        ])));
                    default:
                        return o(i, f);
                }
            case 3:
                var l = A2(jh, n.a, r.x), v = l.a;
                switch(c = l.c, f = A2(gb, fl, l.b), c.$){
                    case 1:
                        return o(i = s(r, {
                            x: v
                        }), uu(h([
                            f,
                            Bd(Fb(i))
                        ])));
                    case 0:
                        return o(i = s(r, {
                            k: A2(_h, A2(Iu, r.k.k.er, c.a), r.k)
                        }), uu(h([
                            f,
                            A2(Cd, i.ay, yd(0)),
                            Bd(Fb(i))
                        ])));
                    default:
                        return o(r, f);
                }
            case 4:
                var p = A2(Eh, n.a, r.a4), q = p.a;
                return c = p.c, f = A2(gb, eu, p.b), 1 === c.$ ? o(s(r, {
                    k: A2(_h, c.a, r.k)
                }), A2(Cd, r.ay, yd(0))) : o(s(r, {
                    a4: q
                }), f);
            case 6:
                var y = A2(dv, n.a, r.aL), U = y.a;
                return c = y.c, f = A2(gb, ol, y.b), 1 === c.$ ? o(s(r, {
                    k: A2(_h, c.a, r.k)
                }), A2(Cd, r.ay, yd(0))) : o(s(r, {
                    aL: U
                }), f);
            default:
                var m = A2(Bh, n.a, r.a6), W = m.a;
                switch(c = m.c, f = A2(gb, sl, m.b), c.$){
                    case 1:
                        return o(s(r, {
                            k: A2(_h, c.a, r.k)
                        }), A2(Cd, r.ay, yd(0)));
                    case 0:
                        return o(s(r, {
                            a6: W
                        }), f);
                    default:
                        return o(r, f);
                }
        }
        var V;
    }), rq = Ds("font-family"), tq = Cf, eq = fr, uq = eq, aq = {
        as: 0,
        W: "sans-serif"
    }, cq = F2(function(n, r) {
        return A2($o, r, A2(eo, n, l));
    }), iq = ms, oq = F2(function(n, r) {
        var t, e = r.dF, u = r.cE;
        return {
            cE: d(A2(xe, uq(n), u), h([
                iq((t = h([
                    A2(cq, "body", h([
                        rq(aq)
                    ]))
                ]), tq(A3(es, "style", l, Do(ss(No(Do(Yo(t)))))))))
            ])),
            dF: e
        };
    }), fq = function(n) {
        return A2(ii, "border-color", n.W);
    }, sq = Ds("bottom"), bq = function(n) {
        return A2(ii, "color", n.W);
    }, dq = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), lq = function(n) {
        return dq({
            $: 2,
            a: n
        });
    }, vq = lq("hover"), pq = F3(function(n, r, t) {
        return A2(ii, n, A2(Mt, " ", h([
            r.W,
            t.W
        ])));
    }), hq = pq("margin"), qq = Ds("padding"), yq = Os("button"), Uq = function(n) {
        return A2(Ns, "click", ve(n));
    }, mq = {
        dQ: 0,
        c: 0,
        aP: 0,
        bM: 0,
        ev: 0,
        aU: 0,
        af: 0,
        U: 0,
        aX: 0,
        R: 0,
        b1: 0,
        a0: 0,
        J: 0,
        W: "auto"
    }, Wq = {
        l: 0,
        W: "block"
    }, Vq = F4(function(n, r, t, e) {
        return A2(ii, n, A2(Mt, " ", h([
            r.W,
            t.W,
            e.W
        ])));
    }), Tq = Vq("border"), Kq = {
        b4: 0,
        bG: 0,
        W: "border-box"
    }, kq = Ds("border-radius"), Oq = Ds("box-sizing"), zq = Ds("center"), Dq = Ds("cursor"), Zq = Ds("display"), Hq = Ds("font-size"), Qq = ju("#ABAAAA"), Pq = Ds("line-height"), Mq = {
        aF: 0,
        cD: 0,
        B: 0,
        c: 0,
        l: 0,
        eq: 0,
        c$: 0,
        cb: 0,
        aW: 0,
        av: 0,
        U: 0,
        e: 0,
        d: 0,
        cf: 0,
        bU: 0,
        eU: 0,
        R: 0,
        bY: 0,
        e_: 0,
        a_: 0,
        aD: 0,
        J: 0,
        i: 0,
        e9: 0,
        W: "none"
    }, Sq = {
        c: 0,
        W: "pointer"
    }, Lq = lq("active"), Rq = Ds("border"), xq = A3(Nu, 130, 130, 130), Iq = h([
        oi(_s(xq))
    ]), Fq = s({
        cw: 0,
        s: 0,
        a8: 0,
        cy: 0,
        aF: 0,
        cA: 0,
        aG: 0,
        Z: 0,
        B: 0,
        bG: 0,
        d_: 0,
        c: 0,
        l: 0,
        aP: 0,
        b8: 0,
        bb: 0,
        bJ: 0,
        as: 0,
        w: 0,
        aQ: 0,
        h: 0,
        ac: 0,
        bM: 0,
        c3: 0,
        cb: 0,
        bi: 0,
        aU: 0,
        af: 0,
        aV: 0,
        aW: 0,
        av: 0,
        aw: 0,
        U: 0,
        bO: 0,
        e: 0,
        d: 0,
        cf: 0,
        bl: 0,
        ah: 0,
        bU: 0,
        aX: 0,
        R: 0,
        b1: 0,
        a_: 0,
        aC: 0,
        a$: 0,
        a0: 0,
        aD: 0,
        J: 0,
        a1: "",
        bz: 0,
        W: "initial",
        bB: 0,
        am: 0
    }, {
        W: "unset"
    }), wq = (gv = _s(Qq), jv = _s(ta), h([
        Rq(Fq),
        oi(gv),
        bq(jv),
        Lq(Iq),
        Pq(As(28))
    ])), Nq = {
        B: 0,
        aC: 0,
        W: "solid"
    }, Xq = function(n) {
        return {
            $: 6,
            a: n
        };
    }, $q = F2(function(n, r) {
        return ci(n + ":" + r);
    }), Yq = F3(function(n, r, t) {
        n: for(;;)switch(t.$){
            case 0:
                var e = A2(Iu, "", ko(A2(St, ":", t.a)));
                return A2($q, r, e);
            case 1:
                return A2($q, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-selector");
            case 2:
                return A2($q, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-combinator");
            case 3:
                return A2($q, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-pseudo-element setter");
            case 4:
                return A2($q, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-media-query");
            case 5:
                return A2($q, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-keyframes");
            default:
                if (t.a.b) {
                    if (t.a.b.b) {
                        t = Xq(t.a.b);
                        continue n;
                    }
                    t = t.a.a;
                    continue n;
                }
                return A2($q, r, "elm-css-error-cannot-apply-" + n + "-with-empty-Style");
        }
    }), gq = A3(Js, 0, "", 0), jq = function(n) {
        return A3(Yq, "textAlign", "text-align", n(gq));
    }, Jq = Ds("text-decoration"), Eq = {
        d_: 0,
        W: "transparent"
    }, Aq = function() {
        var n = _s(Qq);
        return h([
            bq(n),
            oi(Eq),
            A3(Tq, As(1), Nq, n),
            kq(As(6)),
            Qs(As(28)),
            rb(Es(95)),
            A2(hq, As(5), mq),
            Zq(Wq),
            Dq(Sq),
            Oq(Kq),
            rq(aq),
            Hq(As(16)),
            jq(zq),
            Jq(Mq),
            Pq(As(26)),
            vq(wq)
        ]);
    }(), Gq = function(n) {
        return Cf(ss(n));
    }, Cq = F3(function(n, r, t) {
        return A2(yq, h([
            Jo(d(Aq, n)),
            Uq(r)
        ]), h([
            Gq(t)
        ]));
    }), Bq = F2(function(n, r) {
        var t = Xu(r);
        return A4(ku, t.aB, t.au, t.ao, A3(Gc, 0, 1, n));
    }), _q = function(n) {
        var r = _s(A2(Bq, .5, n));
        return A3(Cq, h([
            Zs(Ks),
            sq(As(40)),
            A2(hq, tb, A3(bi, Es(50), 1, As(100))),
            rb(As(200)),
            Qs(As(50)),
            qq(As(10)),
            bq(r),
            fq(r),
            vq(h([
                oi(r),
                bq(_s(ub)),
                fq(_s(ub))
            ]))
        ]), 2, "Click here to begin");
    }, ny = A4(ku, 0, 0, 0, .3), ry = F6(function(n, r, t, e, u, a) {
        return A2(ii, n, A2(Mt, " ", h([
            r.W,
            t.W,
            e.W,
            u.W,
            a.W
        ])));
    }), ty = ry("box-shadow"), ey = Ss("className"), uy = function(n) {
        return {
            ac: 0,
            bM: 0,
            aw: 0,
            U: 0,
            bl: 0,
            bR: 0,
            ah: n,
            a1: "",
            bz: 0,
            W: Pt(n)
        };
    }, ay = Ds("left"), cy = pq("padding"), iy = Ds("pointer-events"), oy = function(n) {
        return qi(n) ? {
            W: "none"
        } : {
            W: A2(Mt, " ", A2(xe, function(n) {
                return n.W;
            }, n))
        };
    }, fy = A2(fa, Ds("transform"), oy), sy = function(n) {
        return fy(h([
            n
        ]));
    }, by = F2(function(n, r) {
        return {
            i: 0,
            W: A2(si, "translate", h([
                n.W,
                r.W
            ]))
        };
    }), dy = Ds("z-index"), ly = {
        $: 4
    }, vy = function(n) {
        return {
            $: 11,
            a: n
        };
    }, py = function(n) {
        return {
            $: 9,
            a: n
        };
    }, hy = {
        $: 10
    }, qy = function(n) {
        return {
            $: 8,
            a: n
        };
    }, yy = {
        bX: 0,
        W: "absolute"
    }, Uy = A3(Nu, 170, 170, 170), my = Vq("margin"), Wy = F3(function(n, r, t) {
        var e = t ? Uy : n;
        return r ? h([
            A3(Tq, As(2), Nq, _s(e)),
            A3(my, As(-2), As(-2), As(18))
        ]) : l;
    }), Vy = {
        b4: 0,
        bG: 0,
        W: "content-box"
    }, Ty = {
        c: 0,
        W: "grab"
    }, Ky = {
        bX: 0,
        W: "relative"
    }, ky = function(n) {
        return h([
            Qs(As(150)),
            rb(Es(100)),
            A3(my, tb, mq, As(20)),
            Dq(Ty),
            kq(As(3)),
            vq(h([
                A3(Tq, As(3), Nq, _s(n)),
                Oq(Vy),
                A3(my, As(-3), As(-3), As(17))
            ])),
            Zs(Ky),
            A5(ty, As(1), As(1), As(2), As(2), _s(ny))
        ]);
    }, Oy = function(n) {
        return A3(di, n, l, "");
    }, zy = A4(ku, 0, 0, 0, 0), Dy = {
        ej: zy,
        ai: "",
        e0: 24,
        dy: zy,
        dz: 10
    }, Zy = s(Dy, {
        ai: "M 88.277344 21.988281 L 67.179688 0.890625 C 66.601562 0.3125 65.820312 0 65.027344 0 L 34.492188 0 C 32.8125 0 31.449219 1.363281 31.449219 3.042969 L 31.449219 20.511719 L 13.980469 20.511719 C 12.300781 20.511719 10.9375 21.875 10.9375 23.554688 L 10.9375 96.957031 C 10.9375 98.636719 12.300781 100 13.980469 100 L 65.613281 100 C 67.292969 100 68.65625 98.636719 68.65625 96.957031 L 68.65625 79.488281 L 86.125 79.488281 C 87.804688 79.488281 89.167969 78.125 89.167969 76.445312 L 89.167969 24.140625 C 89.167969 23.367188 88.871094 22.582031 88.277344 21.988281 Z M 83.082031 73.402344 L 68.65625 73.402344 L 68.65625 44.652344 C 68.65625 43.863281 68.347656 43.085938 67.765625 42.5 L 46.667969 21.402344 C 46.09375 20.828125 45.316406 20.511719 44.515625 20.511719 L 37.535156 20.511719 L 37.535156 6.085938 L 61.984375 6.085938 L 61.984375 24.140625 C 61.984375 25.820312 63.347656 27.183594 65.027344 27.183594 L 83.082031 27.183594 Z M 62.570312 93.914062 L 17.023438 93.914062 L 17.023438 26.597656 L 41.472656 26.597656 L 41.472656 44.652344 C 41.472656 46.332031 42.835938 47.695312 44.515625 47.695312 L 62.570312 47.695312 Z M 47.558594 30.898438 L 58.269531 41.609375 L 47.558594 41.609375 Z M 78.78125 21.097656 L 68.070312 21.097656 L 68.070312 10.386719 C 69.410156 11.726562 77.710938 20.03125 78.78125 21.097656 Z M 78.78125 21.097656"
    }), Hy = s(Dy, {
        ej: Xf,
        ai: "M25,29.26V24.07H37.5c-.52-3.1.34-6.13,2.27-7.77A5.54,5.54,0,0,1,43.18,15H58a5.84,5.84,0,0,1,2.28,1.3c2.8,2.6,2.33,7.3,2.27,7.77H75v5.19H70.45v48a9.17,9.17,0,0,1-1.13,3.89A7.94,7.94,0,0,1,63.64,85H37.5a8.19,8.19,0,0,1-6.82-3.89,9,9,0,0,1-1.13-3.89v-48Zm17-5.19H58a4.88,4.88,0,0,0,0-3.88,3.42,3.42,0,0,0-1.13-1.3H43.18a3.42,3.42,0,0,0-1.13,1.3A4.88,4.88,0,0,0,42.05,24.07ZM39.77,35.74V72h3.41V35.74Zm9.09,0V72h3.41V35.74Zm9.09,0V72h3.41V35.74Z",
        dy: zy
    }), Qy = function(n) {
        return {
            aw: 0,
            U: 0,
            bl: 0,
            bR: 0,
            ah: n,
            a1: "",
            bz: 0,
            W: gc(n)
        };
    }, Py = F2(function(n, r) {
        return A2(ws, n, {
            $: 1,
            a: r
        });
    }), My = function(n) {
        return A2(Py, "mousedown", ve(o(n, !0)));
    }, Sy = function(n) {
        return A2(Ns, "mouseenter", ve(n));
    }, Ly = function(n) {
        return A2(Ns, "mouseleave", ve(n));
    }, Ry = Ds("opacity"), xy = Ss("title"), Iy = _o("height"), Fy = _o("stroke-linejoin"), wy = _o("width"), Ny = function(n) {
        var r = n.ai, t = n.e0, e = n.ej, u = n.dy, a = n.dz;
        return A2(Ef, h([
            Af("0 0 100 100"),
            wy(Pt(t)),
            Iy(Pt(t)),
            rf("none")
        ]), h([
            A2(Nf, h([
                nf(r),
                rf(Ff(e)),
                $f(Ff(u)),
                jf(Pt(a)),
                gf("round"),
                Fy("round")
            ]), l)
        ]));
    }, Xy = F6(function(n, r, e, u, a, c) {
        var i, o = t(Yc.bg(n), Zt) && t(e, Dt(a)), f = h(o ? [
            c,
            A2(zs, h([
                xy("Duplicate"),
                My(vv),
                Uq((i = a, {
                    $: 7,
                    a: i
                })),
                Jo(h([
                    Zs(yy),
                    Gs(As(5)),
                    nb(As(10)),
                    Dq(Sq)
                ]))
            ]), h([
                Ny(s(Zy, {
                    ej: u
                }))
            ])),
            A2(zs, h([
                xy("Delete"),
                My(vv),
                Uq(vy(a)),
                Jo(h([
                    Zs(yy),
                    Gs(As(4)),
                    sq(As(6)),
                    Dq(Sq)
                ]))
            ]), h([
                Ny(Hy)
            ]))
        ] : [
            c
        ]), b = "editor-block-id-" + Pt(a), l = h([
            Uq(qy(a)),
            Ls(b)
        ]), v = A2(yt, Jo(ky(u)), l), p = A2(yt, Jo(d(ky(u), A3(Wy, u, t(a, r), !t(e, Zt) && !o))), l), q = Yc.bg(n);
        return q.$ ? A2(zs, d(p, d(h([
            Sy(py(a)),
            Ly(hy)
        ]), A2(xe, Oy, A2(Yc.d9, a, b)))), f) : t(q.a.cO, a) ? A2(zs, A2(yt, Jo(h([
            Ry(Qy(.3))
        ])), v), f) : A2(zs, d(p, A2(xe, Oy, A2(Yc.ea, a, b))), f);
    }), $y = Vq("border-right"), Yy = F5(function(n, r, t, e, u) {
        return A3(Ts, Zt, !0, {
            cz: n,
            d1: mu(h([
                u
            ])),
            d4: e,
            dq: 1,
            dy: r,
            dz: 1,
            dC: Zt,
            dK: o(0, 0),
            e7: t
        });
    }), gy = F2(function(n, r) {
        return {
            bD: 0,
            S: 0,
            W: d(gc(r), n)
        };
    }), jy = gy("deg"), Jy = pr, Ey = F6(function(n, r, t, e, u, a) {
        return ms(A5(n, r, t, e, u, a));
    }), Ay = F6(function(n, r, t, e, u, a) {
        return Cf(A7(Jy, Ey, n, r, t, e, u, a));
    }), Gy = Ay, Cy = function(n) {
        return {
            i: 0,
            W: A2(si, "rotate", h([
                n.W
            ]))
        };
    }, By = F2(function(n, r) {
        var t = A2(Fa, function(n) {
            return A2(mh, n.cO, dh(r));
        }, Yc.bg(n));
        if (t.$) return l;
        var e = t.a;
        return h([
            A2(zs, A2(xe, Oy, Yc.ek(n)), h([
                A2(zs, h([
                    Jo(A2(yt, sy(Cy(jy(4))), ky(r.dy)))
                ]), h([
                    A6(Gy, Yy, r.cz, r.dy, r.e7, r.d4, e)
                ]))
            ]))
        ]);
    }), _y = Ds("margin-bottom"), nU = Ds("overflow-y"), rU = F4(function(n, r, t, e) {
        var u = $t(A2(Nt, A4(Xy, n, t, e, r.dy), A2(xe, A5(Gy, Yy, r.cz, r.dy, r.e7, r.d4), dh(r))));
        return A2(Hs, h([
            Jo(h([
                oi(_s(ta)),
                Qs(Es(100)),
                rb(As(Rs)),
                nU(mq),
                Oq(Kq),
                A3($y, As(1), Nq, _s(ub)),
                qq(As(15))
            ]))
        ]), A2(yt, A3(Cq, h([
            _y(As(20))
        ]), ly, "Add new block"), d(u, A2(By, n, r))));
    }), tU = dr, eU = F3(function(n, r, t) {
        return ms(A2(n, r, t));
    }), uU = F3(function(n, r, t) {
        return Cf(A4(tU, eU, n, r, t));
    }), aU = uU, cU = Vs, iU = vr, oU = F5(function(n, r, t, e, u) {
        return ms(A4(n, r, t, e, u));
    }), fU = F5(function(n, r, t, e, u) {
        return Cf(A6(iU, oU, n, r, t, e, u));
    }), sU = {
        $: 36
    }, bU = function(n) {
        return A3(Yq, "alignItems", "align-items", n(gq));
    }, dU = pq("box-shadow"), lU = A2(ii, "display", "flex"), vU = function(n) {
        return A3(Yq, "justifyContent", "justify-content", n(gq));
    }, pU = F2(function(n, r) {
        return A2(zs, l, h([
            r,
            A2(zs, h([
                Jo(h([
                    oi(_s(A2(Bq, .5, n))),
                    Zs(Ks),
                    nb(As(40)),
                    Gs(tb),
                    Qs(A3(bi, Es(100), 1, As(40))),
                    rb(A3(bi, Es(100), 1, As(Rs))),
                    js(Ps),
                    lU,
                    bU(zq),
                    vU(zq)
                ]))
            ]), h([
                A3(Cq, h([
                    _y(As(20)),
                    rb(As(180)),
                    Qs(As(50)),
                    A2(dU, As(0), As(0)),
                    A5(ty, tb, tb, As(18), As(18), _s(A2(Bq, .9, n))),
                    oi(_s(n))
                ]), sU, "Compute image")
            ]))
        ]));
    }), hU = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qU = {
        $: 21
    }, yU = Vq("border-top"), UU = Ds("flex-direction"), mU = Ds("flex-grow"), WU = Vq("border-bottom"), VU = Ds("start"), TU = A4(ku, 1, 1, 1, 1), KU = {
        b3: A3(Nu, 22, 22, 22),
        cz: ta,
        d_: TU,
        ep: A3(Nu, 10, 10, 10)
    }, kU = function(n) {
        var r = n ? h([
            oi(_s(KU.b3))
        ]) : l;
        return d(h([
            Zq(Wq),
            rb(Es(100)),
            A2(cy, As(15), As(20)),
            bq(_s(Rf)),
            Dq(Sq),
            A3(WU, As(1), Nq, _s(KU.b3)),
            jq(VU),
            Jq(Mq),
            vq(h([
                oi(_s(KU.ep))
            ])),
            Lq(h([
                oi(_s(KU.b3))
            ]))
        ]), r);
    }, OU = F4(function(n, r, t, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), zU = Kr, DU = F2(function(n, r) {
        var t = r.b, e = r.c;
        return A3(di, A2(zU, n, r.a), t, e);
    }), ZU = F2(function(n, r) {
        switch(r.$){
            case 0:
                var t = r.b, e = r.c;
                return A3(ks, r.a, A2(xe, DU(n), t), A2(xe, ZU(n), e));
            case 1:
                return t = r.c, e = r.d, A4(Hf, r.a, r.b, A2(xe, DU(n), t), A2(xe, ZU(n), e));
            case 2:
                return t = r.b, e = r.c, A3(Is, r.a, A2(xe, DU(n), t), A2(xe, function(r) {
                    return o(r.a, A2(ZU, n, r.b));
                }, e));
            case 3:
                return t = r.c, e = r.d, A4(OU, r.a, r.b, A2(xe, DU(n), t), A2(xe, function(r) {
                    return o(r.a, A2(ZU, n, r.b));
                }, e));
            default:
                return Cf(A2(eq, n, r.a));
        }
    }), HU = ZU, QU = {
        b8: 0,
        bb: 0,
        W: "row"
    }, PU = function(n) {
        return {
            $: 4,
            a: n
        };
    }, MU = Ds("background-image"), SU = {
        l: 0,
        W: "inline-block"
    }, LU = xe(function(n) {
        var r = n.b;
        return A2(Pi, n.a.W, A2(Iu, "", A2(wc, A2(fa, Hu(" "), function(n) {
            return n.W;
        }), r)));
    }), RU = F4(function(n, r, t, e) {
        return {
            aF: 0,
            d: 0,
            W: A2(si, "linear-gradient", A2(yt, n.W, LU(d(h([
                r,
                t
            ]), e))))
        };
    }), xU = Ds("margin-top"), IU = Vq("padding"), FU = Os("input"), wU = Ss("max"), NU = Ss("min"), XU = function(n) {
        return o(n, !0);
    }, $U = A2(Wp, h([
        "target",
        "value"
    ]), ou), YU = function(n) {
        return A2(Py, "input", A2(de, XU, A2(de, n, $U)));
    }, gU = function(n) {
        return A2(Ss, "step", n);
    }, jU = Ss("type"), JU = Ss("value"), EU = F5(function(n, r, t, e, u) {
        return A2(zs, h([
            Jo(h([
                rb(Es(97)),
                js(Ps),
                A2(hq, tb, mq)
            ]))
        ]), h([
            A2(FU, h([
                jU("range"),
                NU(gc(t)),
                wU(gc(e)),
                gU(gc(u)),
                JU(gc(r)),
                YU(function(t) {
                    var e = lh(t);
                    return n(e.$ ? r : e.a);
                }),
                Jo(h([
                    Zq(Wq),
                    rb(Es(100)),
                    Qs(As(27))
                ]))
            ]), l)
        ]));
    }), AU = function(n) {
        return o(n, Zt);
    }, GU = {
        S: 0,
        W: "to right"
    }, CU = F6(function(n, r, t, e, u, a) {
        return A2(zs, h([
            Jo(h([
                Zq(SU),
                rb(Es(100)),
                Qs(As(30)),
                MU(A4(RU, GU, AU(_s(a.e1)), AU(_s(a.ed)), l)),
                fq(_s(Uy)),
                kq(As(3)),
                xU(As(10)),
                A3(IU, As(1), As(4), tb),
                Oq(Kq),
                A3(Tq, As(1), Nq, _s(ub))
            ]))
        ]), h([
            A5(EU, n, r, t, e, u)
        ]));
    }), BU = F2(function(n, r) {
        var t = fv(r);
        return A4(ni, t.el, t.eZ, n, t.dO);
    }), _U = hr, nm = F7(function(n, r, t, e, u, a, c) {
        return ms(A6(n, r, t, e, u, a, c));
    }), rm = F7(function(n, r, t, e, u, a, c) {
        return Cf(A8(_U, nm, n, r, t, e, u, a, c));
    }), tm = {
        $: 2
    }, em = Pf("line"), um = _o("x1"), am = _o("x2"), cm = _o("y1"), im = _o("y2"), om = F3(function(n, r, t) {
        var e = Pt(8), u = Pt(90), a = "0 0 " + Pt(90) + " " + Pt(90), c = Pt(30), i = Ff(A2(Bq, .52, t > .5 ? ub : TU)), o = Pt(45);
        return A2(zs, h([
            Jo(h([
                Zs(yy),
                ay(A3(bi, Es(50 * n + 50), 1, As(7.5))),
                nb(A3(bi, Es(50 * r + 50), 1, As(7.5))),
                Qs(As(15)),
                rb(As(15)),
                iy(Mq)
            ]))
        ]), h([
            A2(Ef, h([
                Af(a)
            ]), h([
                A2(Mf, h([
                    Sf(o),
                    Lf(o),
                    xf(c),
                    rf("none"),
                    $f(i),
                    jf(e)
                ]), l),
                A2(em, h([
                    um("0"),
                    am(u),
                    cm(o),
                    im(o),
                    $f(i),
                    jf(e)
                ]), l),
                A2(em, h([
                    um(o),
                    am(o),
                    cm("0"),
                    im(u),
                    $f(i),
                    jf(e)
                ]), l)
            ]))
        ]));
    }), fm = _o("filter"), sm = uU, bm = Ns, dm = function(n) {
        return A2(Ns, "mousedown", ve(n));
    }, lm = function(n) {
        return A2(Ns, "mouseout", ve(n));
    }, vm = function(n) {
        return A2(Ns, "mouseup", ve(n));
    }, pm = _o("opacity"), hm = Pf("g"), qm = F2(function(n, r) {
        return o(r.a, n(r.b));
    }), ym = F2(function(n, r) {
        return 1 > n ? r : A3(We, 0, -n, r);
    }), Um = F2(function(n, r) {
        var t, e = A2(Pu, 10, n), u = ne(r * e) / e, c = gc(u), i = A2(St, ".", c);
        n: for(;;){
            if (i.b) {
                if (i.b.b) {
                    if (i.b.b.b) break n;
                    return i.a + "." + (1 > a(me(t = i.b.a), n) ? t : A2(ym, me(t) - n, t));
                }
                return i.a;
            }
            break n;
        }
        return c;
    }), mm = H, Wm = F2(function(n, r) {
        var t = n + .02, e = sf(o(1, r + t)), u = e.a, a = e.b, c = sf(o(1, r)), i = c.b, f = "L" + A2(Um, 4, c.a) + " " + A2(Um, 4, i), s = sf(A2(qm, zt(r), Tf(o(1, 1 * mm(t / 2))))), b = s.b, d = "Q" + A2(Um, 4, s.a) + " " + A2(Um, 4, b) + " " + A2(Um, 4, u) + " " + A2(Um, 4, a);
        return o(n, r), "M 0 0" + f + d + "Z";
    }), Vm = _o("pointer-events"), Tm = Pf("defs"), Km = _o("gradientUnits"), km = _o("offset"), Om = Pf("radialGradient"), zm = Pf("stop"), Dm = _o("stop-color"), Zm = F4(function(n, r, t, e) {
        return A2(Tm, l, h([
            A2(Om, h([
                tf(t),
                Sf("0"),
                Lf("0"),
                xf(gc(1 / e)),
                Km("userSpaceOnUse")
            ]), h([
                A2(zm, h([
                    km("0%"),
                    Dm(n)
                ]), l),
                A2(zm, h([
                    km("100%"),
                    Dm(r)
                ]), l)
            ]))
        ]));
    }), Hm = F3(function(n, r, t) {
        var e = 6.283185307179586 / n, u = t * e, a = Ff(ti(o(0, u))), c = "colorId_" + Pt(t), i = Ff(ti(o(1, u)));
        return h([
            A4(Zm, a, i, c, r),
            A2(Nf, h([
                nf(A2(Wm, e, u)),
                rf("url(#" + c + ")"),
                Vm("none")
            ]), l)
        ]);
    }), Qm = F2(function(n, r) {
        return A2(hm, l, A2(Ni, A2(Hm, n, r), A2(wt, 0, n - 1)));
    }), Pm = function(n) {
        var r = fv(n), t = o(r.el, r.eZ);
        return o(t.b, t.a);
    }, Mm = F6(function(n, r, t, e, u, a) {
        var c = fv(u).fa, i = h([
            Af("-1 -1 2 2"),
            Iy("100%"),
            wy("100%"),
            pm(gc(c)),
            fm("blur(" + gc(e) + "px)"),
            Jf("display: block;background-color: white;boder-radius: 50%;transform: scale(" + Pt(2) + ");pointer-events: none;"),
            tf("MainSVG")
        ]), f = A2(xe, Eo, A2(Vi, ce, h([
            o(!0, A2(bm, "click", A2(de, gl, Jl))),
            o(!0, dm(tm)),
            o(!0, vm(jl)),
            o(!a, lm(jl)),
            o(t, A2(bm, "mousemove", A2(de, gl, Jl)))
        ]))), s = h([
            Jo(h([
                kq(Es(50)),
                js(Ps),
                oi(_s(ub)),
                Zs(Ky)
            ])),
            tf(n)
        ]), b = sf(Pm(u)), l = b.a, v = b.b;
        return A2(zs, d(s, f), h([
            A2(zs, h([
                Jo(h([
                    Qs(Es(100)),
                    rb(Es(100))
                ]))
            ]), h([
                A2(Ef, i, h([
                    A3(sm, Qm, r, 2)
                ])),
                A3(om, l, v, c)
            ]))
        ]));
    }), Sm = function(n) {
        return A7(rm, Mm, n.bd, ne(n.bQ), n.ax, n.bF, n.d_, n.bt);
    }, Lm = Ay, Rm = Ds("background-repeat"), xm = Ds("background-size"), Im = Xq, Fm = {
        af: 0,
        W: "cover"
    }, wm = Ds("padding-top"), Nm = {
        aG: 0,
        Z: 0,
        W: "round"
    }, Xm = F5(function(n, r, t, e, u) {
        var a = fv(t).fa, c = Im(u ? l : h([
            Qs(Es(100)),
            rb(Es(100))
        ])), i = h([
            Jo(h([
                c,
                kq(Es(50)),
                js(Ps),
                oi(_s(ub)),
                Zs(Ky),
                A3(Tq, As(1), Nq, _s(ub))
            ])),
            tf(n)
        ]), f = Im(h(u ? [
            wm(Es(100))
        ] : [
            Qs(Es(100))
        ])), s = A2(xe, Eo, A2(Vi, ce, h([
            o(!0, A2(bm, "click", A2(de, gl, Jl))),
            o(!0, dm(tm)),
            o(!0, vm(jl)),
            o(!e, lm(jl)),
            o(r, A2(bm, "mousemove", A2(de, gl, Jl)))
        ]))), b = h([
            Jo(h([
                rb(Es(100)),
                f,
                oi(_s(TU)),
                Rm(Nm),
                xm(Fm),
                MU({
                    aF: 0,
                    W: "url(data:image/jpeg;base64,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)"
                }),
                kq(Es(50)),
                Ry(Qy(a))
            ])),
            tf(n + "static")
        ]), v = sf(Pm(t)), p = v.a, q = v.b;
        return A2(zs, i, h([
            A2(zs, d(b, s), l),
            A3(om, p, q, a)
        ]));
    }), $m = function(n) {
        return A6(Lm, Xm, n.bd, n.ax, n.d_, n.bt, n.cl);
    }, Ym = F2(function(n, r) {
        var e, u, a, c, i = d(kU(!1), h([
            jq(zq),
            Oq(Kq),
            A3(yU, As(1), Nq, _s(KU.b3))
        ])), o = F2(function(r, e) {
            var u, a;
            return A2(zs, h([
                Jo(d((a = t(n, r), d(kU(a), h([
                    mU(uy(1))
                ]))), h([
                    jq(zq)
                ]))),
                Uq((u = r, {
                    $: 19,
                    a: u
                }))
            ]), h([
                Gq(e)
            ]));
        });
        return A2(zs, l, h([
            A2(zs, h([
                Jo(h([
                    lU,
                    UU(QU),
                    rb(As(270))
                ]))
            ]), h([
                A2(o, 0, "Stroke"),
                A2(o, 1, "Background")
            ])),
            A2(zs, h([
                Jo(h([
                    qq(As(12))
                ]))
            ]), h([
                A2(HU, Pl, (e = r, a = e.a9 ? Sm : $m, c = fv(e.d_).fa, A2(zs, h([
                    Jo(h([
                        Qs(Es(100)),
                        rb(Es(100))
                    ]))
                ]), h([
                    a(e),
                    A6(CU, PU, c, 1e-4, 1.0001, .01, (u = e.d_, {
                        ed: A2(BU, 1, u),
                        e1: A2(BU, 0, u)
                    }))
                ]))))
            ])),
            A2(zs, h([
                Jo(i),
                Uq(qU)
            ]), h([
                Gq("Exchange colors")
            ]))
        ]));
    }), gm = function(n) {
        return {
            $: 40,
            a: n
        };
    }, jm = A2(zs, h([
        Jo(h([
            rb(As(200))
        ]))
    ]), h([
        A2(zs, h([
            Jo(kU(!1)),
            Uq({
                $: 12
            })
        ]), h([
            Gq("Save to gallery")
        ])),
        A2(zs, h([
            Jo(kU(!1)),
            Uq({
                $: 25
            })
        ]), h([
            Gq("Copy URL to share")
        ])),
        A2(zs, h([
            Jo(kU(!1)),
            Uq({
                $: 27
            })
        ]), h([
            Gq("Download as SVG")
        ])),
        A2(zs, h([
            Jo(kU(!1)),
            Uq({
                $: 28
            })
        ]), h([
            Gq("Download as JPEG")
        ])),
        A2(zs, h([
            Jo(kU(!1)),
            Uq({
                $: 5
            })
        ]), h([
            Gq("Reset Image")
        ])),
        A2(zs, h([
            Jo(kU(!1)),
            Uq(gm(0))
        ]), h([
            Gq("Random Image")
        ])),
        A2(zs, h([
            Jo(kU(!1)),
            Uq(gm(1))
        ]), h([
            Gq("Random Rectangles")
        ])),
        A2(zs, h([
            Jo(kU(!1)),
            Uq({
                $: 39
            })
        ]), h([
            Gq("Enter fullscreen")
        ]))
    ])), Jm = function(n) {
        return {
            $: 23,
            a: n
        };
    }, Em = {
        $: 24
    }, Am = Ds("border-bottom"), Gm = {
        c: 0,
        W: "default"
    }, Cm = F3(function(n, r, t) {
        var e = Lp(t), u = e.a, a = e.b;
        return A2(FU, h([
            jU("range"),
            NU("0.0001"),
            wU("1"),
            gU("0.0001"),
            JU(gc(a(r))),
            YU(function(t) {
                var e = lh(t);
                return n(e.$ ? r : u(e.a));
            }),
            Jo(h([
                Zq(Wq),
                rb(Es(100)),
                Qs(As(27)),
                Dq(Sq)
            ]))
        ]), l);
    }), Bm = Os("span"), _m = F2(function(n, r) {
        var t, e = A2(St, ".", r);
        n: for(;;){
            if (e.b) {
                if (e.b.b) {
                    if (e.b.b.b) break n;
                    return e.a + "." + (1 > a(me(t = e.b.a), n) ? t : A2(ym, me(t) - n, t));
                }
                return e.a;
            }
            break n;
        }
        return r;
    }), nW = F2(function(n, r) {
        var t = "Change to " + (r ? "sharp" : "organic"), e = d(kU(!1), h([
            jq(zq),
            Oq(Kq),
            A3(yU, As(1), Nq, _s(KU.b3)),
            Am(tb)
        ]));
        return A2(zs, h([
            Jo(h([
                rb(As(240))
            ]))
        ]), h([
            A2(zs, h([
                Jo(h([
                    qq(As(10))
                ]))
            ]), h([
                A2(Bm, h([
                    Jo(h([
                        Zq(Wq),
                        A2(hq, As(10), tb),
                        Dq(Gm)
                    ]))
                ]), h([
                    Gq("Thickness: " + A2(_m, 6, gc(n)) + "px")
                ])),
                A3(Cm, Jm, n, Rp)
            ])),
            A2(zs, h([
                Jo(e),
                Uq(Jm(1))
            ]), h([
                Gq("Reset")
            ])),
            A2(zs, h([
                Jo(e),
                Uq(Em)
            ]), h([
                Gq(t)
            ]))
        ]));
    }), rW = function(n) {
        return {
            $: 38,
            a: n
        };
    }, tW = A2(pu, xe(db), If), eW = {
        ci: 0,
        W: "break-word"
    }, uW = s(QU, {
        W: "column"
    }), aW = function(n) {
        return n.trim();
    }, cW = A2(pu, Pt, A2(pu, Du, A2(pu, A2(Re, F2(function(n, r) {
        var t = r.a, e = r.b;
        return o(2 === A2(Wo, 3, e) ? A2(yt, " ", A2(yt, n, t)) : A2(yt, n, t), e + 1);
    }), o(l, 0)), A2(pu, ce, A2(pu, Zu, aW))))), iW = Ds("max-width"), oW = Ds("min-width"), fW = Ds("overflow-wrap"), sW = Ds("padding-bottom"), bW = function(n) {
        return rh(n.d1).a;
    }, dW = F2(function(n, r) {
        return A3(di, A2(La, n, r), l, "");
    }), lW = function(n) {
        var r = o(o(16, 1e4), o(.3, 70)), t = cW, e = F2(function(n, r) {
            return A2(zs, h([
                Jo(h([
                    lU,
                    A2(hq, As(10), tb)
                ])),
                A2(dW, "gap", "10px")
            ]), h([
                A2(Bm, h([
                    Jo(h([
                        oW(As(120)),
                        bq(_s(Qq))
                    ]))
                ]), h([
                    Gq(n)
                ])),
                A2(Bm, h([
                    Jo(h([
                        bq(_s(ab))
                    ]))
                ]), h([
                    Gq(r)
                ]))
            ]));
        }), u = A2(pu, gc, _m(6)), a = A2(pu, gc, _m(1)), c = function(n) {
            var r = A2(Iu, o(NaN, NaN), A2(wc, A2(pu, function(n) {
                return n.dV;
            }, A2(pu, Co, Eo)), n.er.dC)), t = r.a, e = r.b, u = A2(te, t, e), a = 10 / u, c = n.er.dz / u, i = A2(Go, ee(2), A3(Ao, It, n.bL, n.T)), f = i.a, s = i.b, b = A2(qf, f, s), d = Sa(c * b * (a * b) * A2(Pu, n.er.dq, 2) * bW(n.er));
            return {
                b5: Sa(f * s),
                b9: {
                    aT: s,
                    a5: f
                },
                ae: n.ae,
                cg: bW(n.er),
                cj: d,
                dz: n.er.dz,
                co: {
                    aT: e,
                    a5: t
                },
                ct: n.er.dq
            };
        }(n), i = c.ae, f = c.cg, s = c.dz, b = c.co, d = c.b9, v = c.b5, p = c.cj;
        return A2(zs, h([
            Jo(h([
                rb(As(280)),
                qq(As(10)),
                sW(As(20))
            ]))
        ]), h([
            A2(zs, l, h([
                A2(Bm, h([
                    Jo(h([
                        Zq(Wq),
                        A2(hq, As(10), tb),
                        Dq(Gm),
                        jq(zq)
                    ]))
                ]), h([
                    Gq("Max image compute time: " + Pt(Sa(n.aS)))
                ])),
                A3(Cm, rW, n.aS, r)
            ])),
            A2(zs, h([
                Jo(h([
                    wm(As(10))
                ]))
            ]), h([
                A2(e, "Num of strokes:", t(f)),
                A2(e, "Last slow frame:", a(i) + " ms"),
                A2(e, "Pixels in Line:", t(p)),
                A2(e, "Pixels in canvas:", t(v)),
                A2(e, "Line thickness:", u(s) + " units"),
                A2(e, "Zoom:", u(n.er.dq)),
                A2(e, "SVG view box:", zp(b.a5) || zp(b.aT) ? "N/A" : a(b.a5) + " x " + a(b.aT) + " units"),
                A2(e, "Image canvas:", a(d.a5) + " x " + a(d.aT) + " px"),
                A2(zs, h([
                    Jo(h([
                        lU,
                        UU(uW)
                    ])),
                    A2(dW, "gap", "4px")
                ]), A2(yt, A2(e, "Blocks:", ""), $t(A2(Nt, F2(function(n, r) {
                    return A2(zs, h([
                        Jo(h([
                            lU,
                            bq(_s(Qq))
                        ]))
                    ]), h([
                        A2(zs, h([
                            Jo(h([
                                rb(As(30))
                            ]))
                        ]), h([
                            Gq(Pt(n) + ":")
                        ])),
                        A2(zs, h([
                            Jo(h([
                                iW(As(250)),
                                fW(eW)
                            ]))
                        ]), h([
                            Gq(tW(r) + " (" + Pt(Rt(r)) + ")")
                        ]))
                    ]));
                }), dh(n.er)))))
            ]))
        ]));
    }, vW = {
        $: 35
    }, pW = function(n) {
        return {
            $: 34,
            a: n
        };
    }, hW = {
        $: 31
    }, qW = {
        $: 33
    }, yW = {
        $: 30
    }, UW = Un, mW = F2(function(n, r) {
        return A2(Ms, n, UW(r));
    })("checked"), WW = Os("label"), VW = Ds("margin-left"), TW = A2(Wp, h([
        "target",
        "checked"
    ]), Ys), KW = F4(function(n, r, e, u) {
        var a = 60 * n, c = r ? "Pause" : "Play", i = F3(function(n, r, t) {
            var e;
            return A2(WW, h([
                Jo(h([
                    Zq(Wq),
                    A2(cy, As(10), tb),
                    xU(As(10)),
                    Dq(Sq)
                ]))
            ]), h([
                A2(FU, h([
                    jU("checkbox"),
                    mW(r),
                    (e = n, A2(Ns, "change", A2(de, e, TW)))
                ]), l),
                A2(Bm, h([
                    Jo(h([
                        VW(As(10))
                    ]))
                ]), h([
                    Gq(t)
                ]))
            ]));
        }), o = d(kU(!1), h([
            jq(zq),
            Oq(Kq)
        ]));
        return A2(zs, h([
            Jo(h([
                rb(As(240))
            ]))
        ]), h([
            A2(zs, h([
                Jo(o),
                Uq(yW)
            ]), h([
                Gq(c)
            ])),
            A2(zs, h([
                Jo(o),
                Uq(vW)
            ]), h([
                Gq("Reverse direction")
            ])),
            A2(zs, h([
                Jo(h([
                    qq(As(10))
                ]))
            ]), h([
                A2(Bm, h([
                    Jo(h([
                        Zq(Wq),
                        A2(hq, As(10), tb),
                        Dq(Gm)
                    ]))
                ]), h([
                    Gq("Speed: " + A2(_m, 5, gc(a)) + "\xb0 \u2215 second")
                ])),
                A3(Cm, pW, n, xp),
                A3(i, Xb(qW), !t(e, na), "Slow Motion"),
                A3(i, Xb(hW), u, "Also change colors")
            ]))
        ]));
    }), kW = function(n) {
        return h([
            hU({
                cE: jm,
                dF: "File"
            }),
            hU({
                cE: A2(Ym, n.N, n.q),
                dF: "Color"
            }),
            hU({
                cE: A4(KW, n.bA, n.v, n.A, n.aJ),
                dF: "Video"
            }),
            hU({
                cE: A2(nW, n.er.dz, n.er.d4),
                dF: "Line"
            }),
            hU({
                cE: lW(n),
                dF: "Perf"
            })
        ]);
    }, OW = F2(function(n, r) {
        return A2(F2(function(n, t) {
            for(;;){
                if (0 > n) return t;
                var e = n - 1, u = A2(yt, r(n), t);
                n = e, t = u;
            }
        }), n - 1, l);
    }), zW = Ds("margin-right"), DW = Ds("space-between"), ZW = function(n) {
        return {
            $: 2,
            a: n
        };
    }, HW = function(n) {
        return {
            $: 29,
            a: n
        };
    }, QW = function(n) {
        return {
            $: 22,
            a: n
        };
    }, PW = F7(function(n, r, t, e, u, a, c) {
        return A2(ii, n, A2(Mt, " ", h([
            r.W,
            t.W,
            e.W,
            u.W,
            a.W,
            c.W
        ])));
    })("box-shadow"), MW = {
        B: 0,
        W: "inset"
    }, SW = function(n) {
        return A2(Ns, "blur", ve(n));
    }, LW = function(n) {
        return A2(Ns, "focus", ve(n));
    }, RW = function(n) {
        var r;
        return A2(FU, h([
            Ls("TurnAngle"),
            jU("text"),
            JU(A2(_m, 5, n)),
            Jo(h([
                Zq(Wq),
                rb(As(110)),
                Qs(As(18)),
                oi(_s(Qq)),
                bq(_s(ta)),
                Rq(Fq),
                A6(PW, MW, tb, tb, As(1), As(1), _s(ta)),
                qq(As(8)),
                Hq(As(14)),
                jq(zq),
                mU(uy(1)),
                VW(As(30)),
                zW(As(30)),
                iW(As(160))
            ])),
            YU(QW),
            (r = ZW, A2(Ns, "keydown", Nl(r))),
            LW(HW(1)),
            SW(HW(0))
        ]), l);
    }, xW = function(n) {
        return A2(FU, h([
            jU("range"),
            NU("0.0001"),
            wU(Pt(180)),
            gU("0.0001"),
            JU(n),
            YU(QW),
            Jo(h([
                Zq(Wq),
                Qs(As(27)),
                Dq(Sq)
            ]))
        ]), l);
    }, IW = F2(function(n, r) {
        var t = .5 > fv(r).fa, e = function(n) {
            return A2(Bm, h([
                Jo(h([
                    rb(As(40)),
                    jq(zq),
                    bq(_s(t ? Rf : KU.b3)),
                    Hq(As(14))
                ]))
            ]), h([
                Gq(n)
            ]));
        }, u = ey(t ? "white" : "black");
        return A2(zs, h([
            Jo(h([
                lU,
                UU(QU),
                A2(ii, "justify-content", "space-evenly"),
                bU(zq),
                Zs(Ks),
                sq(tb),
                Gs(tb),
                Qs(As(60)),
                rb(A3(bi, Es(100), 1, As(Rs))),
                Oq(Kq)
            ])),
            u
        ]), h([
            RW(n),
            A2(zs, h([
                Jo(h([
                    rb(A3(bi, Es(80), 1, As(110))),
                    mU(uy(2)),
                    zW(As(40))
                ]))
            ]), h([
                xW(n),
                A2(zs, h([
                    Jo(h([
                        rb(A3(bi, Es(100), 0, As(34))),
                        lU,
                        UU(QU),
                        vU(DW),
                        Zs(Ky),
                        ay(As(-14))
                    ]))
                ]), A2(xe, A2(pu, function(n) {
                    return n + "\xb0";
                }, e), A2(OW, 5, function(n) {
                    return Pt(180 * n / 4 | 0);
                })))
            ]))
        ]));
    }), FW = F3(function(n, r, t) {
        return t ? h([
            A2(zs, h([
                Jo(h([
                    Zs(yy),
                    nb(A3(bi, Es(100), 0, As(8))),
                    dy(uy(1)),
                    js(Ps),
                    oi(_s(ta)),
                    bq(_s(Rf)),
                    A5(ty, tb, tb, As(7), As(-1), _s(ub)),
                    A3(Tq, As(1.5), Nq, _s(ub)),
                    kq(As(5))
                ])),
                Sy(n(0)),
                Ly(n(1))
            ]), h([
                r
            ]))
        ]) : l;
    }), wW = F3(function(n, r, t) {
        var e, u, a = r.dF, c = r.cE, i = r.dG;
        return A2(zs, h([
            Jo(d((e = t.ad, u = e ? h([
                oi(_s(ub))
            ]) : l, d(h([
                Zs(Ky),
                Qs(Es(100)),
                A2(cy, tb, As(15)),
                lU,
                bU(zq),
                vU(zq)
            ]), u)), n)),
            Sy(i(0)),
            Ly(i(1))
        ]), A2(yt, A2(zs, h([
            Jo(h([
                bq(_s(TU)),
                Dq(Gm)
            ]))
        ]), h([
            Gq(a)
        ])), A3(FW, i, c, t.ad)));
    }), NW = F3(function(n, r, t) {
        var e = t.b, u = e.a, a = e.b;
        return 1 === a.$ ? a.a : A2(r, {
            cE: a.a.cE,
            dF: a.a.dF,
            dG: A2(pu, yh(t.a), n)
        }, u);
    }), XW = h([
        0,
        1,
        2,
        3
    ]), $W = Os("a"), YW = function(n) {
        switch(n){
            case 0:
                return "Editor";
            case 1:
                return "Gallery";
            case 2:
                return "Welcome";
            case 3:
                return "Writing";
            default:
                return "Dev playground";
        }
    }, gW = F2(function(n, r) {
        var e;
        return A2($W, h([
            Jo(kU(t(n, r))),
            (e = "/" + yd(r), A2(Ss, "href", e))
        ]), h([
            Gq(YW(r))
        ]));
    }), jW = A2(zs, h([
        Jo(h([
            rb(As(2)),
            Qs(Es(80)),
            Zs(Ky),
            nb(Es(10)),
            oi(_s(A2(Bq, .3, ub)))
        ]))
    ]), l), JW = wW(l), EW = h([
        Jo(h([
            lU,
            UU(QU),
            vU(zq),
            oi(_s(KU.cz)),
            Qs(As(40)),
            Zs(Ky),
            A3(WU, As(1), Nq, _s(ub)),
            A5(ty, tb, As(-3), As(10), As(1), _s(ub)),
            dy(uy(1))
        ]))
    ]), AW = xt(Bu), GW = F3(function(n, r, t) {
        var e, u = t.aN, a = t.dG, c = A2(NW, a, wW(h([
            Zs(yy),
            ay(As(10))
        ]))), i = A2(Nt, Bu, A2(AW, u, A2(yt, (e = n, hU({
            cE: A2(zs, h([
                Jo(h([
                    rb(As(140))
                ]))
            ]), A2(xe, gW(e), XW)),
            dF: "Genart " + YW(e) + " \u25BE"
        })), r))), o = A2(pu, xe(A2(NW, a, JW)), ud(jW));
        if (i.b) {
            var f = i.b;
            return A2(zs, EW, A2(yt, c(i.a), o(f)));
        }
        return A2(zs, EW, l);
    }), CW = Ds("flex-wrap"), BW = Ds("space-around"), _W = h([
        rb(Es(100)),
        Qs(A3(bi, Es(100), 1, As(41))),
        qq(As(10)),
        Oq(Kq),
        oi(_s(ta)),
        nU(mq),
        lU,
        UU(QU),
        CW({
            bb: 0,
            bJ: 0,
            W: "wrap"
        }),
        vU(BW)
    ]), nV = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rV = {
        $: 10
    }, tV = function(n) {
        return {
            $: 0,
            a: n
        };
    }, eV = h([
        rb(Es(100)),
        Qs(As(40)),
        Zs(yy),
        sq(tb),
        jq(zq),
        Pq(As(40)),
        oi(_s(KU.b3)),
        bq(_s(KU.d_)),
        Dq(Sq)
    ]), uV = h([
        oi(_s(ny)),
        rb(As(30)),
        Qs(As(30)),
        Zs(yy),
        nb(As(8)),
        Gs(As(8)),
        Dq(Sq),
        vq(h([
            oi(_s(KU.b3))
        ]))
    ]), aV = h([
        rb(As(250)),
        Qs(As(250)),
        Zs(yy),
        nb(tb),
        ay(tb)
    ]), cV = F2(function(n, r) {
        return s(r, {
            dq: n
        });
    }), iV = function(n) {
        return A3(Ts, Zt, !1, A2(cV, 1, A2(ep, o(0, 0), n)));
    }, oV = s(Dy, {
        ai: "M 75 25 L 25 75 M 25 25 L 75 75",
        dy: Rf
    }), fV = Ds("margin"), sV = h([
        rb(As(300)),
        Qs(As(300)),
        fV(As(30)),
        Zs(Ky),
        A5(ty, tb, tb, As(5), As(1), _s(ub))
    ]), bV = {
        c: 0,
        W: "grabbing"
    }, dV = Ds("visibility"), lV = {
        aX: 0,
        R: 0,
        W: "visible",
        bB: 0
    }, vV = function(n) {
        return dV(n ? lV : Ps);
    }, pV = F5(function(n, r, t, e, u) {
        var a, c, i = n.er, o = n.G;
        return A2(zs, h([
            Jo(d(sV, u)),
            Sy((c = o, {
                $: 9,
                a: c
            })),
            Ly(rV)
        ]), h([
            A2(op, iV, i),
            A2(zs, A2(yt, Jo(A2(yt, (a = e, Dq(a ? bV : Ty)), aV)), r), l),
            A2(zs, h([
                xy("Delete"),
                Uq(tV(o)),
                Jo(A2(yt, vV(t && !e), uV))
            ]), h([
                Ny(s(oV, {
                    ej: TU,
                    e0: 30
                }))
            ])),
            A2(zs, h([
                Uq(nV(o)),
                Jo(A2(yt, vV(t && !e), eV))
            ]), h([
                Gq("Copy to editor")
            ]))
        ]));
    }), hV = F2(function(n, r) {
        var t = A2(Fa, function(n) {
            return A2(mh, n.cO, r);
        }, Pb.bg(n));
        if (t.$) return l;
        var e = t.a;
        return h([
            A2(zs, A2(xe, Oy, Pb.ek(n)), h([
                A5(pV, e, l, !1, !0, h([
                    sy(Cy(jy(4))),
                    fV(tb)
                ]))
            ]))
        ]);
    }), qV = F4(function(n, r, e, u) {
        var a = "gallery-image-id-" + Pt(u.G), c = Pb.bg(r);
        return c.$ ? o(a, A5(pV, u, A2(yt, Ls(a), A2(xe, Oy, A2(Pb.d9, e, a))), t(Dt(u.G), n), !1, l)) : t(c.a.cO, e) ? o(a, A5(pV, u, h([
            Ls(a)
        ]), t(Dt(u.G), n), !0, h([
            Ry(Qy(.3))
        ]))) : o(a, A5(pV, u, A2(yt, Ls(a), A2(xe, Oy, A2(Pb.ea, e, a))), t(Dt(u.G), n), !0, l));
    }), yV = h([
        hU({
            cE: A2(zs, h([
                Jo(h([
                    rb(As(200))
                ]))
            ]), h([
                A2(zs, h([
                    Jo(kU(!1)),
                    Uq({
                        $: 3
                    })
                ]), h([
                    Gq("Download backup file")
                ])),
                A2(zs, h([
                    Jo(kU(!1)),
                    Uq({
                        $: 4
                    })
                ]), h([
                    Gq("Import file")
                ]))
            ])),
            dF: "Backup"
        })
    ]), UV = function(n) {
        var r = _s(A2(Bq, .5, n));
        return A3(Cq, h([
            Zs(Ks),
            sq(As(40)),
            A2(hq, tb, A3(bi, Es(50), 1, As(100))),
            rb(As(200)),
            Qs(As(50)),
            qq(As(10)),
            bq(r),
            fq(r),
            vq(h([
                oi(r),
                bq(_s(ub)),
                fq(_s(ub))
            ]))
        ]), 2, "Click here to begin");
    }, mV = function(n) {
        return {
            $: 4,
            a: n
        };
    }, WV = {
        $: 2
    }, VV = {
        $: 6
    }, TV = function(n) {
        return {
            $: 3,
            a: n
        };
    }, KV = {
        $: 5
    }, kV = {
        l: 0,
        W: "inline-flex"
    }, OV = F2(function(n, r) {
        return A2(yq, h([
            Uq(n),
            Jo(h([
                Zq(kV)
            ]))
        ]), h([
            Gq(r)
        ]));
    }), zV = function(n) {
        return {
            $: 1,
            a: n
        };
    }, DV = Ds("flex-shrink"), ZV = {
        as: 0,
        W: "monospace"
    }, HV = Os("textarea"), QV = F2(function(n, r) {
        return A2(HV, h([
            Ls("WritingInput"),
            Jo(h([
                rb(As(200)),
                Qs(As(100)),
                oi(_s(r)),
                bq(_s(Rf)),
                Hq(As(20)),
                DV(tb),
                rq(ZV)
            ])),
            YU(zV)
        ]), h([
            Gq(n)
        ]));
    }), PV = F2(function(n, r) {
        return A2(zs, h([
            Jo(h([
                Zs(Ks),
                sq(As(40)),
                A2(hq, tb, A3(bi, Es(50), 1, As(200))),
                rb(As(400)),
                Qs(As(100)),
                qq(As(10)),
                bq(_s(Rf)),
                lU,
                UU(QU)
            ]))
        ]), h([
            A2(QV, n, r),
            A2(zs, h([
                Jo(l)
            ]), h([
                A2(OV, KV, "Play/Pause"),
                A2(OV, VV, "Reset Video"),
                A2(OV, TV(10), "More Copies"),
                A2(OV, TV(-10), "Less Copies"),
                A2(OV, mV(1), "Thicker"),
                A2(OV, mV(-1), "Thinner"),
                A2(OV, WV, "Open Editor")
            ]))
        ]));
    }), MV = l;
    Jv = {
        Main: {
            init: (Av = (Ev = {
                et: il,
                eP: function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                },
                eQ: function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                },
                e3: function(n) {
                    switch(n.a3){
                        case 0:
                            return A2(bl, tu, function(n) {
                                return n.bp ? Ya(h([
                                    A2(bl, wb, Al(n.k)),
                                    Ql(Kl)
                                ])) : A2(bl, wb, Al(n.k));
                            }(n.k));
                        case 1:
                            return A2(bl, fl, function(n) {
                                return Pb.e3(n.ap);
                            }(n.x));
                        case 2:
                            return A2(bl, eu, function(n) {
                                return n.ca ? A2(Tl, 100, Xb(0)) : ga;
                            }(n.a4));
                        case 3:
                            return A2(bl, sl, function(n) {
                                var r = n.ca ? A2(Tl, 100, Xb(Gl)) : ga;
                                return n.ca ? r : ga;
                            }(n.a6));
                        default:
                            return A2(bl, ol, function(n) {
                                return n.ca ? A2(Tl, 100, Xb(0)) : ga;
                            }(n.aL));
                    }
                },
                e8: nq,
                fc: function(n) {
                    switch(n.a3){
                        case 0:
                            return A2(oq, tu, function(n) {
                                var r = function(n) {
                                    var r, t, e = (t = n.an).$ ? l : h([
                                        (r = t.a, A3(Fs, "div", l, h([
                                            o(r, A2(zs, h([
                                                Jo(h([
                                                    Zs(Ks),
                                                    ay(Es(50)),
                                                    nb(As(50)),
                                                    sy(A2(by, Es(-50), tb)),
                                                    dy(uy(10)),
                                                    Qs(As(60)),
                                                    oi(_s(ta)),
                                                    bq(_s(Rf)),
                                                    A3(Tq, As(1), Nq, _s(ub)),
                                                    A5(ty, tb, tb, As(5), As(1), _s(ny)),
                                                    kq(As(10)),
                                                    A2(cy, tb, As(20)),
                                                    jq(zq),
                                                    Pq(As(60)),
                                                    rq(aq),
                                                    Hq(As(16)),
                                                    iy(Mq)
                                                ])),
                                                ey("alert")
                                            ]), h([
                                                Gq(r)
                                            ])))
                                        ])))
                                    ]);
                                    return {
                                        cE: h([
                                            iq(A4(cU, GW, 0, kW(n), n.bs)),
                                            iq(A2(zs, h([
                                                Jo(h([
                                                    rb(Es(100)),
                                                    Qs(A3(bi, Es(100), 1, As(41)))
                                                ]))
                                            ]), d(h([
                                                A5(fU, rU, n.ap, n.er, n.o, n.bc),
                                                n.ak ? A2(pU, n.er.cz, n.bf) : n.bf,
                                                A3(aU, IW, n.M, n.er.cz)
                                            ]), e)))
                                        ]),
                                        dF: "Generative Art"
                                    };
                                }(n.k), t = r.dF, e = r.cE;
                                return {
                                    cE: A2(xe, uq(wb), e),
                                    dF: t
                                };
                            }(n.k));
                        case 1:
                            return A2(oq, fl, function(n) {
                                return {
                                    cE: A2(xe, iq, d(h([
                                        A4(cU, GW, 1, yV, n.bs),
                                        A3(Fs, "div", h([
                                            Jo(_W)
                                        ]), A2(Nt, A2(qV, n.be, n.ap), n.x))
                                    ]), A2(hV, n.ap, n.x))),
                                    dF: "Generative Art"
                                };
                            }(n.x));
                        case 2:
                            return A2(oq, eu, function(n) {
                                var r = n.b0 ? h([
                                    UV(n.er.dy)
                                ]) : l;
                                return {
                                    cE: h([
                                        iq(A2(zs, h([
                                            Jo(h([
                                                rb(Es(100)),
                                                Qs(Es(100)),
                                                js(Ps)
                                            ])),
                                            Uq(1)
                                        ]), A2(yt, A3(Ts, Dt("WelcomeVideo"), !1, n.er), r)))
                                    ]),
                                    dF: "Welcome to Genart"
                                };
                            }(n.a4));
                        case 3:
                            return A2(oq, sl, function(n) {
                                return {
                                    cE: h([
                                        iq(A4(cU, GW, 3, MV, n.bs)),
                                        iq(A2(zs, h([
                                            Jo(h([
                                                rb(Es(100)),
                                                Qs(Es(100)),
                                                js(Ps)
                                            ]))
                                        ]), h([
                                            A4(cU, Ts, Dt("WritingVideo"), !1, n.er),
                                            A3(aU, PV, n.bC, n.er.cz)
                                        ])))
                                    ]),
                                    dF: "Writing to Genart"
                                };
                            }(n.a6));
                        default:
                            return A2(oq, ol, function(n) {
                                var r = n.b0 ? h([
                                    _q(n.er.dy)
                                ]) : l;
                                return {
                                    cE: h([
                                        iq(A2(zs, h([
                                            Jo(h([
                                                rb(Es(100)),
                                                Qs(Es(100)),
                                                js(Ps)
                                            ]))
                                        ]), A2(yt, A3(Ts, Dt("WelcomeVideo"), !1, n.er), r)))
                                    ]),
                                    dF: "Developer playground"
                                };
                            }(n.aL));
                    }
                }
            }).eP, Gv = Ev.eQ, Cv = function() {
                Cv.a(Av(nt()));
            }, Cr({
                cm: function(n) {
                    return Cv.a = n, at.addEventListener("popstate", Cv), 0 > at.navigator.userAgent.indexOf("Trident") || at.addEventListener("hashchange", Cv), F2(function(r, t) {
                        if (!(t.ctrlKey || t.metaKey || t.shiftKey || t.button >= 1 || r.target || r.hasAttribute("download"))) {
                            t.preventDefault();
                            var e = r.href, u = nt(), a = Qe(e).a;
                            n(Gv(a && u.eW === a.eW && u.eo === a.eo && u.eV.a === a.eV.a ? {
                                $: 0,
                                a: a
                            } : function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(e)));
                        }
                    });
                },
                et: function(n) {
                    return A3(Ev.et, n, nt(), Cv);
                },
                fc: Ev.fc,
                e8: Ev.e8,
                e3: Ev.e3
            }))(Xl)(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? W(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, Jv) : n.Elm = Jv;
}($75d4fa33b7b16b97$exports);


"use strict";
function $353a8df53265f682$export$ad5582e9e881271f(svgEl, name) {
    svgEl.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    var svgData = svgEl.outerHTML;
    var preface = '<?xml version="1.0" standalone="no"?>\r\n';
    var svgBlob = new Blob([
        preface,
        svgData
    ], {
        type: "image/svg+xml;charset=utf-8"
    });
    var svgUrl = URL.createObjectURL(svgBlob);
    var downloadLink = document.createElement("a");
    downloadLink.href = svgUrl;
    downloadLink.download = name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
}
function $353a8df53265f682$export$af45df6416e679bd(svgElement, filename) {
    var canvas = document.createElement("canvas");
    $353a8df53265f682$var$svgToCanvas(svgElement, canvas, function() {
        $353a8df53265f682$var$downloadCanvas(canvas, filename);
    });
}
/** SVG TO CANVAS - Extracted from http://www.graphicalweb.org/2010/papers/62-From_SVG_to_Canvas_and_Back/#svg_to_canvas */ // TODO Add size parameter to define downloaded image size
//function svgToCanvas(svgOriginalElement, canvasElement, callback, size) {
function $353a8df53265f682$var$svgToCanvas(svgOriginalElement, canvasElement, callback) {
    var logPrefix = "Function svgToCanvas: ";
    if (!svgOriginalElement) {
        console.warn(logPrefix + "No SVG element provided.", svgOriginalElement);
        return;
    }
    if (!canvasElement) {
        console.warn(logPrefix + "No Canvas element provided.", canvasElement);
        return;
    }
    var { svgElement: svgElement, width: width, height: height } = $353a8df53265f682$var$cloneSvgAndFixDimensions(svgOriginalElement);
    // https://developer.mozilla.org/en/XMLSerializer
    var svg_xml = new XMLSerializer().serializeToString(svgElement);
    // This is just a JavaScript (HTML) image.
    var img = new Image();
    // http://en.wikipedia.org/wiki/SVG#Native_support
    // https://developer.mozilla.org/en/DOM/window.btoa
    img.src = "data:image/svg+xml;base64," + btoa(svg_xml);
    var ctx = canvasElement.getContext("2d");
    // TODO test if this will always work (using boundingClientRect).
    ctx.canvas.width = width;
    ctx.canvas.height = height;
    img.onload = function() {
        // After this, Canvas’ origin-clean is DIRTY!
        ctx.drawImage(img, 0, 0);
        !!callback && callback();
    };
}
/** SET CANVAS - Extracted from https://github.com/ericdrowell/concrete/blob/master/src/concrete.js */ function $353a8df53265f682$var$downloadCanvas(canvasElement, filename) {
    var logPrefix = "Function downloadCanvas: ";
    if (!canvasElement || !canvasElement.toBlob) {
        console.warn(logPrefix + "Canvas element not supported", canvasElement);
        return;
    }
    var anchor = document.createElement("a");
    anchor.href = canvasElement.toDataURL("image/jpeg", 0.9);
    anchor.download = filename;
    if (document.createEvent) {
        var eventObject = document.createEvent("MouseEvents");
        eventObject.initEvent("click", true, true);
        anchor.dispatchEvent(eventObject);
    } else if (anchor.click) anchor.click();
    else console.warn(logPrefix + 'Download not supported. No "document.createEvent" or "domElement.click" available.');
}
function $353a8df53265f682$var$cloneSvgAndFixDimensions(svgOriginalElement) {
    // TODO test if element is an SVGElement or something in those lines.
    var boundingClientRect = svgOriginalElement.getBoundingClientRect();
    // Cloning so that we don't mess with the original element.
    // We may change the width and height.
    var deepClone = true;
    var svgElement = svgOriginalElement.cloneNode(deepClone);
    /**
   * Setting "absolute" size to SVG, since relative sizes (like percentage)
   * doesn't work with Firefox.
   *
   *
   * Detour: SVG Lenght geekout
   *
   * Possible CSS2 units are defined here:
   * https://www.w3.org/TR/WD-CSS2/syndata.html#length-units
   *
   * Units constants for SVGLength interface here:
   * https://www.w3.org/TR/SVG11/types.html#InterfaceSVGLength
   *
   * With almost all length types the the browser can reason about
   * the image when we insert into a canvas, but not with these:
   *
   * SVGLength.SVG_LENGTHTYPE_UNKNOWN
   * SVGLength.SVG_LENGTHTYPE_PERCENTAGE
   *
   * And then, we should replace with the given (or default) fixed size
   *
   */ try {
        var widthUnitType = svgElement.width.baseVal.unitType;
        if (widthUnitType === SVGLength.SVG_LENGTHTYPE_UNKNOWN || widthUnitType === SVGLength.SVG_LENGTHTYPE_PERCENTAGE) svgElement.setAttribute("width", svgBoundingBoxSize.width);
        var heightUnitType = svgElement.height.baseVal.unitType;
        if (heightUnitType === SVGLength.SVG_LENGTHTYPE_UNKNOWN || heightUnitType === SVGLength.SVG_LENGTHTYPE_PERCENTAGE) svgElement.setAttribute("height", svgBoundingBoxSize.height);
    } catch (e) {
        //console.warn(logPrefix + "This browser doesn't have support for the SVGLength interface", e);
        /**
     * Test if height is set in percentage (e.g. "80%"); if so then change to absolute
     * boundingClientRect height.
     *
     * It's possible to use this test only (instead of the method above) but it's VERY
     * informative the other method and more involved in Web standards, something I
     * think every developer should know more about. That's the reason we keep it there.
     */ var regexPercentageValue = RegExp("^([0-9]+|[0-9]*\\.[0-9]+)%$");
        if (!svgElement.attributes.width || regexPercentageValue.test(svgElement.attributes.width.value)) svgElement.setAttribute("width", boundingClientRect.width);
        if (!svgElement.attributes.height || regexPercentageValue.test(svgElement.attributes.height.value)) svgElement.setAttribute("height", boundingClientRect.height);
    }
    return {
        svgElement: svgElement,
        width: boundingClientRect.width,
        height: boundingClientRect.height
    };
}


"use strict";
/**
 * STORAGE
 */ var $35da740d59af89ba$var$storageKey = "genart";
var $35da740d59af89ba$var$encodedStorage = localStorage.getItem($35da740d59af89ba$var$storageKey);
var $35da740d59af89ba$var$storage;
try {
    $35da740d59af89ba$var$storage = JSON.parse($35da740d59af89ba$var$encodedStorage);
    // Update storage schema if needed
    if ($35da740d59af89ba$var$storage.image) $35da740d59af89ba$var$storage.editor = $35da740d59af89ba$var$storage.image;
} catch (e) {
    console.log("GENART: Error while parsing localStorage[" + $35da740d59af89ba$var$storageKey + "] = " + $35da740d59af89ba$var$encodedStorage, e);
}
/**
 * INIT
 */ var $35da740d59af89ba$var$elmApp = (0, $75d4fa33b7b16b97$exports.Elm).Main.init({
    node: document.getElementById("elm"),
    flags: $35da740d59af89ba$var$storage || {}
});
/**
 * PORTS
 */ // TODO change to `saveToLocalStorage(key, value)`
$35da740d59af89ba$var$elmApp.ports.saveModelToLocalStorage.subscribe(function(encodedModel) {
    localStorage.setItem($35da740d59af89ba$var$storageKey, JSON.stringify(encodedModel));
});
$35da740d59af89ba$var$elmApp.ports.downloadSvg.subscribe(function() {
    //saveSvg(document.getElementById("MainSVG"), "hybridcode.svg");
    (0, $353a8df53265f682$export$ad5582e9e881271f)(document.getElementById("MainSVG"), "genart.svg");
});
$35da740d59af89ba$var$elmApp.ports.downloadSvgAsJpeg.subscribe(function() {
    var svgElement = document.getElementById("MainSVG");
    (0, $353a8df53265f682$export$af45df6416e679bd)(svgElement, "genart.jpeg");
});
$35da740d59af89ba$var$elmApp.ports.requestFullscreen.subscribe(function() {
    var mainImage = document.getElementById("MainImgKeyedWrapper");
    mainImage.requestFullscreen();
});
$35da740d59af89ba$var$elmApp.ports.copyTextToClipboard.subscribe(function(textToCopy) {
    if (!navigator.clipboard) // TODO Fallback. Do we really want a fallback??
    return;
    navigator.clipboard.writeText(textToCopy).then(()=>{
        // Success
        $35da740d59af89ba$var$elmApp.ports.copyToClipboardResult.send(true);
        console.log("Successfully copied shareable URL into clipboard!");
    }, (err)=>{
        // Error
        $35da740d59af89ba$var$elmApp.ports.copyToClipboardResult.send(false);
        console.error("GENART: couldn't copy into clipboard", err);
    });
});
/**
 * Hackery to prevent going back in history with `backspace` press.
 */ var $35da740d59af89ba$var$turnAngleInput;
var $35da740d59af89ba$var$writingInput;
document.onkeydown = (e)=>{
    if (!$35da740d59af89ba$var$turnAngleInput) $35da740d59af89ba$var$turnAngleInput = document.getElementById("TurnAngle");
    if (!$35da740d59af89ba$var$writingInput) $35da740d59af89ba$var$writingInput = document.getElementById("WritingInput");
    if (e.key === "Backspace" && document.activeElement !== $35da740d59af89ba$var$turnAngleInput && document.activeElement !== $35da740d59af89ba$var$writingInput) e.preventDefault();
};
/**
 * MIDI INTEROP (*not* Firefox friendly)
 *
 * https://webaudio.github.io/web-midi-api/
 */ var $35da740d59af89ba$var$midiOptions = {
    sysex: true,
    software: false
};
const $35da740d59af89ba$var$DISABLED = true;
if ($35da740d59af89ba$var$DISABLED && navigator.requestMIDIAccess) navigator.requestMIDIAccess($35da740d59af89ba$var$midiOptions).then($35da740d59af89ba$var$onMIDISuccess, $35da740d59af89ba$var$onMIDIFailure);
//console.log("Currently only MINILAB MK2 is supported for MIDI input and control.");
function $35da740d59af89ba$var$onMIDISuccess(midiAccess) {
    console.log("MIDI Access Granted: midiAccess obj =", midiAccess);
    for (var input of midiAccess.inputs.values())input.onmidimessage = $35da740d59af89ba$var$getMIDIMessage;
    var firstOutput = midiAccess.outputs.values().next().value;
    for(var i = 0; i < 16; i++)firstOutput.send($35da740d59af89ba$var$setPadColor(i, $35da740d59af89ba$var$PAD_COLORS[i]));
}
function $35da740d59af89ba$var$getMIDIMessage(midiMessage) {
    console.log(midiMessage.data);
    $35da740d59af89ba$var$elmApp.ports.midiEvent.send(midiMessage);
}
function $35da740d59af89ba$var$onMIDIFailure() {
    console.log("Could not access your MIDI devices.");
}
// Set single pad color via SysEx.
function $35da740d59af89ba$var$setPadColor(pad, color) {
    let padHex = 112 + pad; //.toString(16);
    return new Uint8Array([
        0xf0,
        0x00,
        0x20,
        0x6b,
        0x7f,
        0x42,
        0x02,
        0x00,
        0x10,
        padHex,
        color,
        0xf7
    ]);
}
/**
 * Constants from https://github.com/chrenn/minilab-mk2-bitwig/blob/master/minilab-mk2.control.js
 *
 * Originally (and probably) from
 * https://www.untergeek.de/2014/11/taming-arturias-beatstep-sysex-codes-for-programming-via-ipad/
 *
 * More stuff
 * https://answers.bitwig.com/questions/16952/arturia-minilab-mk2-script-need-some-help
 *
 *
 * Other configs present in `minilab-mk2.control.js`
 * host.defineController("Arturia", "MiniLab Mk II", "1.0", "2fdbbb1f-f771-43f7-83e8-bc01c3e573de", "bequadro");
 * khost.defineMidiPorts(1, 1);
 * host.addDeviceNameBasedDiscoveryPair(["Arturia MiniLab mkII"], ["Arturia MiniLab mkII"]);
 */ const $35da740d59af89ba$var$MIDI_STATUS_PAD_ON = 153;
const $35da740d59af89ba$var$MIDI_STATUS_PAD_OFF = 137;
const $35da740d59af89ba$var$MIDI_STATUS_KNOBS = 176;
const $35da740d59af89ba$var$MIDI_DATA1_PAD_OFFSET = 36;
// Knobs mapping (MIDI data1).
const $35da740d59af89ba$var$KNOB1 = 112;
const $35da740d59af89ba$var$KNOB1_CLICK = 113;
const $35da740d59af89ba$var$KNOB9 = 114;
const $35da740d59af89ba$var$KNOB9_CLICK = 115;
const $35da740d59af89ba$var$KNOBS_LEFT_ = [
    74,
    71,
    76,
    18,
    19,
    16
];
const $35da740d59af89ba$var$KNOBS_RIGHT = [
    77,
    93,
    73,
    75,
    17,
    91,
    79,
    72
];
const $35da740d59af89ba$var$COLOR = {
    BLACK: 0x00,
    RED: 0x01,
    BLUE: 0x10,
    GREEN: 0x04,
    CYAN: 0x14,
    PURPLE: 0x11,
    YELLOW: 0x05,
    WHITE: 0x7f
};
const $35da740d59af89ba$var$PAD_COLORS = [
    // Video Controls
    $35da740d59af89ba$var$COLOR.WHITE,
    $35da740d59af89ba$var$COLOR.WHITE,
    // HSL
    $35da740d59af89ba$var$COLOR.YELLOW,
    $35da740d59af89ba$var$COLOR.YELLOW,
    $35da740d59af89ba$var$COLOR.YELLOW,
    // RGB
    $35da740d59af89ba$var$COLOR.RED,
    $35da740d59af89ba$var$COLOR.GREEN,
    $35da740d59af89ba$var$COLOR.BLUE,
    // OTHER
    $35da740d59af89ba$var$COLOR.BLACK,
    $35da740d59af89ba$var$COLOR.RED,
    $35da740d59af89ba$var$COLOR.GREEN,
    $35da740d59af89ba$var$COLOR.YELLOW,
    $35da740d59af89ba$var$COLOR.BLUE,
    $35da740d59af89ba$var$COLOR.PURPLE,
    $35da740d59af89ba$var$COLOR.CYAN,
    $35da740d59af89ba$var$COLOR.WHITE
]; /**
 * SET LOOCAL STORAGE
 *

var storageKeys =
    { v2: 'genart/v0.2/state'
    , latest: 'genart/v0.3/state'
    };

function none() {
    localStorage.removeItem(storageKeys.v2);
    localStorage.removeItem(storageKeys.latest);
}

function v2() {
    localStorage.setItem(
        storageKeys.v2,
        "{\"state\":[\"LLDRDRDLDLD\"],\"gallery\":[{\"composition\":[\"LLDRDRDLDLD\",\"LLDRDRDLDLD\"],\"turnAngle\":90,\"bgColor\":\"#666666\",\"strokeColor\":\"#00b46e\"}],\"bgColor\":\"#333333\",\"strokeColor\":\"#00b46e\",\"turnAngle\":90,\"scale\":1,\"translateX\":0,\"translateY\":0}"
    );
}

function v3() {
    localStorage.setItem(
        storageKeys.latest,
        "{\"image\":{\"composition\":[\"DLDLDRRDLDLD\",\"D\"],\"turnAngle\":90,\"backgroundColor\":\"#333333\",\"strokeColor\":\"#00b46e\",\"translateX\":-108.83347826086958,\"translateY\":-338.8206521739131,\"scale\":0.3699999999999997},\"gallery\":[{\"composition\":[\"DLDLDRRDLDLD\",\"DLDLDRRDLDLD\"],\"turnAngle\":90,\"backgroundColor\":\"#333333\",\"strokeColor\":\"#26b460\",\"translateX\":46.26324691231233,\"translateY\":-65.65293135386595,\"scale\":0.1}]}"
    );
}

function rubbish() {
  localStorage.setItem(storageKeys.v2, "a");
  localStorage.setItem(storageKeys.latest, "a");
}

none();
v2();
v3();
rubbish();


 *
 *
 */ 


//# sourceMappingURL=index.16159c44.js.map
